var $4vY0V$reactariainteractions = require("@react-aria/interactions");
var $4vY0V$react = require("react");
var $4vY0V$reactariautils = require("@react-aria/utils");
var $4vY0V$reactariai18n = require("@react-aria/i18n");
var $4vY0V$reactarialiveannouncer = require("@react-aria/live-announcer");
var $4vY0V$reactariaoverlays = require("@react-aria/overlays");
var $4vY0V$reactdom = require("react-dom");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "DIRECTORY_DRAG_TYPE", () => $4620ae0dc40f0031$export$990fced5dfac2637);
$parcel$export(module.exports, "useDrag", () => $dc204e8ec58447a6$export$7941f8aafa4b6021);
$parcel$export(module.exports, "useDrop", () => $1ca228bc9257ca16$export$ccdee5eaf73cf661);
$parcel$export(module.exports, "useDroppableCollection", () => $7f93a158ac20b90a$export$f4e2f423c21f7b04);
$parcel$export(module.exports, "useDroppableItem", () => $fc1876157e07bcec$export$f7b0c5d28b66b6a5);
$parcel$export(module.exports, "useDropIndicator", () => $c5557edbed563ebf$export$8d0e41d2815afac5);
$parcel$export(module.exports, "useDraggableItem", () => $0cbbd00cda972c67$export$b35afafff42da2d9);
$parcel$export(module.exports, "useDraggableCollection", () => $c3e901bab7fcc6ff$export$2962a7984b2f0a80);
$parcel$export(module.exports, "useClipboard", () => $74f3dedaa4d234b4$export$2314ca2a3e892862);
$parcel$export(module.exports, "DragPreview", () => $2dccaca1f4baa446$export$905ab40ac2179daa);
$parcel$export(module.exports, "ListDropTargetDelegate", () => $2268795bbb597ecb$export$fbd65d14c79e28cc);
$parcel$export(module.exports, "isVirtualDragging", () => $28e10663603f5ea1$export$403bc76cbf68cf60);
$parcel$export(module.exports, "isDirectoryDropItem", () => $4620ae0dc40f0031$export$2b40a62bdbe6b2b0);
$parcel$export(module.exports, "isFileDropItem", () => $4620ae0dc40f0031$export$a144e1752ebe0aa);
$parcel$export(module.exports, "isTextDropItem", () => $4620ae0dc40f0031$export$97fd558bdc44bea1);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */ /*
       * Copyright 2020 Adobe. All rights reserved.
       * This file is licensed to you under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License. You may obtain a copy
       * of the License at http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software distributed under
       * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
       * OF ANY KIND, either express or implied. See the License for the specific language
       * governing permissions and limitations under the License.
       */
var $76b1e110a27b1ccd$export$60b7b4bcf3903d8e;
(function (DROP_OPERATION) {
  DROP_OPERATION[DROP_OPERATION["none"] = 0] = "none";
  DROP_OPERATION[DROP_OPERATION["cancel"] = 0] = "cancel";
  DROP_OPERATION[DROP_OPERATION["move"] = 1] = "move";
  DROP_OPERATION[DROP_OPERATION["copy"] = 2] = "copy";
  DROP_OPERATION[DROP_OPERATION["link"] = 4] = "link";
  DROP_OPERATION[DROP_OPERATION["all"] = 7] = "all";
})($76b1e110a27b1ccd$export$60b7b4bcf3903d8e || ($76b1e110a27b1ccd$export$60b7b4bcf3903d8e = {}));
const $76b1e110a27b1ccd$export$9bbdfc78cf083e16 = {
  ...$76b1e110a27b1ccd$export$60b7b4bcf3903d8e,
  copyMove: $76b1e110a27b1ccd$export$60b7b4bcf3903d8e.copy | $76b1e110a27b1ccd$export$60b7b4bcf3903d8e.move,
  copyLink: $76b1e110a27b1ccd$export$60b7b4bcf3903d8e.copy | $76b1e110a27b1ccd$export$60b7b4bcf3903d8e.link,
  linkMove: $76b1e110a27b1ccd$export$60b7b4bcf3903d8e.link | $76b1e110a27b1ccd$export$60b7b4bcf3903d8e.move,
  all: $76b1e110a27b1ccd$export$60b7b4bcf3903d8e.all,
  uninitialized: $76b1e110a27b1ccd$export$60b7b4bcf3903d8e.all
};
const $76b1e110a27b1ccd$export$dd0165308d8bff45 = $76b1e110a27b1ccd$var$invert($76b1e110a27b1ccd$export$9bbdfc78cf083e16);
$76b1e110a27b1ccd$export$dd0165308d8bff45[$76b1e110a27b1ccd$export$60b7b4bcf3903d8e.all] = "all"; // ensure we don't map to 'uninitialized'.
const $76b1e110a27b1ccd$export$d7ebf00f36b7a95e = $76b1e110a27b1ccd$var$invert($76b1e110a27b1ccd$export$60b7b4bcf3903d8e);
const $76b1e110a27b1ccd$export$608ecc6f1b23c35d = {
  none: "cancel",
  link: "link",
  copy: "copy",
  move: "move"
};
const $76b1e110a27b1ccd$export$5eacb0769d26d3b2 = $76b1e110a27b1ccd$var$invert($76b1e110a27b1ccd$export$608ecc6f1b23c35d);
function $76b1e110a27b1ccd$var$invert(object) {
  let res = {};
  for (let key in object) res[object[key]] = key;
  return res;
}
const $76b1e110a27b1ccd$export$4a7729b856e9a690 = new Set(["text/plain", "text/uri-list", "text/html"]);
const $76b1e110a27b1ccd$export$fd9f9fc120c5402d = "application/vnd.react-aria.items+json";
const $76b1e110a27b1ccd$export$f8fc6581787339b3 = "application/octet-stream";
const $4620ae0dc40f0031$export$dfdf5deeaf27473f = new WeakMap();
const $4620ae0dc40f0031$export$990fced5dfac2637 = Symbol();
function $4620ae0dc40f0031$export$3093291712f09a77(state) {
  let {
    id: id
  } = $4620ae0dc40f0031$export$dfdf5deeaf27473f.get(state);
  if (!id) throw new Error("Droppable item outside a droppable collection");
  return id;
}
function $4620ae0dc40f0031$export$7e397efd01d3db27(state) {
  let {
    ref: ref
  } = $4620ae0dc40f0031$export$dfdf5deeaf27473f.get(state);
  if (!ref) throw new Error("Droppable item outside a droppable collection");
  return ref;
}
function $4620ae0dc40f0031$export$e1d41611756c6326(items) {
  let types = new Set();
  for (let item of items) for (let type of Object.keys(item)) types.add(type);
  return types;
}
function $4620ae0dc40f0031$var$mapModality(modality) {
  if (!modality) modality = "virtual";
  if (modality === "pointer") modality = "virtual";
  if (modality === "virtual" && typeof window !== "undefined" && "ontouchstart" in window) modality = "touch";
  return modality;
}
function $4620ae0dc40f0031$export$49bac5d6d4b352ea() {
  return $4620ae0dc40f0031$var$mapModality((0, $4vY0V$reactariainteractions.useInteractionModality)());
}
function $4620ae0dc40f0031$export$1fb2158d224b542c() {
  return $4620ae0dc40f0031$var$mapModality((0, $4vY0V$reactariainteractions.getInteractionModality)());
}
function $4620ae0dc40f0031$export$f9c1490890ddd063(dataTransfer, items) {
  // The data transfer API doesn't support more than one item of a given type at once.
  // In addition, only a small set of types are supported natively for transfer between applications.
  // We allow for both multiple items, as well as multiple representations of a single item.
  // In order to make our API work with the native API, we serialize all items to JSON and
  // store as a single native item. We only need to do this if there is more than one item
  // of the same type, or if an item has more than one representation. Otherwise the native
  // API is sufficient.
  //
  // The DataTransferItemList API also theoretically supports adding files, which would enable
  // dragging binary data out of the browser onto the user's desktop for example. Unfortunately,
  // this does not currently work in any browser, so it is not currently supported by our API.
  // See e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=438479.
  let groupedByType = new Map();
  let needsCustomData = false;
  let customData = [];
  for (let item of items) {
    let types = Object.keys(item);
    if (types.length > 1) needsCustomData = true;
    let dataByType = {};
    for (let type of types) {
      let typeItems = groupedByType.get(type);
      if (!typeItems) {
        typeItems = [];
        groupedByType.set(type, typeItems);
      } else needsCustomData = true;
      let data = item[type];
      dataByType[type] = data;
      typeItems.push(data);
    }
    customData.push(dataByType);
  }
  for (let [type, items] of groupedByType) if ((0, $76b1e110a27b1ccd$export$4a7729b856e9a690).has(type)) {
    // Only one item of a given type can be set on a data transfer.
    // Join all of the items together separated by newlines.
    let data = items.join("\n");
    dataTransfer.items.add(data, type);
  } else
    // Set data to the first item so we have access to the list of types.
    dataTransfer.items.add(items[0], type);
  if (needsCustomData) {
    let data = JSON.stringify(customData);
    dataTransfer.items.add(data, (0, $76b1e110a27b1ccd$export$fd9f9fc120c5402d));
  }
}
class $4620ae0dc40f0031$export$7f04ce188c91447c {
  has(type) {
    if (this.includesUnknownTypes || type === $4620ae0dc40f0031$export$990fced5dfac2637 && this.types.has((0, $76b1e110a27b1ccd$export$f8fc6581787339b3))) return true;
    return typeof type === "string" && this.types.has(type);
  }
  constructor(dataTransfer) {
    this.types = new Set();
    let hasFiles = false;
    for (let item of dataTransfer.items) if (item.type !== (0, $76b1e110a27b1ccd$export$fd9f9fc120c5402d)) {
      if (item.kind === "file") hasFiles = true;
      if (item.type) this.types.add(item.type);else
        // Files with unknown types or extensions that don't map to a known mime type
        // are sometimes exposed as an empty string by the browser. Map to a generic
        // mime type instead. Note that this could also be a directory as there's no
        // way to determine if something is a file or directory until drop.
        this.types.add((0, $76b1e110a27b1ccd$export$f8fc6581787339b3));
    }
    // In Safari, when dragging files, the dataTransfer.items list is empty, but dataTransfer.types contains "Files".
    // Unfortunately, this doesn't tell us what types of files the user is dragging, so we need to assume that any
    // type the user checks for is included. See https://bugs.webkit.org/show_bug.cgi?id=223517.
    this.includesUnknownTypes = !hasFiles && dataTransfer.types.includes("Files");
  }
}
function $4620ae0dc40f0031$export$d9e760437831f8b3(dataTransfer) {
  let items = [];
  // If our custom drag type is available, use that. This is a JSON serialized
  // representation of all items in the drag, set when there are multiple items
  // of the same type, or an individual item has multiple representations.
  let hasCustomType = false;
  if (dataTransfer.types.includes((0, $76b1e110a27b1ccd$export$fd9f9fc120c5402d))) try {
    let data = dataTransfer.getData((0, $76b1e110a27b1ccd$export$fd9f9fc120c5402d));
    let parsed = JSON.parse(data);
    for (let item of parsed) items.push({
      kind: "text",
      types: new Set(Object.keys(item)),
      getText: type => Promise.resolve(item[type])
    });
    hasCustomType = true;
  } catch (e) {
    // ignore
  }
  // Otherwise, map native drag items to items of a single representation.
  if (!hasCustomType) {
    let stringItems = new Map();
    for (let item of dataTransfer.items) {
      if (item.kind === "string")
        // The data for all formats must be read here because the data transfer gets
        // cleared out after the event handler finishes. If the item has an empty string
        // as a type, the mime type is unknown. Map to a generic mime type instead.
        stringItems.set(item.type || (0, $76b1e110a27b1ccd$export$f8fc6581787339b3), dataTransfer.getData(item.type));else if (item.kind === "file") {
        // Despite the name, webkitGetAsEntry is also implemented in Firefox and Edge.
        // In the future, we may use getAsFileSystemHandle instead, but that's currently
        // only implemented in Chrome.
        if (typeof item.webkitGetAsEntry === "function") {
          let entry = item.webkitGetAsEntry();
          // eslint-disable-next-line max-depth
          if (!entry) continue;
          // eslint-disable-next-line max-depth
          if (entry.isFile) items.push($4620ae0dc40f0031$var$createFileItem(item.getAsFile()));else if (entry.isDirectory) items.push($4620ae0dc40f0031$var$createDirectoryItem(entry));
        } else
          // Assume it's a file.
          items.push($4620ae0dc40f0031$var$createFileItem(item.getAsFile()));
      }
    }
    // All string items are different representations of the same item. There's no way to have
    // multiple string items at once in the current DataTransfer API.
    if (stringItems.size > 0) items.push({
      kind: "text",
      types: new Set(stringItems.keys()),
      getText: type => Promise.resolve(stringItems.get(type))
    });
  }
  return items;
}
function $4620ae0dc40f0031$var$blobToString(blob) {
  if (typeof blob.text === "function") return blob.text();
  // Safari doesn't have the Blob#text() method yet...
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsText(blob);
  });
}
function $4620ae0dc40f0031$var$createFileItem(file) {
  return {
    kind: "file",
    type: file.type || (0, $76b1e110a27b1ccd$export$f8fc6581787339b3),
    name: file.name,
    getText: () => $4620ae0dc40f0031$var$blobToString(file),
    getFile: () => Promise.resolve(file)
  };
}
function $4620ae0dc40f0031$var$createDirectoryItem(entry) {
  return {
    kind: "directory",
    name: entry.name,
    getEntries: () => $4620ae0dc40f0031$var$getEntries(entry)
  };
}
async function* $4620ae0dc40f0031$var$getEntries(item) {
  let reader = item.createReader();
  // We must call readEntries repeatedly because there may be a limit to the
  // number of entries that are returned at once.
  let entries;
  do {
    entries = await new Promise((resolve, reject) => {
      reader.readEntries(resolve, reject);
    });
    for (let entry of entries) {
      if (entry.isFile) {
        let file = await $4620ae0dc40f0031$var$getEntryFile(entry);
        yield $4620ae0dc40f0031$var$createFileItem(file);
      } else if (entry.isDirectory) yield $4620ae0dc40f0031$var$createDirectoryItem(entry);
    }
  } while (entries.length > 0);
}
function $4620ae0dc40f0031$var$getEntryFile(entry) {
  return new Promise((resolve, reject) => entry.file(resolve, reject));
}
function $4620ae0dc40f0031$export$97fd558bdc44bea1(dropItem) {
  return dropItem.kind === "text";
}
function $4620ae0dc40f0031$export$a144e1752ebe0aa(dropItem) {
  return dropItem.kind === "file";
}
function $4620ae0dc40f0031$export$2b40a62bdbe6b2b0(dropItem) {
  return dropItem.kind === "directory";
}
let $4620ae0dc40f0031$export$6ca6700462636d0b = {
  draggingKeys: new Set()
};
function $4620ae0dc40f0031$export$f2be18a910c0caa6(ref) {
  $4620ae0dc40f0031$export$6ca6700462636d0b.draggingCollectionRef = ref;
}
function $4620ae0dc40f0031$export$72cb63bdda528276(keys) {
  $4620ae0dc40f0031$export$6ca6700462636d0b.draggingKeys = keys;
}
function $4620ae0dc40f0031$export$dac8db29d42db9a1(ref) {
  $4620ae0dc40f0031$export$6ca6700462636d0b.dropCollectionRef = ref;
}
function $4620ae0dc40f0031$export$70936501603e6c57() {
  $4620ae0dc40f0031$export$6ca6700462636d0b = {
    draggingKeys: new Set()
  };
}
function $4620ae0dc40f0031$export$6c10d32b362bfa5f(state) {
  $4620ae0dc40f0031$export$6ca6700462636d0b = state;
}
function $4620ae0dc40f0031$export$78bf638634500fa5(ref) {
  let {
    draggingCollectionRef: draggingCollectionRef,
    dropCollectionRef: dropCollectionRef
  } = $4620ae0dc40f0031$export$6ca6700462636d0b;
  return (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) != null && draggingCollectionRef.current === ((ref === null || ref === void 0 ? void 0 : ref.current) || (dropCollectionRef === null || dropCollectionRef === void 0 ? void 0 : dropCollectionRef.current));
}
let $4620ae0dc40f0031$export$8e6636520ac15722;
function $4620ae0dc40f0031$export$64f52ed7349ddb84(dropEffect) {
  $4620ae0dc40f0031$export$8e6636520ac15722 = dropEffect;
}
let $4620ae0dc40f0031$export$f0130eb70b6347b8 = (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).none;
function $4620ae0dc40f0031$export$6539bc8c3a0a2d67(o) {
  $4620ae0dc40f0031$export$f0130eb70b6347b8 = o;
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

let $28e10663603f5ea1$var$dropTargets = new Map();
let $28e10663603f5ea1$var$dropItems = new Map();
let $28e10663603f5ea1$var$dragSession = null;
let $28e10663603f5ea1$var$subscriptions = new Set();
function $28e10663603f5ea1$export$c28d9fb4a54e471a(target) {
  $28e10663603f5ea1$var$dropTargets.set(target.element, target);
  $28e10663603f5ea1$var$dragSession === null || $28e10663603f5ea1$var$dragSession === void 0 ? void 0 : $28e10663603f5ea1$var$dragSession.updateValidDropTargets();
  return () => {
    $28e10663603f5ea1$var$dropTargets.delete(target.element);
    $28e10663603f5ea1$var$dragSession === null || $28e10663603f5ea1$var$dragSession === void 0 ? void 0 : $28e10663603f5ea1$var$dragSession.updateValidDropTargets();
  };
}
function $28e10663603f5ea1$export$aef80212ac99c003(item) {
  $28e10663603f5ea1$var$dropItems.set(item.element, item);
  return () => {
    $28e10663603f5ea1$var$dropItems.delete(item.element);
  };
}
function $28e10663603f5ea1$export$549dbcf8649bf3b2(target, stringFormatter) {
  if ($28e10663603f5ea1$var$dragSession) throw new Error("Cannot begin dragging while already dragging");
  $28e10663603f5ea1$var$dragSession = new $28e10663603f5ea1$var$DragSession(target, stringFormatter);
  requestAnimationFrame(() => {
    $28e10663603f5ea1$var$dragSession.setup();
    if ((0, $4620ae0dc40f0031$export$1fb2158d224b542c)() === "keyboard") $28e10663603f5ea1$var$dragSession.next();
  });
  for (let cb of $28e10663603f5ea1$var$subscriptions) cb();
}
function $28e10663603f5ea1$export$418e185dd3f1b968() {
  let [session, setSession] = (0, $4vY0V$react.useState)($28e10663603f5ea1$var$dragSession);
  (0, $4vY0V$react.useEffect)(() => {
    let cb = () => setSession($28e10663603f5ea1$var$dragSession);
    $28e10663603f5ea1$var$subscriptions.add(cb);
    return () => {
      $28e10663603f5ea1$var$subscriptions.delete(cb);
    };
  }, []);
  return session;
}
function $28e10663603f5ea1$export$403bc76cbf68cf60() {
  return !!$28e10663603f5ea1$var$dragSession;
}
function $28e10663603f5ea1$var$endDragging() {
  $28e10663603f5ea1$var$dragSession = null;
  for (let cb of $28e10663603f5ea1$var$subscriptions) cb();
}
function $28e10663603f5ea1$export$7454aff2e161f241(element) {
  for (let target of $28e10663603f5ea1$var$dropTargets.keys()) {
    if (target.contains(element)) return true;
  }
  return false;
}
const $28e10663603f5ea1$var$CANCELED_EVENTS = ["pointerdown", "pointermove", "pointerenter", "pointerleave", "pointerover", "pointerout", "pointerup", "mousedown", "mousemove", "mouseenter", "mouseleave", "mouseover", "mouseout", "mouseup", "touchstart", "touchmove", "touchend", "focusin", "focusout"];
const $28e10663603f5ea1$var$CLICK_EVENTS = ["pointerup", "mouseup", "touchend"];
const $28e10663603f5ea1$var$MESSAGES = {
  keyboard: "dragStartedKeyboard",
  touch: "dragStartedTouch",
  virtual: "dragStartedVirtual"
};
class $28e10663603f5ea1$var$DragSession {
  setup() {
    document.addEventListener("keydown", this.onKeyDown, true);
    document.addEventListener("keyup", this.onKeyUp, true);
    window.addEventListener("focus", this.onFocus, true);
    window.addEventListener("blur", this.onBlur, true);
    document.addEventListener("click", this.onClick, true);
    document.addEventListener("pointerdown", this.onPointerDown, true);
    for (let event of $28e10663603f5ea1$var$CANCELED_EVENTS) document.addEventListener(event, this.cancelEvent, true);
    this.mutationObserver = new MutationObserver(() => this.updateValidDropTargets());
    this.updateValidDropTargets();
    (0, $4vY0V$reactarialiveannouncer.announce)(this.stringFormatter.format($28e10663603f5ea1$var$MESSAGES[(0, $4620ae0dc40f0031$export$1fb2158d224b542c)()]));
  }
  teardown() {
    document.removeEventListener("keydown", this.onKeyDown, true);
    document.removeEventListener("keyup", this.onKeyUp, true);
    window.removeEventListener("focus", this.onFocus, true);
    window.removeEventListener("blur", this.onBlur, true);
    document.removeEventListener("click", this.onClick, true);
    document.removeEventListener("pointerdown", this.onPointerDown, true);
    for (let event of $28e10663603f5ea1$var$CANCELED_EVENTS) document.removeEventListener(event, this.cancelEvent, true);
    this.mutationObserver.disconnect();
    this.restoreAriaHidden();
  }
  onKeyDown(e) {
    var _this_currentDropTarget;
    this.cancelEvent(e);
    if (e.key === "Escape") {
      this.cancel();
      return;
    }
    if (e.key === "Tab" && !(e.metaKey || e.altKey || e.ctrlKey)) {
      if (e.shiftKey) this.previous();else this.next();
    }
    if (typeof ((_this_currentDropTarget = this.currentDropTarget) === null || _this_currentDropTarget === void 0 ? void 0 : _this_currentDropTarget.onKeyDown) === "function") this.currentDropTarget.onKeyDown(e, this.dragTarget);
  }
  onKeyUp(e) {
    this.cancelEvent(e);
    if (e.key === "Enter") {
      if (e.altKey) this.activate();else this.drop();
    }
  }
  onFocus(e) {
    // Prevent focus events, except to the original drag target.
    if (e.target !== this.dragTarget.element) this.cancelEvent(e);
    // Ignore focus events on the window/document (JSDOM). Will be handled in onBlur, below.
    if (!(e.target instanceof HTMLElement) || e.target === this.dragTarget.element) return;
    let dropTarget = this.validDropTargets.find(target => target.element === e.target) || this.validDropTargets.find(target => target.element.contains(e.target));
    if (!dropTarget) {
      if (this.currentDropTarget) this.currentDropTarget.element.focus();else this.dragTarget.element.focus();
      return;
    }
    let item = $28e10663603f5ea1$var$dropItems.get(e.target);
    this.setCurrentDropTarget(dropTarget, item);
  }
  onBlur(e) {
    if (e.target !== this.dragTarget.element) this.cancelEvent(e);
    // If nothing is gaining focus, or e.relatedTarget is the window/document (JSDOM),
    // restore focus back to the current drop target if any, or the original drag target.
    if (!e.relatedTarget || !(e.relatedTarget instanceof HTMLElement)) {
      if (this.currentDropTarget) this.currentDropTarget.element.focus();else this.dragTarget.element.focus();
    }
  }
  onClick(e) {
    this.cancelEvent(e);
    if ((0, $4vY0V$reactariautils.isVirtualClick)(e) || this.isVirtualClick) {
      if (e.target === this.dragTarget.element) {
        this.cancel();
        return;
      }
      let dropTarget = this.validDropTargets.find(target => target.element.contains(e.target));
      if (dropTarget) {
        let item = $28e10663603f5ea1$var$dropItems.get(e.target);
        this.setCurrentDropTarget(dropTarget, item);
        this.drop(item);
      }
    }
  }
  onPointerDown(e) {
    // Android Talkback double tap has e.detail = 1 for onClick. Detect the virtual click in onPointerDown before onClick fires
    // so we can properly perform cancel and drop operations.
    this.cancelEvent(e);
    this.isVirtualClick = (0, $4vY0V$reactariautils.isVirtualPointerEvent)(e);
  }
  cancelEvent(e) {
    var _this_dragTarget;
    // Allow focusin and focusout on the drag target so focus ring works properly.
    if ((e.type === "focusin" || e.type === "focusout") && e.target === ((_this_dragTarget = this.dragTarget) === null || _this_dragTarget === void 0 ? void 0 : _this_dragTarget.element)) return;
    // Allow default for events that might cancel a click event
    if (!$28e10663603f5ea1$var$CLICK_EVENTS.includes(e.type)) e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
  updateValidDropTargets() {
    if (!this.mutationObserver) return;
    this.mutationObserver.disconnect();
    if (this.restoreAriaHidden) this.restoreAriaHidden();
    this.validDropTargets = $28e10663603f5ea1$var$findValidDropTargets(this.dragTarget);
    // Shuffle drop target order based on starting drag target.
    if (this.validDropTargets.length > 0) {
      let nearestIndex = this.findNearestDropTarget();
      this.validDropTargets = [...this.validDropTargets.slice(nearestIndex), ...this.validDropTargets.slice(0, nearestIndex)];
    }
    if (this.currentDropTarget && !this.validDropTargets.includes(this.currentDropTarget)) this.setCurrentDropTarget(this.validDropTargets[0]);
    // Find valid drop items within collections
    let types = (0, $4620ae0dc40f0031$export$e1d41611756c6326)(this.dragTarget.items);
    let validDropItems = [...$28e10663603f5ea1$var$dropItems.values()].filter(item => {
      if (typeof item.getDropOperation === "function") return item.getDropOperation(types, this.dragTarget.allowedDropOperations) !== "cancel";
      return true;
    });
    // Filter out drop targets that contain valid items. We don't want to stop hiding elements
    // other than the drop items that exist inside the collection.
    let visibleDropTargets = this.validDropTargets.filter(target => !validDropItems.some(item => target.element.contains(item.element)));
    this.restoreAriaHidden = (0, $4vY0V$reactariaoverlays.ariaHideOutside)([this.dragTarget.element, ...validDropItems.map(item => item.element), ...visibleDropTargets.map(target => target.element)]);
    this.mutationObserver.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-hidden"]
    });
  }
  next() {
    if (!this.currentDropTarget) {
      this.setCurrentDropTarget(this.validDropTargets[0]);
      return;
    }
    let index = this.validDropTargets.indexOf(this.currentDropTarget);
    if (index < 0) {
      this.setCurrentDropTarget(this.validDropTargets[0]);
      return;
    }
    // If we've reached the end of the valid drop targets, cycle back to the original drag target.
    // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
    if (index === this.validDropTargets.length - 1) {
      if (!this.dragTarget.element.closest('[aria-hidden="true"]')) {
        this.setCurrentDropTarget(null);
        this.dragTarget.element.focus();
      } else this.setCurrentDropTarget(this.validDropTargets[0]);
    } else this.setCurrentDropTarget(this.validDropTargets[index + 1]);
  }
  previous() {
    if (!this.currentDropTarget) {
      this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
      return;
    }
    let index = this.validDropTargets.indexOf(this.currentDropTarget);
    if (index < 0) {
      this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
      return;
    }
    // If we've reached the start of the valid drop targets, cycle back to the original drag target.
    // This lets the user cancel the drag in case they don't have an Escape key (e.g. iPad keyboard case).
    if (index === 0) {
      if (!this.dragTarget.element.closest('[aria-hidden="true"]')) {
        this.setCurrentDropTarget(null);
        this.dragTarget.element.focus();
      } else this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
    } else this.setCurrentDropTarget(this.validDropTargets[index - 1]);
  }
  findNearestDropTarget() {
    let dragTargetRect = this.dragTarget.element.getBoundingClientRect();
    let minDistance = Infinity;
    let nearest = -1;
    for (let i = 0; i < this.validDropTargets.length; i++) {
      let dropTarget = this.validDropTargets[i];
      let rect = dropTarget.element.getBoundingClientRect();
      let dx = rect.left - dragTargetRect.left;
      let dy = rect.top - dragTargetRect.top;
      let dist = dx * dx + dy * dy;
      if (dist < minDistance) {
        minDistance = dist;
        nearest = i;
      }
    }
    return nearest;
  }
  setCurrentDropTarget(dropTarget, item) {
    if (dropTarget !== this.currentDropTarget) {
      if (this.currentDropTarget && typeof this.currentDropTarget.onDropExit === "function") {
        let rect = this.currentDropTarget.element.getBoundingClientRect();
        this.currentDropTarget.onDropExit({
          type: "dropexit",
          x: rect.left + rect.width / 2,
          y: rect.top + rect.height / 2
        });
      }
      this.currentDropTarget = dropTarget;
      if (dropTarget) {
        if (typeof dropTarget.onDropEnter === "function") {
          let rect = dropTarget.element.getBoundingClientRect();
          dropTarget.onDropEnter({
            type: "dropenter",
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2
          }, this.dragTarget);
        }
        if (!item) dropTarget === null || dropTarget === void 0 ? void 0 : dropTarget.element.focus();
      }
    }
    if (item !== this.currentDropItem) {
      if (item && typeof this.currentDropTarget.onDropTargetEnter === "function") this.currentDropTarget.onDropTargetEnter(item === null || item === void 0 ? void 0 : item.target);
      item === null || item === void 0 ? void 0 : item.element.focus();
      this.currentDropItem = item;
      // Announce first drop target after drag start announcement finishes.
      // Otherwise, it will never get announced because drag start announcement is assertive.
      if (!this.initialFocused) {
        (0, $4vY0V$reactarialiveannouncer.announce)(item === null || item === void 0 ? void 0 : item.element.getAttribute("aria-label"), "polite");
        this.initialFocused = true;
      }
    }
  }
  end() {
    this.teardown();
    $28e10663603f5ea1$var$endDragging();
    if (typeof this.dragTarget.onDragEnd === "function") {
      let target = this.currentDropTarget && this.dropOperation !== "cancel" ? this.currentDropTarget : this.dragTarget;
      let rect = target.element.getBoundingClientRect();
      this.dragTarget.onDragEnd({
        type: "dragend",
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2,
        dropOperation: this.dropOperation || "cancel"
      });
    }
    // Blur and re-focus the drop target so that the focus ring appears.
    if (this.currentDropTarget) {
      // Since we cancel all focus events in drag sessions, refire blur to make sure state gets updated so drag target doesn't think it's still focused
      // i.e. When you from one list to another during a drag session, we need the blur to fire on the first list after the drag.
      if (!this.dragTarget.element.contains(this.currentDropTarget.element)) {
        this.dragTarget.element.dispatchEvent(new FocusEvent("blur"));
        this.dragTarget.element.dispatchEvent(new FocusEvent("focusout", {
          bubbles: true
        }));
      }
      // Re-focus the focusedKey upon reorder. This requires a React rerender between blurring and focusing.
      (0, $4vY0V$reactdom.flushSync)(() => {
        this.currentDropTarget.element.blur();
      });
      this.currentDropTarget.element.focus();
    }
    this.setCurrentDropTarget(null);
  }
  cancel() {
    this.setCurrentDropTarget(null);
    this.end();
    if (!this.dragTarget.element.closest('[aria-hidden="true"]')) this.dragTarget.element.focus();
    (0, $4vY0V$reactarialiveannouncer.announce)(this.stringFormatter.format("dropCanceled"));
  }
  drop(item) {
    if (!this.currentDropTarget) {
      this.cancel();
      return;
    }
    if (typeof (item === null || item === void 0 ? void 0 : item.getDropOperation) === "function") {
      let types = (0, $4620ae0dc40f0031$export$e1d41611756c6326)(this.dragTarget.items);
      this.dropOperation = item.getDropOperation(types, this.dragTarget.allowedDropOperations);
    } else if (typeof this.currentDropTarget.getDropOperation === "function") {
      let types = (0, $4620ae0dc40f0031$export$e1d41611756c6326)(this.dragTarget.items);
      this.dropOperation = this.currentDropTarget.getDropOperation(types, this.dragTarget.allowedDropOperations);
    } else
      // TODO: show menu ??
      this.dropOperation = this.dragTarget.allowedDropOperations[0];
    if (typeof this.currentDropTarget.onDrop === "function") {
      let items = this.dragTarget.items.map(item => ({
        kind: "text",
        types: new Set(Object.keys(item)),
        getText: type => Promise.resolve(item[type])
      }));
      let rect = this.currentDropTarget.element.getBoundingClientRect();
      this.currentDropTarget.onDrop({
        type: "drop",
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2,
        items: items,
        dropOperation: this.dropOperation
      }, item === null || item === void 0 ? void 0 : item.target);
    }
    this.end();
    (0, $4vY0V$reactarialiveannouncer.announce)(this.stringFormatter.format("dropComplete"));
  }
  activate() {
    if (this.currentDropTarget && typeof this.currentDropTarget.onDropActivate === "function") {
      let rect = this.currentDropTarget.element.getBoundingClientRect();
      this.currentDropTarget.onDropActivate({
        type: "dropactivate",
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2
      });
    }
  }
  constructor(target, stringFormatter) {
    this.dragTarget = target;
    this.stringFormatter = stringFormatter;
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.cancelEvent = this.cancelEvent.bind(this);
    this.initialFocused = false;
  }
}
function $28e10663603f5ea1$var$findValidDropTargets(options) {
  let types = (0, $4620ae0dc40f0031$export$e1d41611756c6326)(options.items);
  return [...$28e10663603f5ea1$var$dropTargets.values()].filter(target => {
    if (target.element.closest('[aria-hidden="true"]')) return false;
    if (typeof target.getDropOperation === "function") return target.getDropOperation(types, options.allowedDropOperations) !== "cancel";
    return true;
  });
}
var $7c8adf3925a26206$exports = {};
var $12ee6b0bfb4232ad$exports = {};
$12ee6b0bfb4232ad$exports = {
  "dragDescriptionKeyboard": "\u0627\u0636\u063A\u0637 Enter \u0644\u0628\u062F\u0621 \u0627\u0644\u0633\u062D\u0628.",
  "dragDescriptionKeyboardAlt": "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 Alt + Enter \u0644\u0628\u062F\u0621 \u0627\u0644\u0633\u062D\u0628.",
  "dragDescriptionLongPress": "\u0627\u0636\u063A\u0637 \u0628\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0644\u0628\u062F\u0621 \u0627\u0644\u0633\u062D\u0628.",
  "dragDescriptionTouch": "\u0627\u0636\u063A\u0637 \u0645\u0631\u062A\u064A\u0646 \u0644\u0628\u062F\u0621 \u0627\u0644\u0633\u062D\u0628.",
  "dragDescriptionVirtual": "\u0627\u0646\u0642\u0631 \u0644\u0628\u062F\u0621 \u0627\u0644\u0633\u062D\u0628.",
  "dragItem": args => "\u0627\u0633\u062D\u0628 ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "\u0627\u0633\u062D\u0628 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0639\u0646\u0635\u0631 \u0645\u062D\u062F\u062F"),
    other: () => "".concat(formatter.number(args.count), " \u0639\u0646\u0627\u0635\u0631 \u0645\u062D\u062F\u062F\u0629")
  })),
  "dragSelectedKeyboard": (args, formatter) => "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 Enter \u0644\u0644\u0633\u062D\u0628 ".concat(formatter.plural(args.count, {
    one: "\u0639\u062F\u062F \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629",
    other: "\u0639\u062F\u062F \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629"
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0645\u0641\u062A\u0627\u062D\u064A Alt + Enter \u0644\u0644\u0633\u062D\u0628 ".concat(formatter.plural(args.count, {
    one: "\u0639\u062F\u062F \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629",
    other: "\u0639\u062F\u062F \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629"
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "\u0627\u0636\u063A\u0637 \u0628\u0627\u0633\u062A\u0645\u0631\u0627\u0631 \u0644\u0644\u0633\u062D\u0628 ".concat(formatter.plural(args.count, {
    one: "\u0639\u062F\u062F \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629",
    other: "\u0639\u062F\u062F \u0627\u0644\u0639\u0646\u0627\u0635\u0631 \u0627\u0644\u0645\u062E\u062A\u0627\u0631\u0629"
  }), "."),
  "dragStartedKeyboard": "\u0628\u062F\u0623 \u0627\u0644\u0633\u062D\u0628. \u0627\u0636\u063A\u0637 Tab \u0644\u0644\u0627\u0646\u062A\u0642\u0627\u0644 \u0625\u0644\u0649 \u0645\u0648\u0636\u0639 \u0627\u0644\u0625\u0641\u0644\u0627\u062A\u060C \u062B\u0645 \u0627\u0636\u063A\u0637 Enter \u0644\u0644\u0625\u0641\u0644\u0627\u062A\u060C \u0623\u0648 \u0627\u0636\u063A\u0637 Escape \u0644\u0644\u0625\u0644\u063A\u0627\u0621.",
  "dragStartedTouch": "\u0628\u062F\u0623 \u0627\u0644\u0633\u062D\u0628. \u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0645\u0648\u0636\u0639 \u0627\u0644\u0625\u0641\u0644\u0627\u062A\u060C \u062B\u0645 \u0627\u0636\u063A\u0637 \u0645\u0631\u062A\u064A\u0646 \u0644\u0644\u0625\u0641\u0644\u0627\u062A.",
  "dragStartedVirtual": "\u0628\u062F\u0623 \u0627\u0644\u0633\u062D\u0628. \u0627\u0646\u062A\u0642\u0644 \u0625\u0644\u0649 \u0645\u0643\u0627\u0646 \u0627\u0644\u0625\u0641\u0644\u0627\u062A\u060C \u062B\u0645 \u0627\u0646\u0642\u0631 \u0623\u0648 \u0627\u0636\u063A\u0637 Enter \u0644\u0644\u0625\u0641\u0644\u0627\u062A.",
  "dropCanceled": "\u062A\u0645 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0625\u0641\u0644\u0627\u062A.",
  "dropComplete": "\u0627\u0643\u062A\u0645\u0644 \u0627\u0644\u0625\u0641\u0644\u0627\u062A.",
  "dropDescriptionKeyboard": "\u0627\u0636\u063A\u0637 Enter \u0644\u0644\u0625\u0641\u0644\u0627\u062A. \u0627\u0636\u063A\u0637 Escape \u0644\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0633\u062D\u0628.",
  "dropDescriptionTouch": "\u0627\u0636\u063A\u0637 \u0645\u0631\u062A\u064A\u0646 \u0644\u0644\u0625\u0641\u0644\u0627\u062A.",
  "dropDescriptionVirtual": "\u0627\u0646\u0642\u0631 \u0644\u0644\u0625\u0641\u0644\u0627\u062A.",
  "dropIndicator": "\u0645\u0624\u0634\u0631 \u0627\u0644\u0625\u0641\u0644\u0627\u062A",
  "dropOnItem": args => "\u0625\u0641\u0644\u0627\u062A ".concat(args.itemText),
  "dropOnRoot": "\u0627\u0644\u0625\u0641\u0644\u0627\u062A",
  "endDragKeyboard": "\u0627\u0644\u0633\u062D\u0628. \u0627\u0636\u063A\u0637 Enter \u0644\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0633\u062D\u0628.",
  "endDragTouch": "\u0627\u0644\u0633\u062D\u0628. \u0627\u0636\u063A\u0637 \u0645\u0631\u062A\u064A\u0646 \u0644\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0633\u062D\u0628.",
  "endDragVirtual": "\u0627\u0644\u0633\u062D\u0628. \u0627\u0646\u0642\u0631 \u0644\u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0633\u062D\u0628.",
  "insertAfter": args => "\u0623\u062F\u062E\u0644 \u0628\u0639\u062F ".concat(args.itemText),
  "insertBefore": args => "\u0623\u062F\u062E\u0644 \u0642\u0628\u0644 ".concat(args.itemText),
  "insertBetween": args => "\u0623\u062F\u062E\u0644 \u0628\u064A\u0646 ".concat(args.beforeItemText, " \u0648 ").concat(args.afterItemText)
};
var $e21ef7c55796c5e1$exports = {};
$e21ef7c55796c5e1$exports = {
  "dragDescriptionKeyboard": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EEnter\u201C, \u0437\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u0442\u0435.",
  "dragDescriptionKeyboardAlt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 Alt + Enter, \u0437\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u0442\u0435.",
  "dragDescriptionLongPress": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E, \u0437\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u0442\u0435.",
  "dragDescriptionTouch": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u0434\u0432\u0443\u043A\u0440\u0430\u0442\u043D\u043E, \u0437\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u0442\u0435.",
  "dragDescriptionVirtual": "\u0429\u0440\u0430\u043A\u043D\u0435\u0442\u0435, \u0437\u0430 \u0434\u0430 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u0442\u0435.",
  "dragItem": args => "\u041F\u043B\u044A\u0437\u043D\u0438 ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "\u041F\u043B\u044A\u0437\u043D\u0438 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D \u0435\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430")
  })),
  "dragSelectedKeyboard": (args, formatter) => "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 Enter, \u0437\u0430 \u0434\u0430 \u043F\u043B\u044A\u0437\u043D\u0435\u0442\u0435 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D \u0435\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 Alt \u0438 Enter, \u0437\u0430 \u0434\u0430 \u043F\u043B\u044A\u0437\u043D\u0435\u0442\u0435 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D \u0435\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E, \u0437\u0430 \u0434\u0430 \u043F\u043B\u044A\u0437\u043D\u0435\u0442\u0435 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D \u0435\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0438\u0437\u0431\u0440\u0430\u043D\u0438 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438")
  }), "."),
  "dragStartedKeyboard": "\u0417\u0430\u043F\u043E\u0447\u043D\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u043D\u0435. \u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201ETab\u201C, \u0437\u0430 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0434\u0432\u0438\u0436\u0438\u0442\u0435 \u0434\u043E \u0446\u0435\u043B\u0442\u0430, \u0441\u043B\u0435\u0434 \u043A\u043E\u0435\u0442\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EEnter\u201C \u0437\u0430 \u043F\u0443\u0441\u043A\u0430\u043D\u0435 \u0438\u043B\u0438 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EEscape\u201C \u0437\u0430 \u043E\u0442\u043C\u044F\u043D\u0430.",
  "dragStartedTouch": "\u0417\u0430\u043F\u043E\u0447\u043D\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u043D\u0435. \u041F\u0440\u0438\u0434\u0432\u0438\u0436\u0435\u0442\u0435 \u0441\u0435 \u0434\u043E \u0446\u0435\u043B\u0442\u0430, \u0441\u043B\u0435\u0434 \u043A\u043E\u0435\u0442\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u0434\u0432\u0443\u043A\u0440\u0430\u0442\u043D\u043E, \u0437\u0430 \u0434\u0430 \u043F\u0443\u0441\u043D\u0435\u0442\u0435.",
  "dragStartedVirtual": "\u0417\u0430\u043F\u043E\u0447\u043D\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u043D\u0435. \u041F\u0440\u0438\u0434\u0432\u0438\u0436\u0435\u0442\u0435 \u0441\u0435 \u0434\u043E \u0446\u0435\u043B\u0442\u0430, \u0441\u043B\u0435\u0434 \u043A\u043E\u0435\u0442\u043E \u0449\u0440\u0430\u043A\u043D\u0435\u0442\u0435 \u0438\u043B\u0438 \u043D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EEnter\u201C \u0437\u0430 \u043F\u0443\u0441\u043A\u0430\u043D\u0435.",
  "dropCanceled": "\u041F\u0443\u0441\u043A\u0430\u043D\u0435\u0442\u043E \u0435 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E.",
  "dropComplete": "\u041F\u0443\u0441\u043A\u0430\u043D\u0435\u0442\u043E \u0435 \u0437\u0430\u0432\u044A\u0440\u0448\u0435\u043D\u043E.",
  "dropDescriptionKeyboard": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EEnter\u201C \u0437\u0430 \u043F\u0443\u0441\u043A\u0430\u043D\u0435. \u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EEscape\u201C \u0437\u0430 \u043E\u0442\u043C\u044F\u043D\u0430 \u043D\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u043D\u0435\u0442\u043E.",
  "dropDescriptionTouch": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u0434\u0432\u0443\u043A\u0440\u0430\u0442\u043D\u043E \u0437\u0430 \u043F\u0443\u0441\u043A\u0430\u043D\u0435.",
  "dropDescriptionVirtual": "\u0429\u0440\u0430\u043A\u043D\u0435\u0442\u0435 \u0437\u0430 \u043F\u0443\u0441\u043A\u0430\u043D\u0435.",
  "dropIndicator": "\u0438\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430 \u043F\u0443\u0441\u043A\u0430\u043D\u0435",
  "dropOnItem": args => "\u041F\u0443\u0441\u043D\u0438 \u0432\u044A\u0440\u0445\u0443 ".concat(args.itemText),
  "dropOnRoot": "\u041F\u0443\u0441\u043D\u0438 \u0432\u044A\u0440\u0445\u0443",
  "endDragKeyboard": "\u041F\u043B\u044A\u0437\u0433\u0430\u043D\u0435. \u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u201EEnter\u201C \u0437\u0430 \u043E\u0442\u043C\u044F\u043D\u0430 \u043D\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u043D\u0435\u0442\u043E.",
  "endDragTouch": "\u041F\u043B\u044A\u0437\u0433\u0430\u043D\u0435. \u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u0434\u0432\u0443\u043A\u0440\u0430\u0442\u043D\u043E \u0437\u0430 \u043E\u0442\u043C\u044F\u043D\u0430 \u043D\u0430 \u043F\u043B\u044A\u0437\u0433\u0430\u043D\u0435\u0442\u043E.",
  "endDragVirtual": "\u041F\u043B\u044A\u0437\u0433\u0430\u043D\u0435. \u0429\u0440\u0430\u043A\u043D\u0435\u0442\u0435 \u0437\u0430 \u043E\u0442\u043C\u044F\u043D\u0430.",
  "insertAfter": args => "\u0412\u043C\u044A\u043A\u043D\u0438 \u0441\u043B\u0435\u0434 ".concat(args.itemText),
  "insertBefore": args => "\u0412\u043C\u044A\u043A\u043D\u0438 \u043F\u0440\u0435\u0434\u0438 ".concat(args.itemText),
  "insertBetween": args => "\u0412\u043C\u044A\u043A\u043D\u0438 \u043C\u0435\u0436\u0434\u0443 ".concat(args.beforeItemText, " \u0438 ").concat(args.afterItemText)
};
var $dfa9cd1c2317d9aa$exports = {};
$dfa9cd1c2317d9aa$exports = {
  "dragDescriptionKeyboard": "Stisknut\xEDm kl\xE1vesy Enter za\u010Dnete s p\u0159etahov\xE1n\xEDm.",
  "dragDescriptionKeyboardAlt": "Stisknut\xEDm Alt + Enter zah\xE1j\xEDte p\u0159etahov\xE1n\xED.",
  "dragDescriptionLongPress": "Dlouh\xFDm stisknut\xEDm zah\xE1j\xEDte p\u0159etahov\xE1n\xED.",
  "dragDescriptionTouch": "Poklep\xE1n\xEDm za\u010Dnete s p\u0159etahov\xE1n\xEDm.",
  "dragDescriptionVirtual": "Kliknut\xEDm za\u010Dnete s p\u0159etahov\xE1n\xEDm.",
  "dragItem": args => "P\u0159et\xE1hnout ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "P\u0159et\xE1hnout ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " vybranou polo\u017Eku"),
    few: () => "".concat(formatter.number(args.count), " vybran\xE9 polo\u017Eky"),
    other: () => "".concat(formatter.number(args.count), " vybran\xFDch polo\u017Eek")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Stisknut\xEDm kl\xE1vesy Enter p\u0159et\xE1hn\u011Bte ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " vybranou polo\u017Eku"),
    other: () => "".concat(formatter.number(args.count), " vybran\xE9 polo\u017Eky")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Stisknut\xEDm Alt + Enter p\u0159et\xE1hn\u011Bte ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " vybranou polo\u017Eku"),
    other: () => "".concat(formatter.number(args.count), " vybran\xE9 polo\u017Eky")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Dlouh\xFDm stisknut\xEDm p\u0159et\xE1hnete ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " vybranou polo\u017Eku"),
    other: () => "".concat(formatter.number(args.count), " vybran\xE9 polo\u017Eky")
  }), "."),
  "dragStartedKeyboard": "Za\u010Dn\u011Bte s p\u0159etahov\xE1n\xEDm. Po stisknut\xED kl\xE1vesy Tab najd\u011Bte po\u017Eadovan\xFD c\xEDl a stisknut\xEDm kl\xE1vesy Enter p\u0159eta\u017Een\xED dokon\u010Dete nebo stisknut\xEDm kl\xE1vesy Esc akci zru\u0161te.",
  "dragStartedTouch": "Za\u010Dn\u011Bte s p\u0159etahov\xE1n\xEDm. Najd\u011Bte po\u017Eadovan\xFD c\xEDl a poklep\xE1n\xEDm p\u0159eta\u017Een\xED dokon\u010Dete.",
  "dragStartedVirtual": "Za\u010Dn\u011Bte s p\u0159etahov\xE1n\xEDm. Najd\u011Bte po\u017Eadovan\xFD c\xEDl a kliknut\xEDm nebo stisknut\xEDm kl\xE1vesy Enter p\u0159eta\u017Een\xED dokon\u010Dete.",
  "dropCanceled": "P\u0159eta\u017Een\xED bylo zru\u0161eno.",
  "dropComplete": "P\u0159eta\u017Een\xED bylo dokon\u010Deno.",
  "dropDescriptionKeyboard": "Stisknut\xEDm kl\xE1vesy Enter p\u0159eta\u017Een\xED dokon\u010Dete nebo stisknut\xEDm kl\xE1vesy Esc akci zru\u0161te.",
  "dropDescriptionTouch": "Poklep\xE1n\xEDm p\u0159eta\u017Een\xED dokon\u010Dete.",
  "dropDescriptionVirtual": "Kliknut\xEDm objekt p\u0159et\xE1hn\u011Bte.",
  "dropIndicator": "indik\xE1tor p\u0159eta\u017Een\xED",
  "dropOnItem": args => "P\u0159et\xE1hnout na ".concat(args.itemText),
  "dropOnRoot": "P\u0159et\xE1hnout na",
  "endDragKeyboard": "Prob\xEDh\xE1 p\u0159etahov\xE1n\xED. Stisknut\xEDm kl\xE1vesy Enter p\u0159eta\u017Een\xED zru\u0161\xEDte.",
  "endDragTouch": "Prob\xEDh\xE1 p\u0159etahov\xE1n\xED. Poklep\xE1n\xEDm p\u0159eta\u017Een\xED zru\u0161\xEDte.",
  "endDragVirtual": "Prob\xEDh\xE1 p\u0159etahov\xE1n\xED. Kliknut\xEDm p\u0159eta\u017Een\xED zru\u0161\xEDte.",
  "insertAfter": args => "Vlo\u017Eit za ".concat(args.itemText),
  "insertBefore": args => "Vlo\u017Eit p\u0159ed ".concat(args.itemText),
  "insertBetween": args => "Vlo\u017Eit mezi ".concat(args.beforeItemText, " a ").concat(args.afterItemText)
};
var $65fff3bbacfa8956$exports = {};
$65fff3bbacfa8956$exports = {
  "dragDescriptionKeyboard": "Tryk p\xE5 Enter for at starte med at tr\xE6kke.",
  "dragDescriptionKeyboardAlt": "Tryk p\xE5 Alt + Enter for at starte med at tr\xE6kke.",
  "dragDescriptionLongPress": "Tryk l\xE6nge for at starte med at tr\xE6kke.",
  "dragDescriptionTouch": "Dobbelttryk for at starte med at tr\xE6kke.",
  "dragDescriptionVirtual": "Klik for at starte med at tr\xE6kke.",
  "dragItem": args => "Tr\xE6k ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Tr\xE6k ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valgt element"),
    other: () => "".concat(formatter.number(args.count), " valgte elementer")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Tryk p\xE5 Enter for at tr\xE6kke ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valgte element"),
    other: () => "".concat(formatter.number(args.count), " valgte elementer")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Tryk p\xE5 Alt + Enter for at tr\xE6kke ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valgte element"),
    other: () => "".concat(formatter.number(args.count), " valgte elementer")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Tryk l\xE6nge for at tr\xE6kke ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valgte element"),
    other: () => "".concat(formatter.number(args.count), " valgte elementer")
  }), "."),
  "dragStartedKeyboard": "Startet med at tr\xE6kke. Tryk p\xE5 Tab for at g\xE5 til et slip-m\xE5l, tryk derefter p\xE5 Enter for at slippe, eller tryk p\xE5 Escape for at annullere.",
  "dragStartedTouch": "Startet med at tr\xE6kke. G\xE5 til et slip-m\xE5l, og dobbelttryk derefter for at slippe.",
  "dragStartedVirtual": "Startet med at tr\xE6kke. G\xE5 til et slip-m\xE5l, og klik eller tryk derefter p\xE5 enter for at slippe.",
  "dropCanceled": "Slip annulleret.",
  "dropComplete": "Slip fuldf\xF8rt.",
  "dropDescriptionKeyboard": "Tryk p\xE5 Enter for at slippe. Tryk p\xE5 Escape for at annullere tr\xE6kning.",
  "dropDescriptionTouch": "Dobbelttryk for at slippe.",
  "dropDescriptionVirtual": "Klik for at slippe.",
  "dropIndicator": "slip-indikator",
  "dropOnItem": args => "Slip p\xE5 ".concat(args.itemText),
  "dropOnRoot": "Slip p\xE5",
  "endDragKeyboard": "Tr\xE6kning. Tryk p\xE5 enter for at annullere tr\xE6k.",
  "endDragTouch": "Tr\xE6kning. Dobbelttryk for at annullere tr\xE6k.",
  "endDragVirtual": "Tr\xE6kning. Klik for at annullere tr\xE6kning.",
  "insertAfter": args => "Inds\xE6t efter ".concat(args.itemText),
  "insertBefore": args => "Inds\xE6t f\xF8r ".concat(args.itemText),
  "insertBetween": args => "Inds\xE6t mellem ".concat(args.beforeItemText, " og ").concat(args.afterItemText)
};
var $10b7dfe45cd41c2d$exports = {};
$10b7dfe45cd41c2d$exports = {
  "dragDescriptionKeyboard": "Dr\xFCcken Sie die Eingabetaste, um den Ziehvorgang zu starten.",
  "dragDescriptionKeyboardAlt": "Alt + Eingabe dr\xFCcken, um den Ziehvorgang zu starten.",
  "dragDescriptionLongPress": "Lang dr\xFCcken, um mit dem Ziehen zu beginnen.",
  "dragDescriptionTouch": "Tippen Sie doppelt, um den Ziehvorgang zu starten.",
  "dragDescriptionVirtual": "Zum Starten des Ziehvorgangs klicken.",
  "dragItem": args => "".concat(args.itemText, " ziehen"),
  "dragSelectedItems": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " ausgew\xE4hltes Objekt"),
    other: () => "".concat(formatter.number(args.count), " ausgew\xE4hlte Objekte")
  }), " ziehen"),
  "dragSelectedKeyboard": (args, formatter) => "Eingabetaste dr\xFCcken, um ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " ausgew\xE4hltes Element"),
    other: () => "".concat(formatter.number(args.count), " ausgew\xE4hlte Elemente")
  }), " zu ziehen."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Alt + Eingabetaste dr\xFCcken, um ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " ausgew\xE4hltes Element"),
    other: () => "".concat(formatter.number(args.count), " ausgew\xE4hlte Elemente")
  }), " zu ziehen."),
  "dragSelectedLongPress": (args, formatter) => "Lang dr\xFCcken, um ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " ausgew\xE4hltes Element"),
    other: () => "".concat(formatter.number(args.count), " ausgew\xE4hlte Elemente")
  }), " zu ziehen."),
  "dragStartedKeyboard": "Ziehvorgang gestartet. Dr\xFCcken Sie die Tabulatortaste, um zu einem Ablegeziel zu navigieren und dr\xFCcken Sie dann die Eingabetaste, um das Objekt abzulegen, oder Escape, um den Vorgang abzubrechen.",
  "dragStartedTouch": "Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und tippen Sie doppelt, um das Objekt abzulegen.",
  "dragStartedVirtual": "Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und klicken Sie oder dr\xFCcken Sie die Eingabetaste, um das Objekt abzulegen.",
  "dropCanceled": "Ablegen abgebrochen.",
  "dropComplete": "Ablegen abgeschlossen.",
  "dropDescriptionKeyboard": "Dr\xFCcken Sie die Eingabetaste, um das Objekt abzulegen. Dr\xFCcken Sie Escape, um den Vorgang abzubrechen.",
  "dropDescriptionTouch": "Tippen Sie doppelt, um das Objekt abzulegen.",
  "dropDescriptionVirtual": "Zum Ablegen klicken.",
  "dropIndicator": "Ablegeanzeiger",
  "dropOnItem": args => "Auf ".concat(args.itemText, " ablegen"),
  "dropOnRoot": "Ablegen auf",
  "endDragKeyboard": "Ziehvorgang l\xE4uft. Dr\xFCcken Sie die Eingabetaste, um den Vorgang abzubrechen.",
  "endDragTouch": "Ziehvorgang l\xE4uft. Tippen Sie doppelt, um den Vorgang abzubrechen.",
  "endDragVirtual": "Ziehvorgang l\xE4uft. Klicken Sie, um den Vorgang abzubrechen.",
  "insertAfter": args => "Nach ".concat(args.itemText, " einf\xFCgen"),
  "insertBefore": args => "Vor ".concat(args.itemText, " einf\xFCgen"),
  "insertBetween": args => "Zwischen ".concat(args.beforeItemText, " und ").concat(args.afterItemText, " einf\xFCgen")
};
var $0cadcffb7abc96b8$exports = {};
$0cadcffb7abc96b8$exports = {
  "dragDescriptionKeyboard": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Enter \u03B3\u03B9\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7 \u03C4\u03B7\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2.",
  "dragDescriptionKeyboardAlt": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Alt + Enter \u03B3\u03B9\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7 \u03C4\u03B7\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2.",
  "dragDescriptionLongPress": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C0\u03B1\u03C1\u03B1\u03C4\u03B5\u03C4\u03B1\u03BC\u03AD\u03BD\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC.",
  "dragDescriptionTouch": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03B4\u03CD\u03BF \u03C6\u03BF\u03C1\u03AD\u03C2 \u03B3\u03B9\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7 \u03C4\u03B7\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2.",
  "dragDescriptionVirtual": "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BE\u03B5\u03BA\u03B9\u03BD\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC.",
  "dragItem": args => "\u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "\u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03C3\u03B5 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF"),
    other: () => "".concat(formatter.number(args.count), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1")
  })),
  "dragSelectedKeyboard": (args, formatter) => "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Enter \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03CD\u03C1\u03B5\u03C4\u03B5 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF"),
    other: () => "".concat(formatter.number(args.count), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Alt + Enter \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03CD\u03C1\u03B5\u03C4\u03B5 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF"),
    other: () => "".concat(formatter.number(args.count), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C0\u03B1\u03C1\u03B1\u03C4\u03B5\u03C4\u03B1\u03BC\u03AD\u03BD\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03CD\u03C1\u03B5\u03C4\u03B5 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF"),
    other: () => "".concat(formatter.number(args.count), " \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1")
  }), "."),
  "dragStartedKeyboard": "\u0397 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03BE\u03B5\u03BA\u03AF\u03BD\u03B7\u03C3\u03B5. \u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03BB\u03AE\u03BA\u03C4\u03C1\u03BF Tab \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BC\u03B5\u03C4\u03B1\u03B2\u03B5\u03AF\u03C4\u03B5 \u03C3\u03B5 \u03AD\u03BD\u03B1\u03BD \u03C0\u03C1\u03BF\u03BF\u03C1\u03B9\u03C3\u03BC\u03CC \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7\u03C2 \u03BA\u03B1\u03B9, \u03C3\u03C4\u03B7 \u03C3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1, \u03C0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Enter \u03B3\u03B9\u03B1 \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7 \u03AE \u03C0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Escape \u03B3\u03B9\u03B1 \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7.",
  "dragStartedTouch": "\u0397 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03BE\u03B5\u03BA\u03AF\u03BD\u03B7\u03C3\u03B5. \u039C\u03B5\u03C4\u03B1\u03B2\u03B5\u03AF\u03C4\u03B5 \u03C3\u03B5 \u03AD\u03BD\u03B1\u03BD \u03C0\u03C1\u03BF\u03BF\u03C1\u03B9\u03C3\u03BC\u03CC \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7\u03C2 \u03BA\u03B1\u03B9, \u03C3\u03C4\u03B7 \u03C3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1, \u03C0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03B4\u03CD\u03BF \u03C6\u03BF\u03C1\u03AD\u03C2 \u03B3\u03B9\u03B1 \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7.",
  "dragStartedVirtual": "\u0397 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03BE\u03B5\u03BA\u03AF\u03BD\u03B7\u03C3\u03B5. \u039C\u03B5\u03C4\u03B1\u03B2\u03B5\u03AF\u03C4\u03B5 \u03C3\u03B5 \u03AD\u03BD\u03B1\u03BD \u03C0\u03C1\u03BF\u03BF\u03C1\u03B9\u03C3\u03BC\u03CC \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7\u03C2 \u03BA\u03B1\u03B9, \u03C3\u03C4\u03B7 \u03C3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03AE \u03C0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Enter \u03B3\u03B9\u03B1 \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7.",
  "dropCanceled": "\u0397 \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7 \u03B1\u03BA\u03C5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5.",
  "dropComplete": "\u0397 \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5.",
  "dropDescriptionKeyboard": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Enter \u03B3\u03B9\u03B1 \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7. \u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Escape \u03B3\u03B9\u03B1 \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2.",
  "dropDescriptionTouch": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03B4\u03CD\u03BF \u03C6\u03BF\u03C1\u03AD\u03C2 \u03B3\u03B9\u03B1 \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7.",
  "dropDescriptionVirtual": "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7.",
  "dropIndicator": "\u03B4\u03B5\u03AF\u03BA\u03C4\u03B7\u03C2 \u03B1\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7\u03C2",
  "dropOnItem": args => "\u0391\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7 \u03C3\u03B5 ".concat(args.itemText),
  "dropOnRoot": "\u0391\u03C0\u03CC\u03B8\u03B5\u03C3\u03B7 \u03C3\u03B5",
  "endDragKeyboard": "\u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03C3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7. \u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Enter \u03B3\u03B9\u03B1 \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2.",
  "endDragTouch": "\u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03C3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7. \u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03B4\u03CD\u03BF \u03C6\u03BF\u03C1\u03AD\u03C2 \u03B3\u03B9\u03B1 \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2.",
  "endDragVirtual": "\u039C\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC \u03C3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7. \u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2.",
  "insertAfter": args => "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BC\u03B5\u03C4\u03AC \u03B1\u03C0\u03CC ".concat(args.itemText),
  "insertBefore": args => "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03C0\u03C1\u03B9\u03BD \u03B1\u03C0\u03CC ".concat(args.itemText),
  "insertBetween": args => "\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BC\u03B5\u03C4\u03B1\u03BE\u03CD ".concat(args.beforeItemText, " \u03BA\u03B1\u03B9 ").concat(args.afterItemText)
};
var $7e3982b34ddf1bdf$exports = {};
$7e3982b34ddf1bdf$exports = {
  "dragItem": args => "Drag ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Drag ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " selected item"),
    other: () => "".concat(formatter.number(args.count), " selected items")
  })),
  "dragDescriptionKeyboard": "Press Enter to start dragging.",
  "dragDescriptionKeyboardAlt": "Press Alt + Enter to start dragging.",
  "dragDescriptionTouch": "Double tap to start dragging.",
  "dragDescriptionVirtual": "Click to start dragging.",
  "dragDescriptionLongPress": "Long press to start dragging.",
  "dragSelectedKeyboard": (args, formatter) => "Press Enter to drag ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " selected item"),
    other: () => "".concat(formatter.number(args.count), " selected items")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Press Alt + Enter to drag ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " selected item"),
    other: () => "".concat(formatter.number(args.count), " selected items")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Long press to drag ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " selected item"),
    other: () => "".concat(formatter.number(args.count), " selected items")
  }), "."),
  "dragStartedKeyboard": "Started dragging. Press Tab to navigate to a drop target, then press Enter to drop, or press Escape to cancel.",
  "dragStartedTouch": "Started dragging. Navigate to a drop target, then double tap to drop.",
  "dragStartedVirtual": "Started dragging. Navigate to a drop target, then click or press Enter to drop.",
  "endDragKeyboard": "Dragging. Press Enter to cancel drag.",
  "endDragTouch": "Dragging. Double tap to cancel drag.",
  "endDragVirtual": "Dragging. Click to cancel drag.",
  "dropDescriptionKeyboard": "Press Enter to drop. Press Escape to cancel drag.",
  "dropDescriptionTouch": "Double tap to drop.",
  "dropDescriptionVirtual": "Click to drop.",
  "dropCanceled": "Drop canceled.",
  "dropComplete": "Drop complete.",
  "dropIndicator": "drop indicator",
  "dropOnRoot": "Drop on",
  "dropOnItem": args => "Drop on ".concat(args.itemText),
  "insertBefore": args => "Insert before ".concat(args.itemText),
  "insertBetween": args => "Insert between ".concat(args.beforeItemText, " and ").concat(args.afterItemText),
  "insertAfter": args => "Insert after ".concat(args.itemText)
};
var $cb29ce0b655c4023$exports = {};
$cb29ce0b655c4023$exports = {
  "dragDescriptionKeyboard": "Pulse Intro para empezar a arrastrar.",
  "dragDescriptionKeyboardAlt": "Pulse Intro para empezar a arrastrar.",
  "dragDescriptionLongPress": "Mantenga pulsado para comenzar a arrastrar.",
  "dragDescriptionTouch": "Pulse dos veces para iniciar el arrastre.",
  "dragDescriptionVirtual": "Haga clic para iniciar el arrastre.",
  "dragItem": args => "Arrastrar ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Arrastrar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " elemento seleccionado"),
    other: () => "".concat(formatter.number(args.count), " elementos seleccionados")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Pulse Intro para arrastrar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " elemento seleccionado"),
    other: () => "".concat(formatter.number(args.count), " elementos seleccionados")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Pulse Alt + Intro para arrastrar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " elemento seleccionado"),
    other: () => "".concat(formatter.number(args.count), " elementos seleccionados")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Mantenga pulsado para arrastrar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " elemento seleccionado"),
    other: () => "".concat(formatter.number(args.count), " elementos seleccionados")
  }), "."),
  "dragStartedKeyboard": "Se ha empezado a arrastrar. Pulse el tabulador para ir al p\xFAblico destinatario donde se vaya a colocar y, a continuaci\xF3n, pulse Intro para soltar, o pulse Escape para cancelar.",
  "dragStartedTouch": "Se ha empezado a arrastrar. Vaya al p\xFAblico destinatario donde se vaya a colocar y, a continuaci\xF3n, pulse dos veces para soltar.",
  "dragStartedVirtual": "Se ha empezado a arrastrar. Vaya al p\xFAblico destinatario donde se vaya a colocar y, a continuaci\xF3n, haga clic o pulse Intro para soltar.",
  "dropCanceled": "Se ha cancelado la colocaci\xF3n.",
  "dropComplete": "Colocaci\xF3n finalizada.",
  "dropDescriptionKeyboard": "Pulse Intro para soltar. Pulse Escape para cancelar el arrastre.",
  "dropDescriptionTouch": "Pulse dos veces para soltar.",
  "dropDescriptionVirtual": "Haga clic para soltar.",
  "dropIndicator": "indicador de colocaci\xF3n",
  "dropOnItem": args => "Soltar en ".concat(args.itemText),
  "dropOnRoot": "Soltar en",
  "endDragKeyboard": "Arrastrando. Pulse Intro para cancelar el arrastre.",
  "endDragTouch": "Arrastrando. Pulse dos veces para cancelar el arrastre.",
  "endDragVirtual": "Arrastrando. Haga clic para cancelar el arrastre.",
  "insertAfter": args => "Insertar despu\xE9s de ".concat(args.itemText),
  "insertBefore": args => "Insertar antes de ".concat(args.itemText),
  "insertBetween": args => "Insertar entre ".concat(args.beforeItemText, " y ").concat(args.afterItemText)
};
var $067d46bab80bcf4b$exports = {};
$067d46bab80bcf4b$exports = {
  "dragDescriptionKeyboard": "Lohistamise alustamiseks vajutage klahvi Enter.",
  "dragDescriptionKeyboardAlt": "Lohistamise alustamiseks vajutage klahvikombinatsiooni Alt + Enter.",
  "dragDescriptionLongPress": "Vajutage pikalt lohistamise alustamiseks.",
  "dragDescriptionTouch": "Topeltpuudutage lohistamise alustamiseks.",
  "dragDescriptionVirtual": "Kl\xF5psake lohistamise alustamiseks.",
  "dragItem": args => "Lohista ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Lohista ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valitud \xFCksust"),
    other: () => "".concat(formatter.number(args.count), " valitud \xFCksust")
  })),
  "dragSelectedKeyboard": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valitud \xFCksuse"),
    other: () => "".concat(formatter.number(args.count), " valitud \xFCksuse")
  }), " lohistamiseks vajutage sisestusklahvi Enter."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Lohistamiseks vajutage klahvikombinatsiooni Alt + Enter ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valitud \xFCksuse"),
    other: () => "".concat(formatter.number(args.count), " valitud \xFCksuse")
  }), " jaoks."),
  "dragSelectedLongPress": (args, formatter) => "Pikk vajutus ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valitud \xFCksuse"),
    other: () => "".concat(formatter.number(args.count), " valitud \xFCksuse")
  }), " lohistamiseks."),
  "dragStartedKeyboard": "Alustati lohistamist. Kukutamise sihtm\xE4rgi juurde navigeerimiseks vajutage klahvi Tab, seej\xE4rel vajutage kukutamiseks klahvi Enter v\xF5i loobumiseks klahvi Escape.",
  "dragStartedTouch": "Alustati lohistamist. Navigeerige kukutamise sihtm\xE4rgi juurde ja topeltpuudutage kukutamiseks.",
  "dragStartedVirtual": "Alustati lohistamist. Navigeerige kukutamise sihtm\xE4rgi juurde ja kukutamiseks kl\xF5psake v\xF5i vajutage klahvi Enter.",
  "dropCanceled": "Lohistamisest loobuti.",
  "dropComplete": "Lohistamine on tehtud.",
  "dropDescriptionKeyboard": "Kukutamiseks vajutage klahvi Enter. Lohistamisest loobumiseks vajutage klahvi Escape.",
  "dropDescriptionTouch": "Kukutamiseks topeltpuudutage.",
  "dropDescriptionVirtual": "Kukutamiseks kl\xF5psake.",
  "dropIndicator": "lohistamise indikaator",
  "dropOnItem": args => "Kukuta asukohta ".concat(args.itemText),
  "dropOnRoot": "Kukuta asukohta",
  "endDragKeyboard": "Lohistamine. Lohistamisest loobumiseks vajutage klahvi Enter.",
  "endDragTouch": "Lohistamine. Lohistamisest loobumiseks topeltpuudutage.",
  "endDragVirtual": "Lohistamine. Lohistamisest loobumiseks kl\xF5psake.",
  "insertAfter": args => "Sisesta ".concat(args.itemText, " j\xE4rele"),
  "insertBefore": args => "Sisesta ".concat(args.itemText, " ette"),
  "insertBetween": args => "Sisesta ".concat(args.beforeItemText, " ja ").concat(args.afterItemText, " vahele")
};
var $8aa1b9a1f9d783d3$exports = {};
$8aa1b9a1f9d783d3$exports = {
  "dragDescriptionKeyboard": "Aloita vet\xE4minen painamalla Enter-n\xE4pp\xE4int\xE4.",
  "dragDescriptionKeyboardAlt": "Aloita vet\xE4minen painamalla Alt + Enter -n\xE4pp\xE4inyhdistelm\xE4\xE4.",
  "dragDescriptionLongPress": "Aloita vet\xE4minen pit\xE4m\xE4ll\xE4 painettuna.",
  "dragDescriptionTouch": "Aloita vet\xE4minen kaksoisnapauttamalla.",
  "dragDescriptionVirtual": "Aloita vet\xE4minen napsauttamalla.",
  "dragItem": args => "Ved\xE4 kohdetta ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Ved\xE4 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valittua kohdetta"),
    other: () => "".concat(formatter.number(args.count), " valittua kohdetta")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Ved\xE4 painamalla Enter ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valittu kohde"),
    other: () => "".concat(formatter.number(args.count), " valittua kohdetta")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Ved\xE4 painamalla Alt + Enter ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valittu kohde"),
    other: () => "".concat(formatter.number(args.count), " valittua kohdetta")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Ved\xE4 pit\xE4m\xE4ll\xE4 painettuna ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valittu kohde"),
    other: () => "".concat(formatter.number(args.count), " valittua kohdetta")
  }), "."),
  "dragStartedKeyboard": "Vet\xE4minen aloitettu. Siirry pudotuskohteeseen painamalla sarkainn\xE4pp\xE4int\xE4 ja sitten pudota painamalla Enter-n\xE4pp\xE4int\xE4 tai peruuta painamalla Escape-n\xE4pp\xE4int\xE4.",
  "dragStartedTouch": "Vet\xE4minen aloitettu. Siirry pudotuskohteeseen ja pudota kaksoisnapauttamalla.",
  "dragStartedVirtual": "Vet\xE4minen aloitettu. Siirry pudotuskohteeseen ja pudota napsauttamalla tai painamalla Enter-n\xE4pp\xE4int\xE4.",
  "dropCanceled": "Pudotus peruutettu.",
  "dropComplete": "Pudotus suoritettu.",
  "dropDescriptionKeyboard": "Pudota painamalla Enter-n\xE4pp\xE4int\xE4. Peruuta vet\xE4minen painamalla Escape-n\xE4pp\xE4int\xE4.",
  "dropDescriptionTouch": "Pudota kaksoisnapauttamalla.",
  "dropDescriptionVirtual": "Pudota napsauttamalla.",
  "dropIndicator": "pudotuksen ilmaisin",
  "dropOnItem": args => "Pudota kohteeseen ".concat(args.itemText),
  "dropOnRoot": "Pudota kohteeseen",
  "endDragKeyboard": "Vedet\xE4\xE4n. Peruuta vet\xE4minen painamalla Enter-n\xE4pp\xE4int\xE4.",
  "endDragTouch": "Vedet\xE4\xE4n. Peruuta vet\xE4minen kaksoisnapauttamalla.",
  "endDragVirtual": "Vedet\xE4\xE4n. Peruuta vet\xE4minen napsauttamalla.",
  "insertAfter": args => "Lis\xE4\xE4 kohteen ".concat(args.itemText, " j\xE4lkeen"),
  "insertBefore": args => "Lis\xE4\xE4 ennen kohdetta ".concat(args.itemText),
  "insertBetween": args => "Lis\xE4\xE4 kohteiden ".concat(args.beforeItemText, " ja ").concat(args.afterItemText, " v\xE4liin")
};
var $9e248ec27f7dc55f$exports = {};
$9e248ec27f7dc55f$exports = {
  "dragDescriptionKeyboard": "Appuyez sur Entr\xE9e pour commencer le d\xE9placement.",
  "dragDescriptionKeyboardAlt": "Appuyez sur Alt\xA0+\xA0Entr\xE9e pour commencer \xE0 faire glisser.",
  "dragDescriptionLongPress": "Appuyez de mani\xE8re prolong\xE9e pour commencer \xE0 faire glisser.",
  "dragDescriptionTouch": "Touchez deux fois pour commencer le d\xE9placement.",
  "dragDescriptionVirtual": "Cliquez pour commencer le d\xE9placement.",
  "dragItem": args => "D\xE9placer ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "D\xE9placer ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9"),
    other: () => "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Appuyez sur Entr\xE9e pour faire glisser ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9"),
    other: () => "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Appuyez sur Alt\xA0+\xA0Entr\xE9e pour faire glisser ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9"),
    other: () => "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Appuyez de mani\xE8re prolong\xE9e pour faire glisser ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \xE9l\xE9ment s\xE9lectionn\xE9"),
    other: () => "".concat(formatter.number(args.count), " \xE9l\xE9ments s\xE9lectionn\xE9s")
  }), "."),
  "dragStartedKeyboard": "D\xE9placement commenc\xE9. Appuyez sur Tabulation pour acc\xE9der \xE0 une cible de d\xE9p\xF4t, puis appuyez sur Entr\xE9e pour d\xE9poser, ou appuyez sur \xC9chap pour annuler.",
  "dragStartedTouch": "D\xE9placement commenc\xE9. Acc\xE9dez \xE0 une cible de d\xE9p\xF4t, puis touchez deux fois pour d\xE9poser.",
  "dragStartedVirtual": "D\xE9placement commenc\xE9. Acc\xE9dez \xE0 une cible de d\xE9p\xF4t, puis cliquez ou appuyez sur Entr\xE9e pour d\xE9poser.",
  "dropCanceled": "D\xE9p\xF4t annul\xE9.",
  "dropComplete": "D\xE9p\xF4t termin\xE9.",
  "dropDescriptionKeyboard": "Appuyez sur Entr\xE9e pour d\xE9poser. Appuyez sur \xC9chap pour annuler le d\xE9placement.",
  "dropDescriptionTouch": "Touchez deux fois pour d\xE9poser.",
  "dropDescriptionVirtual": "Cliquez pour d\xE9poser.",
  "dropIndicator": "indicateur de d\xE9p\xF4t",
  "dropOnItem": args => "D\xE9poser sur ".concat(args.itemText),
  "dropOnRoot": "D\xE9poser sur",
  "endDragKeyboard": "D\xE9placement. Appuyez sur Entr\xE9e pour annuler le d\xE9placement.",
  "endDragTouch": "D\xE9placement. Touchez deux fois pour annuler le d\xE9placement.",
  "endDragVirtual": "D\xE9placement. Cliquez pour annuler le d\xE9placement.",
  "insertAfter": args => "Ins\xE9rer apr\xE8s ".concat(args.itemText),
  "insertBefore": args => "Ins\xE9rer avant ".concat(args.itemText),
  "insertBetween": args => "Ins\xE9rer entre ".concat(args.beforeItemText, " et ").concat(args.afterItemText)
};
var $6387f7228f0de45e$exports = {};
$6387f7228f0de45e$exports = {
  "dragDescriptionKeyboard": "\u05D4\u05E7\u05E9 \u05E2\u05DC Enter \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05DC\u05D2\u05E8\u05D5\u05E8.",
  "dragDescriptionKeyboardAlt": "\u05D4\u05E7\u05E9 Alt + Enter \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05DC\u05D2\u05E8\u05D5\u05E8.",
  "dragDescriptionLongPress": "\u05DC\u05D7\u05E5 \u05DC\u05D7\u05D9\u05E6\u05D4 \u05D0\u05E8\u05D5\u05DB\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05DC\u05D2\u05E8\u05D5\u05E8.",
  "dragDescriptionTouch": "\u05D4\u05E7\u05E9 \u05E4\u05E2\u05DE\u05D9\u05D9\u05DD \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05D1\u05D2\u05E8\u05D9\u05E8\u05D4.",
  "dragDescriptionVirtual": "\u05DC\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05DC\u05D2\u05E8\u05D5\u05E8.",
  "dragItem": args => "\u05D2\u05E8\u05D5\u05E8 \u05D0\u05EA ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "\u05D2\u05E8\u05D5\u05E8 ".concat(formatter.plural(args.count, {
    one: () => "\u05E4\u05E8\u05D9\u05D8 \u05E0\u05D1\u05D7\u05E8 ".concat(formatter.number(args.count)),
    other: () => "".concat(formatter.number(args.count), " \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E9\u05E0\u05D1\u05D7\u05E8\u05D5")
  })),
  "dragSelectedKeyboard": (args, formatter) => "\u05D4\u05E7\u05E9 \u05E2\u05DC Enter \u05DB\u05D3\u05D9 \u05DC\u05D2\u05E8\u05D5\u05E8 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u05E4\u05E8\u05D9\u05D8 \u05E9\u05E0\u05D1\u05D7\u05E8"),
    other: () => "".concat(formatter.number(args.count), " \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E9\u05E0\u05D1\u05D7\u05E8\u05D5")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "\u05D4\u05E7\u05E9 Alt + Enter \u05DB\u05D3\u05D9 \u05DC\u05D2\u05E8\u05D5\u05E8 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u05E4\u05E8\u05D9\u05D8 \u05E9\u05E0\u05D1\u05D7\u05E8"),
    other: () => "".concat(formatter.number(args.count), " \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E9\u05E0\u05D1\u05D7\u05E8\u05D5")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "\u05DC\u05D7\u05E5 \u05DC\u05D7\u05D9\u05E6\u05D4 \u05D0\u05E8\u05D5\u05DB\u05D4 \u05DB\u05D3\u05D9 \u05DC\u05D2\u05E8\u05D5\u05E8 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u05E4\u05E8\u05D9\u05D8 \u05E9\u05E0\u05D1\u05D7\u05E8"),
    other: () => "".concat(formatter.number(args.count), " \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E9\u05E0\u05D1\u05D7\u05E8\u05D5")
  }), "."),
  "dragStartedKeyboard": "\u05D4\u05EA\u05D7\u05DC\u05EA \u05DC\u05D2\u05E8\u05D5\u05E8. \u05D4\u05E7\u05E9 \u05E2\u05DC Tab \u05DB\u05D3\u05D9 \u05DC\u05E0\u05D5\u05D5\u05D8 \u05DC\u05E0\u05E7\u05D5\u05D3\u05EA \u05D4\u05D2\u05E8\u05D9\u05E8\u05D4 \u05D5\u05DC\u05D0\u05D7\u05E8 \u05DE\u05DB\u05DF \u05D4\u05E7\u05E9 \u05E2\u05DC Enter \u05DB\u05D3\u05D9 \u05DC\u05E9\u05D7\u05E8\u05E8 \u05D0\u05D5 \u05E2\u05DC Escape \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D8\u05DC.",
  "dragStartedTouch": "\u05D4\u05EA\u05D7\u05DC\u05EA \u05DC\u05D2\u05E8\u05D5\u05E8. \u05E0\u05D5\u05D5\u05D8 \u05DC\u05E0\u05E7\u05D5\u05D3\u05EA \u05D4\u05E9\u05D7\u05E8\u05D5\u05E8 \u05D5\u05DC\u05D0\u05D7\u05E8 \u05DE\u05DB\u05DF \u05D4\u05E7\u05E9 \u05E4\u05E2\u05DE\u05D9\u05D9\u05DD \u05DB\u05D3\u05D9 \u05DC\u05E9\u05D7\u05E8\u05E8.",
  "dragStartedVirtual": "\u05D4\u05EA\u05D7\u05DC\u05EA \u05DC\u05D2\u05E8\u05D5\u05E8. \u05E0\u05D5\u05D5\u05D8 \u05DC\u05E0\u05E7\u05D5\u05D3\u05EA \u05D4\u05E9\u05D7\u05E8\u05D5\u05E8 \u05D5\u05DC\u05D0\u05D7\u05E8 \u05DE\u05DB\u05DF \u05DC\u05D7\u05E5 \u05D0\u05D5 \u05D4\u05E7\u05E9 \u05E2\u05DC Enter \u05DB\u05D3\u05D9 \u05DC\u05E9\u05D7\u05E8\u05E8.",
  "dropCanceled": "\u05D4\u05E9\u05D7\u05E8\u05D5\u05E8 \u05D1\u05D5\u05D8\u05DC.",
  "dropComplete": "\u05D4\u05E9\u05D7\u05E8\u05D5\u05E8 \u05D4\u05D5\u05E9\u05DC\u05DD.",
  "dropDescriptionKeyboard": "\u05D4\u05E7\u05E9 \u05E2\u05DC Enter \u05DB\u05D3\u05D9 \u05DC\u05E9\u05D7\u05E8\u05E8. \u05D4\u05E7\u05E9 \u05E2\u05DC Escape \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D8\u05DC \u05D0\u05EA \u05D4\u05D2\u05E8\u05D9\u05E8\u05D4.",
  "dropDescriptionTouch": "\u05D4\u05E7\u05E9 \u05E4\u05E2\u05DE\u05D9\u05D9\u05DD \u05DB\u05D3\u05D9 \u05DC\u05E9\u05D7\u05E8\u05E8.",
  "dropDescriptionVirtual": "\u05DC\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05E9\u05D7\u05E8\u05E8.",
  "dropIndicator": "\u05DE\u05D7\u05D5\u05D5\u05DF \u05E9\u05D7\u05E8\u05D5\u05E8",
  "dropOnItem": args => "\u05E9\u05D7\u05E8\u05E8 \u05E2\u05DC ".concat(args.itemText),
  "dropOnRoot": "\u05E9\u05D7\u05E8\u05E8 \u05E2\u05DC",
  "endDragKeyboard": "\u05D2\u05D5\u05E8\u05E8. \u05D4\u05E7\u05E9 \u05E2\u05DC Enter \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D8\u05DC \u05D0\u05EA \u05D4\u05D2\u05E8\u05D9\u05E8\u05D4.",
  "endDragTouch": "\u05D2\u05D5\u05E8\u05E8. \u05D4\u05E7\u05E9 \u05E4\u05E2\u05DE\u05D9\u05D9\u05DD \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D8\u05DC \u05D0\u05EA \u05D4\u05D2\u05E8\u05D9\u05E8\u05D4.",
  "endDragVirtual": "\u05D2\u05D5\u05E8\u05E8. \u05DC\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D8\u05DC \u05D0\u05EA \u05D4\u05D2\u05E8\u05D9\u05E8\u05D4.",
  "insertAfter": args => "\u05D4\u05D5\u05E1\u05E3 \u05D0\u05D7\u05E8\u05D9 ".concat(args.itemText),
  "insertBefore": args => "\u05D4\u05D5\u05E1\u05E3 \u05DC\u05E4\u05E0\u05D9 ".concat(args.itemText),
  "insertBetween": args => "\u05D4\u05D5\u05E1\u05E3 \u05D1\u05D9\u05DF ".concat(args.beforeItemText, " \u05DC\u05D1\u05D9\u05DF ").concat(args.afterItemText)
};
var $34a283567735f754$exports = {};
$34a283567735f754$exports = {
  "dragDescriptionKeyboard": "Pritisnite Enter da biste po\u010Deli povla\u010Diti.",
  "dragDescriptionKeyboardAlt": "Pritisnite Alt + Enter za po\u010Detak povla\u010Denja.",
  "dragDescriptionLongPress": "Dugo pritisnite za po\u010Detak povla\u010Denja.",
  "dragDescriptionTouch": "Dvaput dodirnite da biste po\u010Deli povla\u010Diti.",
  "dragDescriptionVirtual": "Kliknite da biste po\u010Deli povla\u010Diti.",
  "dragItem": args => "Povucite stavku ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Povucite ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " odabranu stavku"),
    other: () => "ovoliko odabranih stavki: ".concat(formatter.number(args.count))
  })),
  "dragSelectedKeyboard": (args, formatter) => "Pritisnite Enter za povla\u010Denje ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " odabrana stavka"),
    other: () => "".concat(formatter.number(args.count), " odabrane stavke")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Pritisnite Alt + Enter za povla\u010Denje ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " odabrana stavka"),
    other: () => "".concat(formatter.number(args.count), " odabrane stavke")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Dugo pritisnite za povla\u010Denje ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " odabrana stavka"),
    other: () => "".concat(formatter.number(args.count), " odabrane stavke")
  }), "."),
  "dragStartedKeyboard": "Po\u010Deli ste povla\u010Diti. Pritisnite tipku tabulatora da biste do\u0161li do cilja ispu\u0161tanja, a zatim Enter da biste ispustili stavku ili Escape da biste prekinuli povla\u010Denje.",
  "dragStartedTouch": "Po\u010Deli ste povla\u010Diti. Do\u0111ite do cilja ispu\u0161tanja, a zatim dvaput dodirnite da biste ispustili stavku.",
  "dragStartedVirtual": "Po\u010Deli ste povla\u010Diti. Do\u0111ite do cilja ispu\u0161tanja, a zatim kliknite ili pritisnite Enter da biste ispustili stavku.",
  "dropCanceled": "Povla\u010Denje je prekinuto.",
  "dropComplete": "Ispu\u0161tanje je dovr\u0161eno.",
  "dropDescriptionKeyboard": "Pritisnite Enter da biste ispustili stavku. Pritisnite Escape da biste prekinuli povla\u010Denje.",
  "dropDescriptionTouch": "Dvaput dodirnite da biste ispustili stavku.",
  "dropDescriptionVirtual": "Kliknite da biste ispustili stavku.",
  "dropIndicator": "pokazatelj ispu\u0161tanja",
  "dropOnItem": args => "Ispustite na stavku ".concat(args.itemText),
  "dropOnRoot": "Ispustite na",
  "endDragKeyboard": "Povla\u010Denje. Pritisnite Enter da biste prekinuli povla\u010Denje.",
  "endDragTouch": "Povla\u010Denje. Dvaput dodirnite da biste prekinuli povla\u010Denje.",
  "endDragVirtual": "Povla\u010Denje. Kliknite da biste prekinuli povla\u010Denje.",
  "insertAfter": args => "Umetnite iza stavke ".concat(args.itemText),
  "insertBefore": args => "Ispustite ispred stavke ".concat(args.itemText),
  "insertBetween": args => "Umetnite izme\u0111u stavki ".concat(args.beforeItemText, " i ").concat(args.afterItemText)
};
var $466590c56bee4342$exports = {};
$466590c56bee4342$exports = {
  "dragDescriptionKeyboard": "Nyomja le az Enter billenty\u0171t a h\xFAz\xE1s megkezd\xE9s\xE9hez.",
  "dragDescriptionKeyboardAlt": "Nyomja le az Alt + Enter billenty\u0171ket a h\xFAz\xE1s megkezd\xE9s\xE9hez.",
  "dragDescriptionLongPress": "Hosszan nyomja meg a h\xFAz\xE1s elind\xEDt\xE1s\xE1hoz.",
  "dragDescriptionTouch": "Koppintson dupl\xE1n a h\xFAz\xE1s megkezd\xE9s\xE9hez.",
  "dragDescriptionVirtual": "Kattintson a h\xFAz\xE1s megkezd\xE9s\xE9hez.",
  "dragItem": args => "".concat(args.itemText, " h\xFAz\xE1sa"),
  "dragSelectedItems": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " kijel\xF6lt elem"),
    other: () => "".concat(formatter.number(args.count), " kijel\xF6lt elem")
  }), " h\xFAz\xE1sa"),
  "dragSelectedKeyboard": (args, formatter) => "Nyomja meg az Entert ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " kijel\xF6lt elem"),
    other: () => "".concat(formatter.number(args.count), " kijel\xF6lt elem")
  }), " h\xFAz\xE1s\xE1hoz."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Nyomja meg az Alt + Enter billenty\u0171ket ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " kijel\xF6lt elem"),
    other: () => "".concat(formatter.number(args.count), " kijel\xF6lt elem")
  }), " h\xFAz\xE1s\xE1hoz."),
  "dragSelectedLongPress": (args, formatter) => "Tartsa lenyomva hosszan ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " kijel\xF6lt elem"),
    other: () => "".concat(formatter.number(args.count), " kijel\xF6lt elem")
  }), " h\xFAz\xE1s\xE1hoz."),
  "dragStartedKeyboard": "H\xFAz\xE1s megkezdve. Nyomja le a Tab billenty\u0171t az elenged\xE9si c\xE9lhoz navig\xE1l\xE1s\xE1hoz, majd nyomja le az Enter billenty\u0171t az elenged\xE9shez, vagy nyomja le az Escape billenty\u0171t a megszak\xEDt\xE1shoz.",
  "dragStartedTouch": "H\xFAz\xE1s megkezdve. Navig\xE1ljon egy elenged\xE9si c\xE9lhoz, majd koppintson dupl\xE1n az elenged\xE9shez.",
  "dragStartedVirtual": "H\xFAz\xE1s megkezdve. Navig\xE1ljon egy elenged\xE9si c\xE9lhoz, majd kattintson vagy nyomja le az Enter billenty\u0171t az elenged\xE9shez.",
  "dropCanceled": "Elenged\xE9s megszak\xEDtva.",
  "dropComplete": "Elenged\xE9s teljes\xEDtve.",
  "dropDescriptionKeyboard": "Nyomja le az Enter billenty\u0171t az elenged\xE9shez. Nyomja le az Escape billenty\u0171t a h\xFAz\xE1s megszak\xEDt\xE1s\xE1hoz.",
  "dropDescriptionTouch": "Koppintson dupl\xE1n az elenged\xE9shez.",
  "dropDescriptionVirtual": "Kattintson az elenged\xE9shez.",
  "dropIndicator": "elenged\xE9sjelz\u0151",
  "dropOnItem": args => "Elenged\xE9s erre: ".concat(args.itemText),
  "dropOnRoot": "Elenged\xE9s erre:",
  "endDragKeyboard": "H\xFAz\xE1s folyamatban. Nyomja le az Enter billenty\u0171t a h\xFAz\xE1s megszak\xEDt\xE1s\xE1hoz.",
  "endDragTouch": "H\xFAz\xE1s folyamatban. Koppintson dupl\xE1n a h\xFAz\xE1s megszak\xEDt\xE1s\xE1hoz.",
  "endDragVirtual": "H\xFAz\xE1s folyamatban. Kattintson a h\xFAz\xE1s megszak\xEDt\xE1s\xE1hoz.",
  "insertAfter": args => "Besz\xFAr\xE1s ".concat(args.itemText, " ut\xE1n"),
  "insertBefore": args => "Besz\xFAr\xE1s ".concat(args.itemText, " el\xE9"),
  "insertBetween": args => "Besz\xFAr\xE1s ".concat(args.beforeItemText, " \xE9s ").concat(args.afterItemText, " k\xF6z\xE9")
};
var $e013896dcb6a6884$exports = {};
$e013896dcb6a6884$exports = {
  "dragDescriptionKeyboard": "Premi Invio per iniziare a trascinare.",
  "dragDescriptionKeyboardAlt": "Premi Alt + Invio per iniziare a trascinare.",
  "dragDescriptionLongPress": "Premi a lungo per iniziare a trascinare.",
  "dragDescriptionTouch": "Tocca due volte per iniziare a trascinare.",
  "dragDescriptionVirtual": "Fai clic per iniziare a trascinare.",
  "dragItem": args => "Trascina ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Trascina ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " altro elemento selezionato"),
    other: () => "".concat(formatter.number(args.count), " altri elementi selezionati")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Premi Invio per trascinare ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " elemento selezionato"),
    other: () => "".concat(formatter.number(args.count), " elementi selezionati")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Premi Alt + Invio per trascinare ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " elemento selezionato"),
    other: () => "".concat(formatter.number(args.count), " elementi selezionati")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Premi a lungo per trascinare ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " elemento selezionato"),
    other: () => "".concat(formatter.number(args.count), " elementi selezionati")
  }), "."),
  "dragStartedKeyboard": "Hai iniziato a trascinare. Premi Tab per arrivare sull\u2019area di destinazione, quindi premi Invio per rilasciare o Esc per annullare.",
  "dragStartedTouch": "Hai iniziato a trascinare. Arriva sull\u2019area di destinazione, quindi tocca due volte per rilasciare.",
  "dragStartedVirtual": "Hai iniziato a trascinare. Arriva sull\u2019area di destinazione, quindi fai clic o premi Invio per rilasciare.",
  "dropCanceled": "Rilascio annullato.",
  "dropComplete": "Rilascio completato.",
  "dropDescriptionKeyboard": "Premi Invio per rilasciare. Premi Esc per annullare.",
  "dropDescriptionTouch": "Tocca due volte per rilasciare.",
  "dropDescriptionVirtual": "Fai clic per rilasciare.",
  "dropIndicator": "indicatore di rilascio",
  "dropOnItem": args => "Rilascia su ".concat(args.itemText),
  "dropOnRoot": "Rilascia su",
  "endDragKeyboard": "Trascinamento. Premi Invio per annullare.",
  "endDragTouch": "Trascinamento. Tocca due volte per annullare.",
  "endDragVirtual": "Trascinamento. Fai clic per annullare.",
  "insertAfter": args => "Inserisci dopo ".concat(args.itemText),
  "insertBefore": args => "Inserisci prima di ".concat(args.itemText),
  "insertBetween": args => "Inserisci tra ".concat(args.beforeItemText, " e ").concat(args.afterItemText)
};
var $d6121e4246c6e502$exports = {};
$d6121e4246c6e502$exports = {
  "dragDescriptionKeyboard": "Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30C9\u30E9\u30C3\u30B0\u3092\u958B\u59CB\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  "dragDescriptionKeyboardAlt": "Alt+Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30C9\u30E9\u30C3\u30B0\u3092\u958B\u59CB\u3057\u307E\u3059\u3002",
  "dragDescriptionLongPress": "\u9577\u62BC\u3057\u3057\u3066\u30C9\u30E9\u30C3\u30B0\u3092\u958B\u59CB\u3057\u307E\u3059\u3002",
  "dragDescriptionTouch": "\u30C0\u30D6\u30EB\u30BF\u30C3\u30D7\u3057\u3066\u30C9\u30E9\u30C3\u30B0\u3092\u958B\u59CB\u3057\u307E\u3059\u3002",
  "dragDescriptionVirtual": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30C9\u30E9\u30C3\u30B0\u3092\u958B\u59CB\u3057\u307E\u3059\u3002",
  "dragItem": args => "".concat(args.itemText, " \u3092\u30C9\u30E9\u30C3\u30B0"),
  "dragSelectedItems": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u500B\u306E\u9078\u629E\u9805\u76EE"),
    other: () => "".concat(formatter.number(args.count), " \u500B\u306E\u9078\u629E\u9805\u76EE")
  }), " \u3092\u30C9\u30E9\u30C3\u30B0"),
  "dragSelectedKeyboard": (args, formatter) => "Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u3001".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u9078\u629E\u3057\u305F\u9805\u76EE"),
    other: () => "".concat(formatter.number(args.count), " \u9078\u629E\u3057\u305F\u9805\u76EE")
  }), "\u3092\u30C9\u30E9\u30C3\u30B0\u3057\u307E\u3059\u3002"),
  "dragSelectedKeyboardAlt": (args, formatter) => "Alt+Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u3001".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u9078\u629E\u3057\u305F\u9805\u76EE"),
    other: () => "".concat(formatter.number(args.count), " \u9078\u629E\u3057\u305F\u9805\u76EE")
  }), "\u3092\u30C9\u30E9\u30C3\u30B0\u3057\u307E\u3059\u3002"),
  "dragSelectedLongPress": (args, formatter) => "\u9577\u62BC\u3057\u3057\u3066\u3001".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u9078\u629E\u3057\u305F\u9805\u76EE"),
    other: () => "".concat(formatter.number(args.count), " \u9078\u629E\u3057\u305F\u9805\u76EE")
  }), "\u3092\u30C9\u30E9\u30C3\u30B0\u3057\u307E\u3059\u3002"),
  "dragStartedKeyboard": "\u30C9\u30E9\u30C3\u30B0\u3092\u958B\u59CB\u3057\u307E\u3059\u3002Tab \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30C9\u30ED\u30C3\u30D7\u30BF\u30FC\u30B2\u30C3\u30C8\u306B\u3044\u3069\u3046\u3057\u3001Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30C9\u30ED\u30C3\u30D7\u3059\u308B\u304B\u3001Esc \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u3002",
  "dragStartedTouch": "\u30C9\u30E9\u30C3\u30B0\u3092\u958B\u59CB\u3057\u307E\u3057\u305F\u3002\u30C9\u30ED\u30C3\u30D7\u306E\u30BF\u30FC\u30B2\u30C3\u30C8\u306B\u79FB\u52D5\u3057\u3001\u30C0\u30D6\u30EB\u30BF\u30C3\u30D7\u3057\u3066\u30C9\u30ED\u30C3\u30D7\u3057\u307E\u3059\u3002",
  "dragStartedVirtual": "\u30C9\u30E9\u30C3\u30B0\u3092\u958B\u59CB\u3057\u307E\u3057\u305F\u3002\u30C9\u30ED\u30C3\u30D7\u306E\u30BF\u30FC\u30B2\u30C3\u30C8\u306B\u79FB\u52D5\u3057\u3001\u30AF\u30EA\u30C3\u30AF\u307E\u305F\u306F Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30C9\u30ED\u30C3\u30D7\u3057\u307E\u3059\u3002",
  "dropCanceled": "\u30C9\u30ED\u30C3\u30D7\u304C\u30AD\u30E3\u30F3\u30BB\u30EB\u3055\u308C\u307E\u3057\u305F\u3002",
  "dropComplete": "\u30C9\u30ED\u30C3\u30D7\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002",
  "dropDescriptionKeyboard": "Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30C9\u30ED\u30C3\u30D7\u3057\u307E\u3059\u3002Esc \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30C9\u30E9\u30C3\u30B0\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u3002",
  "dropDescriptionTouch": "\u30C0\u30D6\u30EB\u30BF\u30C3\u30D7\u3057\u3066\u30C9\u30ED\u30C3\u30D7\u3057\u307E\u3059\u3002",
  "dropDescriptionVirtual": "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30C9\u30ED\u30C3\u30D7\u3057\u307E\u3059\u3002",
  "dropIndicator": "\u30C9\u30ED\u30C3\u30D7\u30A4\u30F3\u30B8\u30B1\u30FC\u30BF\u30FC",
  "dropOnItem": args => "".concat(args.itemText, " \u306B\u30C9\u30ED\u30C3\u30D7"),
  "dropOnRoot": "\u30C9\u30ED\u30C3\u30D7\u5834\u6240",
  "endDragKeyboard": "\u30C9\u30E9\u30C3\u30B0\u3057\u3066\u3044\u307E\u3059\u3002Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u30C9\u30E9\u30C3\u30B0\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u3002",
  "endDragTouch": "\u30C9\u30E9\u30C3\u30B0\u3057\u3066\u3044\u307E\u3059\u3002\u30C0\u30D6\u30EB\u30BF\u30C3\u30D7\u3057\u3066\u30C9\u30E9\u30C3\u30B0\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u3002",
  "endDragVirtual": "\u30C9\u30E9\u30C3\u30B0\u3057\u3066\u3044\u307E\u3059\u3002\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30C9\u30E9\u30C3\u30B0\u3092\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u3002",
  "insertAfter": args => "".concat(args.itemText, " \u306E\u5F8C\u306B\u633F\u5165"),
  "insertBefore": args => "".concat(args.itemText, " \u306E\u524D\u306B\u633F\u5165"),
  "insertBetween": args => "".concat(args.beforeItemText, " \u3068 ").concat(args.afterItemText, " \u306E\u9593\u306B\u633F\u5165")
};
var $cf48a963c482dcba$exports = {};
$cf48a963c482dcba$exports = {
  "dragDescriptionKeyboard": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC138\uC694.",
  "dragDescriptionKeyboardAlt": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 Alt + Enter\uB97C \uB204\uB974\uC2ED\uC2DC\uC624.",
  "dragDescriptionLongPress": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 \uAE38\uAC8C \uB204\uB974\uC2ED\uC2DC\uC624.",
  "dragDescriptionTouch": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 \uB354\uBE14 \uD0ED\uD558\uC138\uC694.",
  "dragDescriptionVirtual": "\uB4DC\uB798\uADF8\uB97C \uC2DC\uC791\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC138\uC694.",
  "dragItem": args => "".concat(args.itemText, " \uB4DC\uB798\uADF8"),
  "dragSelectedItems": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9"),
    other: () => "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9")
  }), " \uB4DC\uB798\uADF8"),
  "dragSelectedKeyboard": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9"),
    other: () => "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9")
  }), "\uC744 \uB4DC\uB798\uADF8\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC2ED\uC2DC\uC624."),
  "dragSelectedKeyboardAlt": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9"),
    other: () => "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9")
  }), "\uC744 \uB4DC\uB798\uADF8\uD558\uB824\uBA74 Alt + Enter\uB97C \uB204\uB974\uC2ED\uC2DC\uC624."),
  "dragSelectedLongPress": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9"),
    other: () => "".concat(formatter.number(args.count), "\uAC1C \uC120\uD0DD \uD56D\uBAA9")
  }), "\uC744 \uB4DC\uB798\uADF8\uD558\uB824\uBA74 \uAE38\uAC8C \uB204\uB974\uC2ED\uC2DC\uC624."),
  "dragStartedKeyboard": "\uB4DC\uB798\uADF8\uAC00 \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4. Tab\uC744 \uB20C\uB7EC \uB4DC\uB86D \uB300\uC0C1\uC73C\uB85C \uC774\uB3D9\uD55C \uB2E4\uC74C Enter\uB97C \uB20C\uB7EC \uB4DC\uB86D\uD558\uAC70\uB098 Esc\uB97C \uB20C\uB7EC \uCDE8\uC18C\uD558\uC138\uC694.",
  "dragStartedTouch": "\uB4DC\uB798\uADF8\uAC00 \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB4DC\uB86D \uB300\uC0C1\uC73C\uB85C \uC774\uB3D9\uD55C \uB2E4\uC74C \uB354\uBE14 \uD0ED\uD558\uC5EC \uB4DC\uB86D\uD558\uC138\uC694.",
  "dragStartedVirtual": "\uB4DC\uB798\uADF8\uAC00 \uC2DC\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4. \uB4DC\uB86D \uB300\uC0C1\uC73C\uB85C \uC774\uB3D9\uD55C \uB2E4\uC74C \uD074\uB9AD\uD558\uAC70\uB098 Enter\uB97C \uB20C\uB7EC \uB4DC\uB86D\uD558\uC138\uC694.",
  "dropCanceled": "\uB4DC\uB86D\uC774 \uCDE8\uC18C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  "dropComplete": "\uB4DC\uB86D\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
  "dropDescriptionKeyboard": "\uB4DC\uB86D\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC138\uC694. \uB4DC\uB798\uADF8\uB97C \uCDE8\uC18C\uD558\uB824\uBA74 Esc\uB97C \uB204\uB974\uC138\uC694.",
  "dropDescriptionTouch": "\uB354\uBE14 \uD0ED\uD558\uC5EC \uB4DC\uB86D\uD558\uC138\uC694.",
  "dropDescriptionVirtual": "\uB4DC\uB86D\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC138\uC694.",
  "dropIndicator": "\uB4DC\uB86D \uD45C\uC2DC\uAE30",
  "dropOnItem": args => "".concat(args.itemText, "\uC5D0 \uB4DC\uB86D"),
  "dropOnRoot": "\uB4DC\uB86D \uB300\uC0C1",
  "endDragKeyboard": "\uB4DC\uB798\uADF8 \uC911\uC785\uB2C8\uB2E4. \uB4DC\uB798\uADF8\uB97C \uCDE8\uC18C\uD558\uB824\uBA74 Enter\uB97C \uB204\uB974\uC138\uC694.",
  "endDragTouch": "\uB4DC\uB798\uADF8 \uC911\uC785\uB2C8\uB2E4. \uB4DC\uB798\uADF8\uB97C \uCDE8\uC18C\uD558\uB824\uBA74 \uB354\uBE14 \uD0ED\uD558\uC138\uC694.",
  "endDragVirtual": "\uB4DC\uB798\uADF8 \uC911\uC785\uB2C8\uB2E4. \uB4DC\uB798\uADF8\uB97C \uCDE8\uC18C\uD558\uB824\uBA74 \uD074\uB9AD\uD558\uC138\uC694.",
  "insertAfter": args => "".concat(args.itemText, " \uC774\uD6C4\uC5D0 \uC0BD\uC785"),
  "insertBefore": args => "".concat(args.itemText, " \uC774\uC804\uC5D0 \uC0BD\uC785"),
  "insertBetween": args => "".concat(args.beforeItemText, " \uBC0F ").concat(args.afterItemText, " \uC0AC\uC774\uC5D0 \uC0BD\uC785")
};
var $b156071f04f1c899$exports = {};
$b156071f04f1c899$exports = {
  "dragDescriptionKeyboard": "Paspauskite \u201EEnter\u201C, kad prad\u0117tum\u0117te vilkti.",
  "dragDescriptionKeyboardAlt": "Paspauskite \u201EAlt + Enter\u201C, kad prad\u0117tum\u0117te vilkti.",
  "dragDescriptionLongPress": "Palaikykite nuspaud\u0119, kad prad\u0117tum\u0117te vilkti.",
  "dragDescriptionTouch": "Palieskite dukart, kad prad\u0117tum\u0117te vilkti.",
  "dragDescriptionVirtual": "Spustel\u0117kite, kad prad\u0117tum\u0117te vilkti.",
  "dragItem": args => "Vilkti ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Vilkti ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " pasirinkt\u0105 element\u0105"),
    other: () => "".concat(formatter.number(args.count), " pasirinktus elementus")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Paspauskite \u201EEnter\u201C, jei norite nuvilkti ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " pasirinkt\u0105 element\u0105"),
    other: () => "".concat(formatter.number(args.count), " pasirinktus elementus")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Paspauskite \u201EAlt + Enter\u201C, kad nuvilktum\u0117te ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " pasirinkt\u0105 element\u0105"),
    other: () => "".concat(formatter.number(args.count), " pasirinktus elementus")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Nuspaud\u0119 palaikykite, kad nuvilktum\u0117te ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " pasirinkt\u0105 element\u0105"),
    other: () => "".concat(formatter.number(args.count), " pasirinktus elementus")
  }), "."),
  "dragStartedKeyboard": "Prad\u0117ta vilkti. Paspauskite \u201ETab\u201C, kad pereitum\u0117te \u012F tiesiogin\u0119 paskirties viet\u0105, tada paspauskite \u201EEnter\u201C, kad numestum\u0117te, arba \u201EEscape\u201C, kad at\u0161auktum\u0117te.",
  "dragStartedTouch": "Prad\u0117ta vilkti. Eikite \u012F tiesiogin\u0119 paskirties viet\u0105, tada palieskite dukart, kad numestum\u0117te.",
  "dragStartedVirtual": "Prad\u0117ta vilkti. Eikite \u012F tiesiogin\u0119 paskirties viet\u0105 ir spustel\u0117kite arba paspauskite \u201EEnter\u201C, kad numestum\u0117te.",
  "dropCanceled": "Numetimas at\u0161auktas.",
  "dropComplete": "Numesta.",
  "dropDescriptionKeyboard": "Paspauskite \u201EEnter\u201C, kad numestum\u0117te. Paspauskite \u201EEscape\u201C, kad at\u0161auktum\u0117te vilkim\u0105.",
  "dropDescriptionTouch": "Palieskite dukart, kad numestum\u0117te.",
  "dropDescriptionVirtual": "Spustel\u0117kite, kad numestum\u0117te.",
  "dropIndicator": "numetimo indikatorius",
  "dropOnItem": args => "Numesti ant ".concat(args.itemText),
  "dropOnRoot": "Numesti ant",
  "endDragKeyboard": "Velkama. Paspauskite \u201EEnter\u201C, kad at\u0161auktum\u0117te vilkim\u0105.",
  "endDragTouch": "Velkama. Spustel\u0117kite dukart, kad at\u0161auktum\u0117te vilkim\u0105.",
  "endDragVirtual": "Velkama. Spustel\u0117kite, kad at\u0161auktum\u0117te vilkim\u0105.",
  "insertAfter": args => "\u012Eterpti po ".concat(args.itemText),
  "insertBefore": args => "\u012Eterpti prie\u0161 ".concat(args.itemText),
  "insertBetween": args => "\u012Eterpti tarp ".concat(args.beforeItemText, " ir ").concat(args.afterItemText)
};
var $5300be8ef98d39fa$exports = {};
$5300be8ef98d39fa$exports = {
  "dragDescriptionKeyboard": "Nospiediet Enter, lai s\u0101ktu vilk\u0161anu.",
  "dragDescriptionKeyboardAlt": "Nospiediet tausti\u0146u kombin\u0101ciju Alt+Enter, lai s\u0101ktu vilk\u0161anu.",
  "dragDescriptionLongPress": "Turiet nospiestu, lai s\u0101ktu vilk\u0161anu.",
  "dragDescriptionTouch": "Veiciet dubultsk\u0101rienu, lai s\u0101ktu vilk\u0161anu.",
  "dragDescriptionVirtual": "Noklik\u0161\u0137iniet, lai s\u0101ktu vilk\u0161anu.",
  "dragItem": args => "Velciet ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Velciet ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " atlas\u012Bto vienumu"),
    other: () => "".concat(formatter.number(args.count), " atlas\u012Btos vienumus")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Nospiediet tausti\u0146u Enter, lai vilktu ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " atlas\u012Bto vienumu"),
    other: () => "".concat(formatter.number(args.count), " atlas\u012Btos vienumus")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Nospiediet tausti\u0146u kombin\u0101ciju Alt+Enter, lai vilktu ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " atlas\u012Bto vienumu"),
    other: () => "".concat(formatter.number(args.count), " atlas\u012Btos vienumus")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Turiet nospiestu, lai vilktu ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " atlas\u012Bto vienumu"),
    other: () => "".concat(formatter.number(args.count), " atlas\u012Btos vienumus")
  }), "."),
  "dragStartedKeyboard": "Uzs\u0101kta vilk\u0161ana. Nospiediet tausti\u0146u Tab, lai p\u0101rietu uz nome\u0161anas m\u0113r\u0137i, p\u0113c tam nospiediet Enter, lai nomestu, vai nospiediet Escape, lai atceltu.",
  "dragStartedTouch": "Uzs\u0101kta vilk\u0161ana. P\u0101rejiet uz nome\u0161anas m\u0113r\u0137i, p\u0113c tam veiciet dubultsk\u0101rienu, lai nomestu.",
  "dragStartedVirtual": "Uzs\u0101kta vilk\u0161ana. P\u0101rejiet uz nome\u0161anas m\u0113r\u0137i, p\u0113c tam nospiediet Enter, lai nomestu.",
  "dropCanceled": "Nome\u0161ana atcelta.",
  "dropComplete": "Nome\u0161ana pabeigta.",
  "dropDescriptionKeyboard": "Nospiediet Enter, lai nomestu. Nospiediet Escape, lai atceltu vilk\u0161anu.",
  "dropDescriptionTouch": "Veiciet dubultsk\u0101rienu, lai nomestu.",
  "dropDescriptionVirtual": "Noklik\u0161\u0137iniet, lai nomestu.",
  "dropIndicator": "nome\u0161anas indikators",
  "dropOnItem": args => "Nometiet uz ".concat(args.itemText),
  "dropOnRoot": "Nometiet uz",
  "endDragKeyboard": "Notiek vilk\u0161ana. Nospiediet Enter, lai atceltu vilk\u0161anu.",
  "endDragTouch": "Notiek vilk\u0161ana. Veiciet dubultsk\u0101rienu, lai atceltu vilk\u0161anu.",
  "endDragVirtual": "Notiek vilk\u0161ana. Noklik\u0161\u0137iniet, lai atceltu vilk\u0161anu.",
  "insertAfter": args => "Ievietojiet p\u0113c ".concat(args.itemText),
  "insertBefore": args => "Ievietojiet pirms ".concat(args.itemText),
  "insertBetween": args => "Ievietojiet starp ".concat(args.beforeItemText, " un ").concat(args.afterItemText)
};
var $7484477aad199932$exports = {};
$7484477aad199932$exports = {
  "dragDescriptionKeyboard": "Trykk p\xE5 Enter for \xE5 begynne \xE5 dra.",
  "dragDescriptionKeyboardAlt": "Trykk p\xE5 Alt + Enter for \xE5 begynne \xE5 dra.",
  "dragDescriptionLongPress": "Trykk lenge for \xE5 begynne \xE5 dra.",
  "dragDescriptionTouch": "Dobbelttrykk for \xE5 begynne \xE5 dra.",
  "dragDescriptionVirtual": "Klikk for \xE5 begynne \xE5 dra.",
  "dragItem": args => "Dra ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Dra ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " merket element"),
    other: () => "".concat(formatter.number(args.count), " merkede elementer")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Trykk Enter for \xE5 dra ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valgt element"),
    other: () => "".concat(formatter.number(args.count), " valgte elementer")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Trykk p\xE5 Alt + Enter for \xE5 dra ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valgt element"),
    other: () => "".concat(formatter.number(args.count), " valgte elementer")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Trykk lenge for \xE5 dra ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valgt element"),
    other: () => "".concat(formatter.number(args.count), " valgte elementer")
  }), "."),
  "dragStartedKeyboard": "Begynte \xE5 dra. Trykk p\xE5 Tab for \xE5 navigere til et m\xE5l, og trykk deretter p\xE5 Enter for \xE5 slippe eller p\xE5 Esc for \xE5 avbryte.",
  "dragStartedTouch": "Begynte \xE5 dra. Naviger til et m\xE5l, og dobbelttrykk for \xE5 slippe.",
  "dragStartedVirtual": "Begynte \xE5 dra. Naviger til et m\xE5l, og klikk eller trykk p\xE5 Enter for \xE5 slippe.",
  "dropCanceled": "Avbr\xF8t slipping.",
  "dropComplete": "Slippingen er fullf\xF8rt.",
  "dropDescriptionKeyboard": "Trykk p\xE5 Enter for \xE5 slippe. Trykk p\xE5 Esc hvis du vil avbryte draingen.",
  "dropDescriptionTouch": "Dobbelttrykk for \xE5 slippe.",
  "dropDescriptionVirtual": "Klikk for \xE5 slippe.",
  "dropIndicator": "slippeindikator",
  "dropOnItem": args => "Slipp p\xE5 ".concat(args.itemText),
  "dropOnRoot": "Slipp p\xE5",
  "endDragKeyboard": "Drar. Trykk p\xE5 Enter hvis du vil avbryte.",
  "endDragTouch": "Drar. Dobbelttrykk hvis du vil avbryte.",
  "endDragVirtual": "Drar. Klikk hvis du vil avbryte.",
  "insertAfter": args => "Sett inn etter ".concat(args.itemText),
  "insertBefore": args => "Sett inn f\xF8r ".concat(args.itemText),
  "insertBetween": args => "Sett inn mellom ".concat(args.beforeItemText, " og ").concat(args.afterItemText)
};
var $968e09cb41d6cd76$exports = {};
$968e09cb41d6cd76$exports = {
  "dragDescriptionKeyboard": "Druk op Enter om te slepen.",
  "dragDescriptionKeyboardAlt": "Druk op Alt + Enter om te slepen.",
  "dragDescriptionLongPress": "Houd lang ingedrukt om te slepen.",
  "dragDescriptionTouch": "Dubbeltik om te slepen.",
  "dragDescriptionVirtual": "Klik om met slepen te starten.",
  "dragItem": args => "".concat(args.itemText, " slepen"),
  "dragSelectedItems": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " geselecteerd item"),
    other: () => "".concat(formatter.number(args.count), " geselecteerde items")
  }), " slepen"),
  "dragSelectedKeyboard": (args, formatter) => "Druk op Enter om ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " geselecteerd item"),
    other: () => "".concat(formatter.number(args.count), " geselecteerde items")
  }), " te slepen."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Druk op Alt + Enter om ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " geselecteerd item"),
    other: () => "".concat(formatter.number(args.count), " geselecteerde items")
  }), " te slepen."),
  "dragSelectedLongPress": (args, formatter) => "Houd lang ingedrukt om ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " geselecteerd item"),
    other: () => "".concat(formatter.number(args.count), " geselecteerde items")
  }), " te slepen."),
  "dragStartedKeyboard": "Begonnen met slepen. Druk op Tab om naar een locatie te gaan. Druk dan op Enter om neer te zetten, of op Esc om te annuleren.",
  "dragStartedTouch": "Begonnen met slepen. Ga naar de gewenste locatie en dubbeltik om neer te zetten.",
  "dragStartedVirtual": "Begonnen met slepen. Ga naar de gewenste locatie en klik of druk op Enter om neer te zetten.",
  "dropCanceled": "Neerzetten geannuleerd.",
  "dropComplete": "Neerzetten voltooid.",
  "dropDescriptionKeyboard": "Druk op Enter om neer te zetten. Druk op Esc om het slepen te annuleren.",
  "dropDescriptionTouch": "Dubbeltik om neer te zetten.",
  "dropDescriptionVirtual": "Klik om neer te zetten.",
  "dropIndicator": "aanwijzer voor neerzetten",
  "dropOnItem": args => "Neerzetten op ".concat(args.itemText),
  "dropOnRoot": "Neerzetten op",
  "endDragKeyboard": "Bezig met slepen. Druk op Enter om te annuleren.",
  "endDragTouch": "Bezig met slepen. Dubbeltik om te annuleren.",
  "endDragVirtual": "Bezig met slepen. Klik om te annuleren.",
  "insertAfter": args => "Plaatsen na ".concat(args.itemText),
  "insertBefore": args => "Plaatsen v\xF3\xF3r ".concat(args.itemText),
  "insertBetween": args => "Plaatsen tussen ".concat(args.beforeItemText, " en ").concat(args.afterItemText)
};
var $0c2c6c954dd638d7$exports = {};
$0c2c6c954dd638d7$exports = {
  "dragDescriptionKeyboard": "Naci\u015Bnij Enter, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragDescriptionKeyboardAlt": "Naci\u015Bnij Alt + Enter, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragDescriptionLongPress": "Naci\u015Bnij i przytrzymaj, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragDescriptionTouch": "Dotknij dwukrotnie, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragDescriptionVirtual": "Kliknij, aby rozpocz\u0105\u0107 przeci\u0105ganie.",
  "dragItem": args => "Przeci\u0105gnij ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Przeci\u0105gnij ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " wybrany element"),
    other: () => "".concat(formatter.number(args.count), " wybranych element\xF3w")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Naci\u015Bnij Enter, aby przeci\u0105gn\u0105\u0107 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " wybrany element"),
    other: () => "".concat(formatter.number(args.count), " wybrane(-ych) elementy(-\xF3w)")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Naci\u015Bnij Alt + Enter, aby przeci\u0105gn\u0105\u0107 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " wybrany element"),
    other: () => "".concat(formatter.number(args.count), " wybrane(-ych) elementy(-\xF3w)")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Naci\u015Bnij i przytrzymaj, aby przeci\u0105gn\u0105\u0107 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " wybrany element"),
    other: () => "".concat(formatter.number(args.count), " wybrane(-ych) elementy(-\xF3w)")
  }), "."),
  "dragStartedKeyboard": "Rozpocz\u0119to przeci\u0105ganie. Naci\u015Bnij Tab, aby wybra\u0107 miejsce docelowe, a nast\u0119pnie naci\u015Bnij Enter, aby upu\u015Bci\u0107, lub Escape, aby anulowa\u0107.",
  "dragStartedTouch": "Rozpocz\u0119to przeci\u0105ganie. Wybierz miejsce, w kt\xF3rym chcesz upu\u015Bci\u0107 element, a nast\u0119pnie dotknij dwukrotnie, aby upu\u015Bci\u0107.F",
  "dragStartedVirtual": "Rozpocz\u0119to przeci\u0105ganie. Wybierz miejsce, w kt\xF3rym chcesz upu\u015Bci\u0107 element, a nast\u0119pnie kliknij lub naci\u015Bnij Enter, aby upu\u015Bci\u0107.",
  "dropCanceled": "Anulowano upuszczenie.",
  "dropComplete": "Zako\u0144czono upuszczanie.",
  "dropDescriptionKeyboard": "Naci\u015Bnij Enter, aby upu\u015Bci\u0107. Naci\u015Bnij Escape, aby anulowa\u0107 przeci\u0105gni\u0119cie.",
  "dropDescriptionTouch": "Dotknij dwukrotnie, aby upu\u015Bci\u0107.",
  "dropDescriptionVirtual": "Kliknij, aby upu\u015Bci\u0107.",
  "dropIndicator": "wska\u017Anik upuszczenia",
  "dropOnItem": args => "Upu\u015B\u0107 na ".concat(args.itemText),
  "dropOnRoot": "Upu\u015B\u0107",
  "endDragKeyboard": "Przeci\u0105ganie. Naci\u015Bnij Enter, aby anulowa\u0107 przeci\u0105gni\u0119cie.",
  "endDragTouch": "Przeci\u0105ganie. Kliknij dwukrotnie, aby anulowa\u0107 przeci\u0105gni\u0119cie.",
  "endDragVirtual": "Przeci\u0105ganie. Kliknij, aby anulowa\u0107 przeci\u0105ganie.",
  "insertAfter": args => "Umie\u015B\u0107 za ".concat(args.itemText),
  "insertBefore": args => "Umie\u015B\u0107 przed ".concat(args.itemText),
  "insertBetween": args => "Umie\u015B\u0107 mi\u0119dzy ".concat(args.beforeItemText, " i ").concat(args.afterItemText)
};
var $db510f249c1f2e00$exports = {};
$db510f249c1f2e00$exports = {
  "dragDescriptionKeyboard": "Pressione Enter para come\xE7ar a arrastar.",
  "dragDescriptionKeyboardAlt": "Pressione Alt + Enter para come\xE7ar a arrastar.",
  "dragDescriptionLongPress": "Pressione e segure para come\xE7ar a arrastar.",
  "dragDescriptionTouch": "Toque duas vezes para come\xE7ar a arrastar.",
  "dragDescriptionVirtual": "Clique para come\xE7ar a arrastar.",
  "dragItem": args => "Arrastar ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Arrastar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " item selecionado"),
    other: () => "".concat(formatter.number(args.count), " itens selecionados")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Pressione Enter para arrastar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " o item selecionado"),
    other: () => "".concat(formatter.number(args.count), " os itens selecionados")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Pressione Alt + Enter para arrastar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " o item selecionado"),
    other: () => "".concat(formatter.number(args.count), " os itens selecionados")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Pressione e segure para arrastar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " o item selecionado"),
    other: () => "".concat(formatter.number(args.count), " os itens selecionados")
  }), "."),
  "dragStartedKeyboard": "Comece a arrastar. Pressione Tab para navegar at\xE9 um alvo e, em seguida, pressione Enter para soltar ou pressione Escape para cancelar.",
  "dragStartedTouch": "Comece a arrastar. Navegue at\xE9 um alvo e toque duas vezes para soltar.",
  "dragStartedVirtual": "Comece a arrastar. Navegue at\xE9 um alvo e clique ou pressione Enter para soltar.",
  "dropCanceled": "Libera\xE7\xE3o cancelada.",
  "dropComplete": "Libera\xE7\xE3o conclu\xEDda.",
  "dropDescriptionKeyboard": "Pressione Enter para soltar. Pressione Escape para cancelar.",
  "dropDescriptionTouch": "Toque duas vezes para soltar.",
  "dropDescriptionVirtual": "Clique para soltar.",
  "dropIndicator": "indicador de libera\xE7\xE3o",
  "dropOnItem": args => "Soltar em ".concat(args.itemText),
  "dropOnRoot": "Soltar",
  "endDragKeyboard": "Arrastando. Pressione Enter para cancelar.",
  "endDragTouch": "Arrastando. Toque duas vezes para cancelar.",
  "endDragVirtual": "Arrastando. Clique para cancelar.",
  "insertAfter": args => "Inserir ap\xF3s ".concat(args.itemText),
  "insertBefore": args => "Inserir antes de ".concat(args.itemText),
  "insertBetween": args => "Inserir entre ".concat(args.beforeItemText, " e ").concat(args.afterItemText)
};
var $d734686296d37387$exports = {};
$d734686296d37387$exports = {
  "dragDescriptionKeyboard": "Prima Enter para iniciar o arrasto.",
  "dragDescriptionKeyboardAlt": "Prima Alt + Enter para iniciar o arrasto.",
  "dragDescriptionLongPress": "Prima longamente para come\xE7ar a arrastar.",
  "dragDescriptionTouch": "Fa\xE7a duplo toque para come\xE7ar a arrastar.",
  "dragDescriptionVirtual": "Clique para iniciar o arrasto.",
  "dragItem": args => "Arrastar ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Arrastar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " item selecionado"),
    other: () => "".concat(formatter.number(args.count), " itens selecionados")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Prima Enter para arrastar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " o item selecionado"),
    other: () => "".concat(formatter.number(args.count), " os itens selecionados")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Prima Alt + Enter para arrastar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " o item selecionado"),
    other: () => "".concat(formatter.number(args.count), " os itens selecionados")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Prima longamente para arrastar ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " o item selecionado"),
    other: () => "".concat(formatter.number(args.count), " os itens selecionados")
  }), "."),
  "dragStartedKeyboard": "Arrasto iniciado. Prima a tecla de tabula\xE7\xE3o para navegar para um destino para largar, e em seguida prima Enter para largar ou prima Escape para cancelar.",
  "dragStartedTouch": "Arrasto iniciado. Navegue para um destino para largar, e em seguida fa\xE7a duplo toque para largar.",
  "dragStartedVirtual": "Arrasto iniciado. Navegue para um destino para largar, e em seguida clique ou prima Enter para largar.",
  "dropCanceled": "Largar cancelado.",
  "dropComplete": "Largar completo.",
  "dropDescriptionKeyboard": "Prima Enter para largar. Prima Escape para cancelar o arrasto.",
  "dropDescriptionTouch": "Fa\xE7a duplo toque para largar.",
  "dropDescriptionVirtual": "Clique para largar.",
  "dropIndicator": "Indicador de largar",
  "dropOnItem": args => "Largar em ".concat(args.itemText),
  "dropOnRoot": "Largar em",
  "endDragKeyboard": "A arrastar. Prima Enter para cancelar o arrasto.",
  "endDragTouch": "A arrastar. Fa\xE7a duplo toque para cancelar o arrasto.",
  "endDragVirtual": "A arrastar. Clique para cancelar o arrasto.",
  "insertAfter": args => "Inserir depois de ".concat(args.itemText),
  "insertBefore": args => "Inserir antes de ".concat(args.itemText),
  "insertBetween": args => "Inserir entre ".concat(args.beforeItemText, " e ").concat(args.afterItemText)
};
var $d239d4998a584a23$exports = {};
$d239d4998a584a23$exports = {
  "dragDescriptionKeyboard": "Ap\u0103sa\u021Bi pe Enter pentru a \xEEncepe glisarea.",
  "dragDescriptionKeyboardAlt": "Ap\u0103sa\u021Bi pe Alt + Enter pentru a \xEEncepe glisarea.",
  "dragDescriptionLongPress": "Ap\u0103sa\u021Bi lung pentru a \xEEncepe glisarea.",
  "dragDescriptionTouch": "Atinge\u021Bi de dou\u0103 ori pentru a \xEEncepe s\u0103 glisa\u021Bi.",
  "dragDescriptionVirtual": "Face\u021Bi clic pentru a \xEEncepe glisarea.",
  "dragItem": args => "Glisa\u021Bi ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Glisa\u021Bi ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " element selectat"),
    other: () => "".concat(formatter.number(args.count), " elemente selectate")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Ap\u0103sa\u021Bi pe Enter pentru a glisa ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " element selectat"),
    other: () => "".concat(formatter.number(args.count), " elemente selectate")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Ap\u0103sa\u021Bi pe Alt + Enter pentru a glisa ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " element selectat"),
    other: () => "".concat(formatter.number(args.count), " elemente selectate")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Ap\u0103sa\u021Bi lung pentru a glisa ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " element selectat"),
    other: () => "".concat(formatter.number(args.count), " elemente selectate")
  }), "."),
  "dragStartedKeyboard": "A \xEEnceput glisarea. Ap\u0103sa\u021Bi pe Tab pentru a naviga la o \u021Bint\u0103 de fixare, apoi ap\u0103sa\u021Bi pe Enter pentru a fixa sau ap\u0103sa\u021Bi pe Escape pentru a anula glisarea.",
  "dragStartedTouch": "A \xEEnceput glisarea. Naviga\u021Bi la o \u021Bint\u0103 de fixare, apoi atinge\u021Bi de dou\u0103 ori pentru a fixa.",
  "dragStartedVirtual": "A \xEEnceput glisarea. Naviga\u021Bi la o \u021Bint\u0103 de fixare, apoi face\u021Bi clic sau ap\u0103sa\u021Bi pe Enter pentru a fixa.",
  "dropCanceled": "Fixare anulat\u0103.",
  "dropComplete": "Fixare finalizat\u0103.",
  "dropDescriptionKeyboard": "Ap\u0103sa\u021Bi pe Enter pentru a fixa. Ap\u0103sa\u021Bi pe Escape pentru a anula glisarea.",
  "dropDescriptionTouch": "Atinge\u021Bi de dou\u0103 ori pentru a fixa.",
  "dropDescriptionVirtual": "Face\u021Bi clic pentru a fixa.",
  "dropIndicator": "indicator de fixare",
  "dropOnItem": args => "Fixa\u021Bi pe ".concat(args.itemText),
  "dropOnRoot": "Fixare pe",
  "endDragKeyboard": "Se gliseaz\u0103. Ap\u0103sa\u021Bi pe Enter pentru a anula glisarea.",
  "endDragTouch": "Se gliseaz\u0103. Atinge\u021Bi de dou\u0103 ori pentru a anula glisarea.",
  "endDragVirtual": "Se gliseaz\u0103. Face\u021Bi clic pentru a anula glisarea.",
  "insertAfter": args => "Insera\u021Bi dup\u0103 ".concat(args.itemText),
  "insertBefore": args => "Insera\u021Bi \xEEnainte de ".concat(args.itemText),
  "insertBetween": args => "Insera\u021Bi \xEEntre ".concat(args.beforeItemText, " \u0219i ").concat(args.afterItemText)
};
var $a06126b47eabe64f$exports = {};
$a06126b47eabe64f$exports = {
  "dragDescriptionKeyboard": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Enter \u0434\u043B\u044F \u043D\u0430\u0447\u0430\u043B\u0430 \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F.",
  "dragDescriptionKeyboardAlt": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 Alt + Enter, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u0442\u044C.",
  "dragDescriptionLongPress": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438 \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0439\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u0442\u044C.",
  "dragDescriptionTouch": "\u0414\u0432\u0430\u0436\u0434\u044B \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043D\u0430\u0447\u0430\u043B\u0430 \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F.",
  "dragDescriptionVirtual": "\u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435 \u0434\u043B\u044F \u043D\u0430\u0447\u0430\u043B\u0430 \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F.",
  "dragItem": args => "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u044C ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u044C ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u044D\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u044D\u043B\u0435\u043C")
  })),
  "dragSelectedKeyboard": (args, formatter) => "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 Enter \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430"),
    other: () => "".concat(formatter.number(args.count), " \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 Alt + Enter \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430"),
    other: () => "".concat(formatter.number(args.count), " \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0438 \u0443\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0439\u0442\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430"),
    other: () => "".concat(formatter.number(args.count), " \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432")
  }), "."),
  "dragStartedKeyboard": "\u041D\u0430\u0447\u0430\u0442\u043E \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Tab \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430 \u0446\u0435\u043B\u0438, \u0437\u0430\u0442\u0435\u043C \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Enter, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435, \u0438\u043B\u0438 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Escape \u0434\u043B\u044F \u043E\u0442\u043C\u0435\u043D\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F.",
  "dragStartedTouch": "\u041D\u0430\u0447\u0430\u0442\u043E \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435. \u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0446\u0435\u043B\u044C, \u0437\u0430\u0442\u0435\u043C \u0434\u0432\u0430\u0436\u0434\u044B \u043D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435.",
  "dragStartedVirtual": "\u041D\u0430\u0447\u0430\u0442\u043E \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Tab \u0434\u043B\u044F \u0432\u044B\u0431\u043E\u0440\u0430 \u0446\u0435\u043B\u0438, \u0437\u0430\u0442\u0435\u043C \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Enter, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435.",
  "dropCanceled": "\u041F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u043E.",
  "dropComplete": "\u041F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E.",
  "dropDescriptionKeyboard": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Enter, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Escape \u0434\u043B\u044F \u043E\u0442\u043C\u0435\u043D\u044B.",
  "dropDescriptionTouch": "\u0414\u0432\u0430\u0436\u0434\u044B \u043D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435.",
  "dropDescriptionVirtual": "\u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435.",
  "dropIndicator": "\u0438\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F",
  "dropOnItem": args => "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u044C \u043D\u0430 ".concat(args.itemText),
  "dropOnRoot": "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u044C \u043D\u0430",
  "endDragKeyboard": "\u041F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043B\u0430\u0432\u0438\u0448\u0443 Enter \u0434\u043B\u044F \u043E\u0442\u043C\u0435\u043D\u044B.",
  "endDragTouch": "\u041F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435. \u0414\u0432\u0430\u0436\u0434\u044B \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043E\u0442\u043C\u0435\u043D\u044B.",
  "endDragVirtual": "\u041F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u0435. \u0429\u0435\u043B\u043A\u043D\u0438\u0442\u0435 \u0434\u043B\u044F \u043E\u0442\u043C\u0435\u043D\u044B.",
  "insertAfter": args => "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0441\u043B\u0435 ".concat(args.itemText),
  "insertBefore": args => "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u0435\u0440\u0435\u0434 ".concat(args.itemText),
  "insertBetween": args => "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043C\u0435\u0436\u0434\u0443 ".concat(args.beforeItemText, " \u0438 ").concat(args.afterItemText)
};
var $0983413fc05d96fb$exports = {};
$0983413fc05d96fb$exports = {
  "dragDescriptionKeyboard": "Stla\u010Den\xEDm kl\xE1vesu Enter za\u010Dnete pres\xFAvanie.",
  "dragDescriptionKeyboardAlt": "Stla\u010Den\xEDm kl\xE1vesov Alt + Enter za\u010Dnete pres\xFAvanie.",
  "dragDescriptionLongPress": "Dlh\xFDm stla\u010Den\xEDm za\u010Dnete pres\xFAvanie.",
  "dragDescriptionTouch": "Dvojit\xFDm kliknut\xEDm za\u010Dnete pres\xFAvanie.",
  "dragDescriptionVirtual": "Kliknut\xEDm za\u010Dnete pres\xFAvanie.",
  "dragItem": args => "Presun\xFA\u0165 polo\u017Eku ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Presun\xFA\u0165 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " vybrat\xFA polo\u017Eku"),
    other: () => "".concat(formatter.number(args.count), " vybrat\xE9 polo\u017Eky")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Stla\u010Den\xEDm kl\xE1vesu Enter presuniete ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " vybrat\xFA polo\u017Eku"),
    other: () => "".concat(formatter.number(args.count), " vybrat\xFDch polo\u017Eiek")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Stla\u010Den\xEDm kl\xE1vesov Alt + Enter presuniete ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " vybrat\xFA polo\u017Eku"),
    other: () => "".concat(formatter.number(args.count), " vybrat\xFDch polo\u017Eiek")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Dlh\xFDm stla\u010Den\xEDm presuniete ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " vybrat\xFA polo\u017Eku"),
    other: () => "".concat(formatter.number(args.count), " vybrat\xFDch polo\u017Eiek")
  }), "."),
  "dragStartedKeyboard": "Pres\xFAvanie sa za\u010Dalo. Do cie\u013Eov\xE9ho umiestnenia prejdete stla\u010Den\xEDm kl\xE1vesu Tab. Ak chcete polo\u017Eku umiestni\u0165, stla\u010Dte kl\xE1ves Enter alebo stla\u010Dte kl\xE1ves Esc, ak chcete pres\xFAvanie zru\u0161i\u0165.",
  "dragStartedTouch": "Pres\xFAvanie sa za\u010Dalo. Prejdite na cie\u013Eov\xE9 umiestnenie a dvojit\xFDm kliknut\xEDm umiestnite polo\u017Eku.",
  "dragStartedVirtual": "Pres\xFAvanie sa za\u010Dalo. Prejdite na cie\u013Eov\xE9 umiestnenie a kliknut\xEDm alebo stla\u010Den\xEDm kl\xE1vesu Enter umiestnite polo\u017Eku.",
  "dropCanceled": "Umiestnenie zru\u0161en\xE9.",
  "dropComplete": "Umiestnenie dokon\u010Den\xE9.",
  "dropDescriptionKeyboard": "Stla\u010Den\xEDm kl\xE1vesu Enter umiestnite polo\u017Eku. Stla\u010Den\xEDm kl\xE1vesu Esc zru\u0161\xEDte pres\xFAvanie.",
  "dropDescriptionTouch": "Dvojit\xFDm kliknut\xEDm umiestnite polo\u017Eku.",
  "dropDescriptionVirtual": "Kliknut\xEDm umiestnite polo\u017Eku.",
  "dropIndicator": "indik\xE1tor umiestnenia",
  "dropOnItem": args => "Umiestni\u0165 na polo\u017Eku ".concat(args.itemText),
  "dropOnRoot": "Umiestni\u0165 na",
  "endDragKeyboard": "Prebieha pres\xFAvanie. Ak ho chcete zru\u0161i\u0165, stla\u010Dte kl\xE1ves Enter.",
  "endDragTouch": "Prebieha pres\xFAvanie. Dvojit\xFDm kliknut\xEDm ho m\xF4\u017Eete zru\u0161i\u0165.",
  "endDragVirtual": "Prebieha pres\xFAvanie.",
  "insertAfter": args => "Vlo\u017Ei\u0165 za polo\u017Eku ".concat(args.itemText),
  "insertBefore": args => "Vlo\u017Ei\u0165 pred polo\u017Eku ".concat(args.itemText),
  "insertBetween": args => "Vlo\u017Ei\u0165 medzi polo\u017Eky ".concat(args.beforeItemText, " a ").concat(args.afterItemText)
};
var $c66896a0464692f1$exports = {};
$c66896a0464692f1$exports = {
  "dragDescriptionKeyboard": "Pritisnite tipko Enter za za\u010Detek vle\u010Denja.",
  "dragDescriptionKeyboardAlt": "Pritisnite tipki Alt + Enter za za\u010Detek vle\u010Denja.",
  "dragDescriptionLongPress": "Pritisnite in zadr\u017Eite za za\u010Detek vle\u010Denja.",
  "dragDescriptionTouch": "Dvotapnite za za\u010Detek vle\u010Denja.",
  "dragDescriptionVirtual": "Kliknite za za\u010Detek vle\u010Denja.",
  "dragItem": args => "Povleci ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Povlecite ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " izbran element"),
    other: () => "izbrane elemente (".concat(formatter.number(args.count), ")")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Pritisnite tipko Enter, da povle\u010Dete ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " izbrani element"),
    other: () => "".concat(formatter.number(args.count), " izbranih elementov")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Pritisnite tipki Alt + Enter, da povle\u010Dete ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " izbrani element"),
    other: () => "".concat(formatter.number(args.count), " izbranih elementov")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Pritisnite in zadr\u017Eite, da povle\u010Dete ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " izbrani element"),
    other: () => "".concat(formatter.number(args.count), " izbranih elementov")
  }), "."),
  "dragStartedKeyboard": "Vle\u010Denje se je za\u010Delo. Pritisnite tipko Tab za pomik na mesto, kamor \u017Eelite spustiti elemente, in pritisnite tipko Enter, da jih spustite, ali tipko Escape, da prekli\u010Dete postopek.",
  "dragStartedTouch": "Vle\u010Denje se je za\u010Delo. Pomaknite se na mesto, kamor \u017Eelite spustiti elemente, in dvotapnite, da jih spustite.",
  "dragStartedVirtual": "Vle\u010Denje se je za\u010Delo. Pomaknite se na mesto, kamor \u017Eelite spustiti elemente, in kliknite ali pritisnite tipko Enter, da jih spustite.",
  "dropCanceled": "Spust je preklican.",
  "dropComplete": "Spust je kon\u010Dan.",
  "dropDescriptionKeyboard": "Pritisnite tipko Enter, da spustite. Pritisnite tipko Escape, da prekli\u010Dete vle\u010Denje.",
  "dropDescriptionTouch": "Dvotapnite, da spustite.",
  "dropDescriptionVirtual": "Kliknite, da spustite.",
  "dropIndicator": "indikator spusta",
  "dropOnItem": args => "Spusti na mesto ".concat(args.itemText),
  "dropOnRoot": "Spusti na mesto",
  "endDragKeyboard": "Vle\u010Denje. Pritisnite tipko Enter za preklic vle\u010Denja.",
  "endDragTouch": "Vle\u010Denje. Dvotapnite za preklic vle\u010Denja.",
  "endDragVirtual": "Vle\u010Denje. Kliknite, da prekli\u010Dete vle\u010Denje.",
  "insertAfter": args => "Vstavi za ".concat(args.itemText),
  "insertBefore": args => "Vstavi pred ".concat(args.itemText),
  "insertBetween": args => "Vstavi med ".concat(args.beforeItemText, " in ").concat(args.afterItemText)
};
var $f0d9abe43a1bcdf6$exports = {};
$f0d9abe43a1bcdf6$exports = {
  "dragItem": args => "Prevucite ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Prevucite ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " izabranu stavku"),
    other: () => "".concat(formatter.number(args.count), " izabrane stavke")
  })),
  "dragDescriptionKeyboard": "Pritisnite Enter da biste zapo\u010Deli prevla\u010Denje..",
  "dragDescriptionKeyboardAlt": "Pritisnite Alt + Enter da biste zapo\u010Deli prevla\u010Denje.",
  "dragDescriptionLongPress": "Pritisnite dugo da biste zapo\u010Deli prevla\u010Denje.",
  "dragDescriptionTouch": "Dvaput dodirnite za otpu\u0161tanje.",
  "dragDescriptionVirtual": "Kliknite da biste zapo\u010Deli prevla\u010Denje.",
  "dragStartedKeyboard": "Prevla\u010Denje je zapo\u010Deto. Pritisnite Tab da biste oti\u0161li do cilja za otpu\u0161tanje, zatim pritisnite Enter za ispu\u0161tanje ili pritisnite Escape za otkazivanje.",
  "dragStartedTouch": "Prevla\u010Denje je zapo\u010Deto. Idite do cilja za otpu\u0161tanje, a zatim dvaput dodirnite za otpu\u0161tanje.",
  "dragStartedVirtual": "Prevla\u010Denje je zapo\u010Deto. Idite do cilja za otpu\u0161tanje, a zatim kliknite ili pritinite Enter za otpu\u0161tanje.",
  "endDragKeyboard": "Prevla\u010Denje u toku. Pritisnite Enter da biste otkazali prevla\u010Denje.",
  "endDragTouch": "Prevla\u010Denje u toku. Dvaput dodirnite da biste otkazali prevla\u010Denje.",
  "endDragVirtual": "Prevla\u010Denje u toku. Kliknite da biste otkazali prevla\u010Denje.",
  "dragSelectedKeyboard": (args, formatter) => "Pritisnite Enter da biste prevukli ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " izabranu stavku"),
    other: () => "".concat(formatter.number(args.count), " izabranih stavki")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Pritisnite Alt + Enter da biste prevukli ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " izabranu stavku"),
    other: () => "".concat(formatter.number(args.count), " izabranih stavki")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Pritisnite dugo da biste prevukli ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " izabranu stavku"),
    other: () => "".concat(formatter.number(args.count), " izabranih stavki")
  }), "."),
  "dropDescriptionKeyboard": "Pritisnite Enter da biste otpustili. Pritisnite Escape da biste otkazali prevla\u010Denje.",
  "dropDescriptionTouch": "Dvaput dodirnite za otpu\u0161tanje.",
  "dropDescriptionVirtual": "Kliknite za otpu\u0161tanje.",
  "dropCanceled": "Otpu\u0161tanje je otkazano.",
  "dropComplete": "Prevla\u010Denje je zavr\u0161eno.",
  "dropIndicator": "Indikator otpu\u0161tanja",
  "dropOnRoot": "Otpusti na",
  "dropOnItem": args => "Otpusti na ".concat(args.itemText),
  "insertBefore": args => "Umetnite ispred ".concat(args.itemText),
  "insertBetween": args => "Umetnite izme\u0111u ".concat(args.beforeItemText, " i ").concat(args.afterItemText),
  "insertAfter": args => "Umetnite posle ".concat(args.itemText)
};
var $f3e2ce4b6d6cc4ac$exports = {};
$f3e2ce4b6d6cc4ac$exports = {
  "dragDescriptionKeyboard": "Tryck p\xE5 enter f\xF6r att b\xF6rja dra.",
  "dragDescriptionKeyboardAlt": "Tryck p\xE5 Alt + Retur f\xF6r att b\xF6rja dra.",
  "dragDescriptionLongPress": "Tryck l\xE4nge f\xF6r att b\xF6rja dra.",
  "dragDescriptionTouch": "Dubbeltryck f\xF6r att b\xF6rja dra.",
  "dragDescriptionVirtual": "Klicka f\xF6r att b\xF6rja dra.",
  "dragItem": args => "Dra ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "Dra ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " valt objekt"),
    other: () => "".concat(formatter.number(args.count), " valda objekt")
  })),
  "dragSelectedKeyboard": (args, formatter) => "Tryck p\xE5 Retur f\xF6r att dra ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " markerat objekt"),
    other: () => "".concat(formatter.number(args.count), " markerade objekt")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "Tryck p\xE5 Alt + Retur f\xF6r att dra ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " markerat objekt"),
    other: () => "".concat(formatter.number(args.count), " markerade objekt")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "Tryck l\xE4nge f\xF6r att dra ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " markerat objekt"),
    other: () => "".concat(formatter.number(args.count), " markerade objekt")
  }), "."),
  "dragStartedKeyboard": "B\xF6rja dra. Tryck p\xE5 tabb f\xF6r att navigera till m\xE5let, tryck p\xE5 enter f\xF6r att sl\xE4ppa eller p\xE5 escape f\xF6r att avbryta.",
  "dragStartedTouch": "B\xF6rja dra. Navigera till ett m\xE5l och dubbeltryck f\xF6r att sl\xE4ppa.",
  "dragStartedVirtual": "B\xF6rja dra. Navigera till ett m\xE5l och klicka eller tryck p\xE5 enter f\xF6r att sl\xE4ppa.",
  "dropCanceled": "Sl\xE4pp\xE5tg\xE4rd avbr\xF6ts.",
  "dropComplete": "Sl\xE4pp\xE5tg\xE4rd klar.",
  "dropDescriptionKeyboard": "Tryck p\xE5 enter f\xF6r att sl\xE4ppa. Tryck p\xE5 escape f\xF6r att avbryta drag\xE5tg\xE4rd.",
  "dropDescriptionTouch": "Dubbeltryck f\xF6r att sl\xE4ppa.",
  "dropDescriptionVirtual": "Klicka f\xF6r att sl\xE4ppa.",
  "dropIndicator": "sl\xE4ppindikator",
  "dropOnItem": args => "Sl\xE4pp p\xE5 ".concat(args.itemText),
  "dropOnRoot": "Sl\xE4pp p\xE5",
  "endDragKeyboard": "Drar. Tryck p\xE5 enter f\xF6r att avbryta drag\xE5tg\xE4rd.",
  "endDragTouch": "Drar. Dubbeltryck f\xF6r att avbryta drag\xE5tg\xE4rd.",
  "endDragVirtual": "Drar. Klicka f\xF6r att avbryta drag\xE5tg\xE4rd.",
  "insertAfter": args => "Infoga efter ".concat(args.itemText),
  "insertBefore": args => "Infoga f\xF6re ".concat(args.itemText),
  "insertBetween": args => "Infoga mellan ".concat(args.beforeItemText, " och ").concat(args.afterItemText)
};
var $da91b0d12d273475$exports = {};
$da91b0d12d273475$exports = {
  "dragDescriptionKeyboard": "S\xFCr\xFCklemeyi ba\u015Flatmak i\xE7in Enter'a bas\u0131n.",
  "dragDescriptionKeyboardAlt": "S\xFCr\xFCklemeyi ba\u015Flatmak i\xE7in Alt + Enter'a bas\u0131n.",
  "dragDescriptionLongPress": "S\xFCr\xFCklemeye ba\u015Flamak i\xE7in uzun bas\u0131n.",
  "dragDescriptionTouch": "S\xFCr\xFCklemeyi ba\u015Flatmak i\xE7in \xE7ift t\u0131klay\u0131n.",
  "dragDescriptionVirtual": "S\xFCr\xFCklemeyi ba\u015Flatmak i\xE7in t\u0131klay\u0131n.",
  "dragItem": args => "".concat(args.itemText, "\u2019i s\xFCr\xFCkle"),
  "dragSelectedItems": (args, formatter) => "S\xFCr\xFCkle ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " se\xE7ili \xF6ge"),
    other: () => "".concat(formatter.number(args.count), " se\xE7ili \xF6ge")
  })),
  "dragSelectedKeyboard": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe"),
    other: () => "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe")
  }), " \xF6\u011Fesini s\xFCr\xFCklemek i\xE7in Enter'a bas\u0131n."),
  "dragSelectedKeyboardAlt": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe"),
    other: () => "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe")
  }), " \xF6\u011Fesini s\xFCr\xFCklemek i\xE7in Alt + Enter tu\u015Funa bas\u0131n."),
  "dragSelectedLongPress": (args, formatter) => "".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe"),
    other: () => "".concat(formatter.number(args.count), " se\xE7ilmi\u015F \xF6\u011Fe")
  }), " \xF6\u011Fesini s\xFCr\xFCklemek i\xE7in uzun bas\u0131n."),
  "dragStartedKeyboard": "S\xFCr\xFCkleme ba\u015Flat\u0131ld\u0131. Bir b\u0131rakma hedefine gitmek i\xE7in Tab\u2019a bas\u0131n, ard\u0131ndan b\u0131rakmak i\xE7in Enter\u2019a bas\u0131n veya iptal etmek i\xE7in Escape\u2019e bas\u0131n.",
  "dragStartedTouch": "S\xFCr\xFCkleme ba\u015Flat\u0131ld\u0131. Bir b\u0131rakma hedefine gidin, ard\u0131ndan b\u0131rakmak i\xE7in \xE7ift t\u0131klay\u0131n.",
  "dragStartedVirtual": "S\xFCr\xFCkleme ba\u015Flat\u0131ld\u0131. Bir b\u0131rakma hedefine gidin, ard\u0131ndan b\u0131rakmak i\xE7in Enter\u2019a t\u0131klay\u0131n veya bas\u0131n.",
  "dropCanceled": "B\u0131rakma iptal edildi.",
  "dropComplete": "B\u0131rakma tamamland\u0131.",
  "dropDescriptionKeyboard": "B\u0131rakmak i\xE7in Enter'a bas\u0131n. S\xFCr\xFCklemeyi iptal etmek i\xE7in Escape'e bas\u0131n.",
  "dropDescriptionTouch": "B\u0131rakmak i\xE7in \xE7ift t\u0131klay\u0131n.",
  "dropDescriptionVirtual": "B\u0131rakmak i\xE7in t\u0131klay\u0131n.",
  "dropIndicator": "b\u0131rakma g\xF6stergesi",
  "dropOnItem": args => "".concat(args.itemText, " \xFCzerine b\u0131rak"),
  "dropOnRoot": "B\u0131rak\u0131n",
  "endDragKeyboard": "S\xFCr\xFCkleme. S\xFCr\xFCklemeyi iptal etmek i\xE7in Enter'a bas\u0131n.",
  "endDragTouch": "S\xFCr\xFCkleme. S\xFCr\xFCklemeyi iptal etmek i\xE7in \xE7ift t\u0131klay\u0131n.",
  "endDragVirtual": "S\xFCr\xFCkleme. S\xFCr\xFCklemeyi iptal etmek i\xE7in t\u0131klay\u0131n.",
  "insertAfter": args => "".concat(args.itemText, "\u2019den sonra gir"),
  "insertBefore": args => "".concat(args.itemText, "\u2019den \xF6nce gir"),
  "insertBetween": args => "".concat(args.beforeItemText, " ve ").concat(args.afterItemText, " aras\u0131na gir")
};
var $d6f72e28f0f4871c$exports = {};
$d6f72e28f0f4871c$exports = {
  "dragDescriptionKeyboard": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Enter, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
  "dragDescriptionKeyboardAlt": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Alt + Enter, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
  "dragDescriptionLongPress": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0456 \u0443\u0442\u0440\u0438\u043C\u0443\u0439\u0442\u0435, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
  "dragDescriptionTouch": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0434\u0432\u0456\u0447\u0456, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
  "dragDescriptionVirtual": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
  "dragItem": args => "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438 ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0445 \u0435\u043B\u0435\u043C")
  })),
  "dragSelectedKeyboard": (args, formatter) => "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Enter, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0445 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438(-\u0456\u0432)")
  }), "."),
  "dragSelectedKeyboardAlt": (args, formatter) => "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Alt + Enter, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0445 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438(-\u0456\u0432)")
  }), "."),
  "dragSelectedLongPress": (args, formatter) => "\u0423\u0442\u0440\u0438\u043C\u0443\u0439\u0442\u0435, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442"),
    other: () => "".concat(formatter.number(args.count), " \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0445 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438(-\u0456\u0432)")
  }), "."),
  "dragStartedKeyboard": "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u043E\u0447\u0430\u043B\u043E\u0441\u044F. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Tab, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u0446\u0456\u043B\u0456 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F, \u043F\u043E\u0442\u0456\u043C \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Enter, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438, \u0430\u0431\u043E Escape, \u0449\u043E\u0431 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438.",
  "dragStartedTouch": "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u043E\u0447\u0430\u043B\u043E\u0441\u044F. \u041F\u0435\u0440\u0435\u0439\u0434\u0456\u0442\u044C \u0434\u043E \u0446\u0456\u043B\u0456 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F, \u043F\u043E\u0442\u0456\u043C \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0434\u0432\u0456\u0447\u0456, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438.",
  "dragStartedVirtual": "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u043F\u043E\u0447\u0430\u043B\u043E\u0441\u044F. \u041F\u0435\u0440\u0435\u0439\u0434\u0456\u0442\u044C \u0434\u043E \u0446\u0456\u043B\u0456 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F, \u043F\u043E\u0442\u0456\u043C \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Enter, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438.",
  "dropCanceled": "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E.",
  "dropComplete": "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E.",
  "dropDescriptionKeyboard": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Enter, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Escape, \u0449\u043E\u0431 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
  "dropDescriptionTouch": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0434\u0432\u0456\u0447\u0456, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438.",
  "dropDescriptionVirtual": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438.",
  "dropIndicator": "\u0456\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F",
  "dropOnItem": args => "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438 \u043D\u0430 ".concat(args.itemText),
  "dropOnRoot": "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438 \u043D\u0430",
  "endDragKeyboard": "\u0422\u0440\u0438\u0432\u0430\u0454 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Enter, \u0449\u043E\u0431 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
  "endDragTouch": "\u0422\u0440\u0438\u0432\u0430\u0454 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0434\u0432\u0456\u0447\u0456, \u0449\u043E\u0431 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
  "endDragVirtual": "\u0422\u0440\u0438\u0432\u0430\u0454 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F. \u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u0443\u0432\u0430\u043D\u043D\u044F.",
  "insertAfter": args => "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043F\u0456\u0441\u043B\u044F ".concat(args.itemText),
  "insertBefore": args => "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043F\u0435\u0440\u0435\u0434 ".concat(args.itemText),
  "insertBetween": args => "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u0438 \u043C\u0456\u0436 ".concat(args.beforeItemText, " \u0456 ").concat(args.afterItemText)
};
var $187738fbdc896f75$exports = {};
$187738fbdc896f75$exports = {
  "dragDescriptionKeyboard": "\u6309 Enter \u5F00\u59CB\u62D6\u52A8\u3002",
  "dragDescriptionKeyboardAlt": "\u6309 Alt + Enter \u5F00\u59CB\u62D6\u52A8\u3002",
  "dragDescriptionLongPress": "\u957F\u6309\u4EE5\u5F00\u59CB\u62D6\u52A8\u3002",
  "dragDescriptionTouch": "\u53CC\u51FB\u5F00\u59CB\u62D6\u52A8\u3002",
  "dragDescriptionVirtual": "\u5355\u51FB\u5F00\u59CB\u62D6\u52A8\u3002",
  "dragItem": args => "\u62D6\u52A8 ".concat(args.itemText),
  "dragSelectedItems": (args, formatter) => "\u62D6\u52A8 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u9009\u4E2D\u9879\u76EE"),
    other: () => "".concat(formatter.number(args.count), " \u9009\u4E2D\u9879\u76EE")
  })),
  "dragSelectedKeyboard": (args, formatter) => "\u6309 Enter \u4EE5\u62D6\u52A8 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879"),
    other: () => "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879")
  }), "\u3002"),
  "dragSelectedKeyboardAlt": (args, formatter) => "\u6309 Alt + Enter \u4EE5\u62D6\u52A8 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879"),
    other: () => "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879")
  }), "\u3002"),
  "dragSelectedLongPress": (args, formatter) => "\u957F\u6309\u4EE5\u62D6\u52A8 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879"),
    other: () => "".concat(formatter.number(args.count), " \u4E2A\u9009\u5B9A\u9879")
  }), "\u3002"),
  "dragStartedKeyboard": "\u5DF2\u5F00\u59CB\u62D6\u52A8\u3002\u6309 Tab \u5BFC\u822A\u5230\u653E\u7F6E\u76EE\u6807\uFF0C\u7136\u540E\u6309 Enter \u653E\u7F6E\u6216\u6309 Escape \u53D6\u6D88\u3002",
  "dragStartedTouch": "\u5DF2\u5F00\u59CB\u62D6\u52A8\u3002\u5BFC\u822A\u5230\u653E\u7F6E\u76EE\u6807\uFF0C\u7136\u540E\u53CC\u51FB\u653E\u7F6E\u3002",
  "dragStartedVirtual": "\u5DF2\u5F00\u59CB\u62D6\u52A8\u3002\u5BFC\u822A\u5230\u653E\u7F6E\u76EE\u6807\uFF0C\u7136\u540E\u5355\u51FB\u6216\u6309 Enter \u653E\u7F6E\u3002",
  "dropCanceled": "\u653E\u7F6E\u5DF2\u53D6\u6D88\u3002",
  "dropComplete": "\u653E\u7F6E\u5DF2\u5B8C\u6210\u3002",
  "dropDescriptionKeyboard": "\u6309 Enter \u653E\u7F6E\u3002\u6309 Escape \u53D6\u6D88\u62D6\u52A8\u3002",
  "dropDescriptionTouch": "\u53CC\u51FB\u653E\u7F6E\u3002",
  "dropDescriptionVirtual": "\u5355\u51FB\u653E\u7F6E\u3002",
  "dropIndicator": "\u653E\u7F6E\u6807\u8BB0",
  "dropOnItem": args => "\u653E\u7F6E\u4E8E ".concat(args.itemText),
  "dropOnRoot": "\u653E\u7F6E\u4E8E",
  "endDragKeyboard": "\u6B63\u5728\u62D6\u52A8\u3002\u6309 Enter \u53D6\u6D88\u62D6\u52A8\u3002",
  "endDragTouch": "\u6B63\u5728\u62D6\u52A8\u3002\u53CC\u51FB\u53D6\u6D88\u62D6\u52A8\u3002",
  "endDragVirtual": "\u6B63\u5728\u62D6\u52A8\u3002\u5355\u51FB\u53D6\u6D88\u62D6\u52A8\u3002",
  "insertAfter": args => "\u63D2\u5165\u5230 ".concat(args.itemText, " \u4E4B\u540E"),
  "insertBefore": args => "\u63D2\u5165\u5230 ".concat(args.itemText, " \u4E4B\u524D"),
  "insertBetween": args => "\u63D2\u5165\u5230 ".concat(args.beforeItemText, " \u548C ").concat(args.afterItemText, " \u4E4B\u95F4")
};
var $80cfc1f1f7d356d3$exports = {};
$80cfc1f1f7d356d3$exports = {
  "dragDescriptionKeyboard": "\u6309 Enter \u9375\u4EE5\u958B\u59CB\u62D6\u66F3\u3002",
  "dragDescriptionKeyboardAlt": "\u6309 Alt+Enter \u9375\u4EE5\u958B\u59CB\u62D6\u66F3\u3002",
  "dragDescriptionLongPress": "\u9577\u6309\u4EE5\u958B\u59CB\u62D6\u66F3\u3002",
  "dragDescriptionTouch": "\u8F15\u9EDE\u5169\u4E0B\u4EE5\u958B\u59CB\u62D6\u66F3\u3002",
  "dragDescriptionVirtual": "\u6309\u4E00\u4E0B\u6ED1\u9F20\u4EE5\u958B\u59CB\u62D6\u66F3\u3002",
  "dragItem": args => "\u62D6\u66F3\u300C".concat(args.itemText, "\u300D"),
  "dragSelectedItems": (args, formatter) => "\u62D6\u66F3 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u500B\u9078\u5B9A\u9805\u76EE"),
    other: () => "".concat(formatter.number(args.count), " \u500B\u9078\u5B9A\u9805\u76EE")
  })),
  "dragSelectedKeyboard": (args, formatter) => "\u6309 Enter \u9375\u4EE5\u62D6\u66F3 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u500B\u9078\u5B9A\u9805\u76EE"),
    other: () => "".concat(formatter.number(args.count), " \u500B\u9078\u5B9A\u9805\u76EE")
  }), "\u3002"),
  "dragSelectedKeyboardAlt": (args, formatter) => "\u6309 Alt+Enter \u9375\u4EE5\u62D6\u66F3 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u500B\u9078\u5B9A\u9805\u76EE"),
    other: () => "".concat(formatter.number(args.count), " \u500B\u9078\u5B9A\u9805\u76EE")
  }), "\u3002"),
  "dragSelectedLongPress": (args, formatter) => "\u9577\u6309\u4EE5\u62D6\u66F3 ".concat(formatter.plural(args.count, {
    one: () => "".concat(formatter.number(args.count), " \u500B\u9078\u5B9A\u9805\u76EE"),
    other: () => "".concat(formatter.number(args.count), " \u500B\u9078\u5B9A\u9805\u76EE")
  }), "\u3002"),
  "dragStartedKeyboard": "\u5DF2\u958B\u59CB\u62D6\u66F3\u3002\u6309 Tab \u9375\u4EE5\u700F\u89BD\u81F3\u653E\u7F6E\u76EE\u6A19\uFF0C\u7136\u5F8C\u6309 Enter \u9375\u4EE5\u653E\u7F6E\uFF0C\u6216\u6309 Escape \u9375\u4EE5\u53D6\u6D88\u3002",
  "dragStartedTouch": "\u5DF2\u958B\u59CB\u62D6\u66F3\u3002\u700F\u89BD\u81F3\u653E\u7F6E\u76EE\u6A19\uFF0C\u7136\u5F8C\u8F15\u9EDE\u5169\u4E0B\u4EE5\u653E\u7F6E\u3002",
  "dragStartedVirtual": "\u5DF2\u958B\u59CB\u62D6\u66F3\u3002\u700F\u89BD\u81F3\u653E\u7F6E\u76EE\u6A19\uFF0C\u7136\u5F8C\u6309\u4E00\u4E0B\u6ED1\u9F20\u6216\u6309 Enter \u9375\u4EE5\u653E\u7F6E\u3002",
  "dropCanceled": "\u653E\u7F6E\u5DF2\u53D6\u6D88\u3002",
  "dropComplete": "\u653E\u7F6E\u5DF2\u5B8C\u6210\u3002",
  "dropDescriptionKeyboard": "\u6309 Enter \u9375\u4EE5\u653E\u7F6E\u3002\u6309 Escape \u9375\u4EE5\u53D6\u6D88\u62D6\u66F3\u3002",
  "dropDescriptionTouch": "\u8F15\u9EDE\u5169\u4E0B\u4EE5\u653E\u7F6E\u3002",
  "dropDescriptionVirtual": "\u6309\u4E00\u4E0B\u6ED1\u9F20\u4EE5\u653E\u7F6E\u3002",
  "dropIndicator": "\u653E\u7F6E\u6307\u793A\u5668",
  "dropOnItem": args => "\u653E\u7F6E\u5728\u300C".concat(args.itemText, "\u300D\u4E0A"),
  "dropOnRoot": "\u653E\u7F6E\u5728",
  "endDragKeyboard": "\u62D6\u66F3\u4E2D\u3002\u6309 Enter \u9375\u4EE5\u53D6\u6D88\u62D6\u66F3\u3002",
  "endDragTouch": "\u62D6\u66F3\u4E2D\u3002\u8F15\u9EDE\u5169\u4E0B\u4EE5\u53D6\u6D88\u62D6\u66F3\u3002",
  "endDragVirtual": "\u62D6\u66F3\u4E2D\u3002\u6309\u4E00\u4E0B\u6ED1\u9F20\u4EE5\u53D6\u6D88\u62D6\u66F3\u3002",
  "insertAfter": args => "\u63D2\u5165\u81F3\u300C".concat(args.itemText, "\u300D\u4E4B\u5F8C"),
  "insertBefore": args => "\u63D2\u5165\u81F3\u300C".concat(args.itemText, "\u300D\u4E4B\u524D"),
  "insertBetween": args => "\u63D2\u5165\u81F3\u300C".concat(args.beforeItemText, "\u300D\u548C\u300C").concat(args.afterItemText, "\u300D\u4E4B\u9593")
};
$7c8adf3925a26206$exports = {
  "ar-AE": $12ee6b0bfb4232ad$exports,
  "bg-BG": $e21ef7c55796c5e1$exports,
  "cs-CZ": $dfa9cd1c2317d9aa$exports,
  "da-DK": $65fff3bbacfa8956$exports,
  "de-DE": $10b7dfe45cd41c2d$exports,
  "el-GR": $0cadcffb7abc96b8$exports,
  "en-US": $7e3982b34ddf1bdf$exports,
  "es-ES": $cb29ce0b655c4023$exports,
  "et-EE": $067d46bab80bcf4b$exports,
  "fi-FI": $8aa1b9a1f9d783d3$exports,
  "fr-FR": $9e248ec27f7dc55f$exports,
  "he-IL": $6387f7228f0de45e$exports,
  "hr-HR": $34a283567735f754$exports,
  "hu-HU": $466590c56bee4342$exports,
  "it-IT": $e013896dcb6a6884$exports,
  "ja-JP": $d6121e4246c6e502$exports,
  "ko-KR": $cf48a963c482dcba$exports,
  "lt-LT": $b156071f04f1c899$exports,
  "lv-LV": $5300be8ef98d39fa$exports,
  "nb-NO": $7484477aad199932$exports,
  "nl-NL": $968e09cb41d6cd76$exports,
  "pl-PL": $0c2c6c954dd638d7$exports,
  "pt-BR": $db510f249c1f2e00$exports,
  "pt-PT": $d734686296d37387$exports,
  "ro-RO": $d239d4998a584a23$exports,
  "ru-RU": $a06126b47eabe64f$exports,
  "sk-SK": $0983413fc05d96fb$exports,
  "sl-SI": $c66896a0464692f1$exports,
  "sr-SP": $f0d9abe43a1bcdf6$exports,
  "sv-SE": $f3e2ce4b6d6cc4ac$exports,
  "tr-TR": $da91b0d12d273475$exports,
  "uk-UA": $d6f72e28f0f4871c$exports,
  "zh-CN": $187738fbdc896f75$exports,
  "zh-TW": $80cfc1f1f7d356d3$exports
};
const $dc204e8ec58447a6$var$MESSAGES = {
  keyboard: {
    start: "dragDescriptionKeyboard",
    end: "endDragKeyboard"
  },
  touch: {
    start: "dragDescriptionTouch",
    end: "endDragTouch"
  },
  virtual: {
    start: "dragDescriptionVirtual",
    end: "endDragVirtual"
  }
};
function $dc204e8ec58447a6$export$7941f8aafa4b6021(options) {
  let {
    hasDragButton: hasDragButton
  } = options;
  let stringFormatter = (0, $4vY0V$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($7c8adf3925a26206$exports)));
  let state = (0, $4vY0V$react.useRef)({
    options: options,
    x: 0,
    y: 0
  }).current;
  state.options = options;
  let isDraggingRef = (0, $4vY0V$react.useRef)(false);
  let [isDragging, setDraggingState] = (0, $4vY0V$react.useState)(false);
  let setDragging = isDragging => {
    isDraggingRef.current = isDragging;
    setDraggingState(isDragging);
  };
  let {
    addGlobalListener: addGlobalListener,
    removeAllGlobalListeners: removeAllGlobalListeners
  } = (0, $4vY0V$reactariautils.useGlobalListeners)();
  let modalityOnPointerDown = (0, $4vY0V$react.useRef)(null);
  let onDragStart = e => {
    var _options_preview;
    if (e.defaultPrevented) return;
    // Prevent the drag event from propagating to any parent draggables
    e.stopPropagation();
    // If this drag was initiated by a mobile screen reader (e.g. VoiceOver or TalkBack), enter virtual dragging mode.
    if (modalityOnPointerDown.current === "virtual") {
      e.preventDefault();
      startDragging(e.target);
      modalityOnPointerDown.current = null;
      return;
    }
    if (typeof options.onDragStart === "function") options.onDragStart({
      type: "dragstart",
      x: e.clientX,
      y: e.clientY
    });
    let items = options.getItems();
    (0, $4620ae0dc40f0031$export$f9c1490890ddd063)(e.dataTransfer, items);
    let allowed = (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).all;
    if (typeof options.getAllowedDropOperations === "function") {
      let allowedOperations = options.getAllowedDropOperations();
      allowed = (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).none;
      for (let operation of allowedOperations) allowed |= (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e)[operation] || (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).none;
    }
    (0, $4620ae0dc40f0031$export$6539bc8c3a0a2d67)(allowed);
    e.dataTransfer.effectAllowed = (0, $76b1e110a27b1ccd$export$dd0165308d8bff45)[allowed] || "none";
    // If there is a preview option, use it to render a custom preview image that will
    // appear under the pointer while dragging. If not, the element itself is dragged by the browser.
    if (typeof ((_options_preview = options.preview) === null || _options_preview === void 0 ? void 0 : _options_preview.current) === "function") options.preview.current(items, node => {
      // Compute the offset that the preview will appear under the mouse.
      // If possible, this is based on the point the user clicked on the target.
      // If the preview is much smaller, then just use the center point of the preview.
      let size = node.getBoundingClientRect();
      let rect = e.currentTarget.getBoundingClientRect();
      let x = e.clientX - rect.x;
      let y = e.clientY - rect.y;
      if (x > size.width || y > size.height) {
        x = size.width / 2;
        y = size.height / 2;
      }
      // Rounding height to an even number prevents blurry preview seen on some screens
      let height = 2 * Math.round(size.height / 2);
      node.style.height = "".concat(height, "px");
      e.dataTransfer.setDragImage(node, x, y);
    });
    // Enforce that drops are handled by useDrop.
    addGlobalListener(window, "drop", e => {
      e.preventDefault();
      e.stopPropagation();
      console.warn("Drags initiated from the React Aria useDrag hook may only be dropped on a target created with useDrop. This ensures that a keyboard and screen reader accessible alternative is available.");
    }, {
      once: true
    });
    state.x = e.clientX;
    state.y = e.clientY;
    // Wait a frame before we set dragging to true so that the browser has time to
    // render the preview image before we update the element that has been dragged.
    requestAnimationFrame(() => {
      setDragging(true);
    });
  };
  let onDrag = e => {
    // Prevent the drag event from propagating to any parent draggables
    e.stopPropagation();
    if (e.clientX === state.x && e.clientY === state.y) return;
    if (typeof options.onDragMove === "function") options.onDragMove({
      type: "dragmove",
      x: e.clientX,
      y: e.clientY
    });
    state.x = e.clientX;
    state.y = e.clientY;
  };
  let onDragEnd = e => {
    // Prevent the drag event from propagating to any parent draggables
    e.stopPropagation();
    if (typeof options.onDragEnd === "function") {
      let event = {
        type: "dragend",
        x: e.clientX,
        y: e.clientY,
        dropOperation: (0, $76b1e110a27b1ccd$export$608ecc6f1b23c35d)[e.dataTransfer.dropEffect]
      };
      // Chrome Android always returns none as its dropEffect so we use the drop effect set in useDrop via
      // onDragEnter/onDragOver instead. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
      if (0, $4620ae0dc40f0031$export$8e6636520ac15722) event.dropOperation = (0, $76b1e110a27b1ccd$export$608ecc6f1b23c35d)[(0, $4620ae0dc40f0031$export$8e6636520ac15722)];
      options.onDragEnd(event);
    }
    setDragging(false);
    removeAllGlobalListeners();
    (0, $4620ae0dc40f0031$export$6539bc8c3a0a2d67)((0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).none);
    (0, $4620ae0dc40f0031$export$64f52ed7349ddb84)(undefined);
  };
  // If the dragged element is removed from the DOM via onDrop, onDragEnd won't fire: https://bugzilla.mozilla.org/show_bug.cgi?id=460801
  // In this case, we need to manually call onDragEnd on cleanup
  // eslint-disable-next-line arrow-body-style
  (0, $4vY0V$reactariautils.useLayoutEffect)(() => {
    return () => {
      if (isDraggingRef.current) {
        if (typeof state.options.onDragEnd === "function") {
          let event = {
            type: "dragend",
            x: 0,
            y: 0,
            dropOperation: (0, $76b1e110a27b1ccd$export$608ecc6f1b23c35d)[(0, $4620ae0dc40f0031$export$8e6636520ac15722) || "none"]
          };
          state.options.onDragEnd(event);
        }
        setDragging(false);
        (0, $4620ae0dc40f0031$export$6539bc8c3a0a2d67)((0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).none);
        (0, $4620ae0dc40f0031$export$64f52ed7349ddb84)(undefined);
      }
    };
  }, [state]);
  let onPress = e => {
    if (e.pointerType !== "keyboard" && e.pointerType !== "virtual") return;
    startDragging(e.target);
  };
  let startDragging = target => {
    if (typeof state.options.onDragStart === "function") {
      let rect = target.getBoundingClientRect();
      state.options.onDragStart({
        type: "dragstart",
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2
      });
    }
    $28e10663603f5ea1$export$549dbcf8649bf3b2({
      element: target,
      items: state.options.getItems(),
      allowedDropOperations: typeof state.options.getAllowedDropOperations === "function" ? state.options.getAllowedDropOperations() : ["move", "copy", "link"],
      onDragEnd(e) {
        setDragging(false);
        if (typeof state.options.onDragEnd === "function") state.options.onDragEnd(e);
      }
    }, stringFormatter);
    setDragging(true);
  };
  let modality = (0, $4620ae0dc40f0031$export$49bac5d6d4b352ea)();
  let message = !isDragging ? $dc204e8ec58447a6$var$MESSAGES[modality].start : $dc204e8ec58447a6$var$MESSAGES[modality].end;
  let descriptionProps = (0, $4vY0V$reactariautils.useDescription)(stringFormatter.format(message));
  let interactions;
  if (!hasDragButton)
    // If there's no separate button to trigger accessible drag and drop mode,
    // then add event handlers to the draggable element itself to start dragging.
    // For keyboard, we use the Enter key in a capturing listener to prevent other
    // events such as selection from also occurring. We attempt to infer whether a
    // pointer event (e.g. long press) came from a touch screen reader, and then initiate
    // dragging in the native onDragStart listener above.
    interactions = {
      ...descriptionProps,
      onPointerDown(e) {
        modalityOnPointerDown.current = (0, $4vY0V$reactariautils.isVirtualPointerEvent)(e.nativeEvent) ? "virtual" : e.pointerType;
        // Try to detect virtual drag passthrough gestures.
        if (e.width < 1 && e.height < 1)
          // iOS VoiceOver.
          modalityOnPointerDown.current = "virtual";else {
          let rect = e.currentTarget.getBoundingClientRect();
          let offsetX = e.clientX - rect.x;
          let offsetY = e.clientY - rect.y;
          let centerX = rect.width / 2;
          let centerY = rect.height / 2;
          if (Math.abs(offsetX - centerX) <= 0.5 && Math.abs(offsetY - centerY) <= 0.5)
            // Android TalkBack.
            modalityOnPointerDown.current = "virtual";else modalityOnPointerDown.current = e.pointerType;
        }
      },
      onKeyDownCapture(e) {
        if (e.target === e.currentTarget && e.key === "Enter") {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      onKeyUpCapture(e) {
        if (e.target === e.currentTarget && e.key === "Enter") {
          e.preventDefault();
          e.stopPropagation();
          startDragging(e.target);
        }
      },
      onClick(e) {
        // Handle NVDA/JAWS in browse mode, and touch screen readers. In this case, no keyboard events are fired.
        if ((0, $4vY0V$reactariautils.isVirtualClick)(e.nativeEvent) || modalityOnPointerDown.current === "virtual") {
          e.preventDefault();
          e.stopPropagation();
          startDragging(e.target);
        }
      }
    };
  return {
    dragProps: {
      ...interactions,
      draggable: "true",
      onDragStart: onDragStart,
      onDrag: onDrag,
      onDragEnd: onDragEnd
    },
    dragButtonProps: {
      ...descriptionProps,
      onPress: onPress
    },
    isDragging: isDragging
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $419982e205c8e8dc$var$MESSAGES = {
  keyboard: "dropDescriptionKeyboard",
  touch: "dropDescriptionTouch",
  virtual: "dropDescriptionVirtual"
};
function $419982e205c8e8dc$export$62447ad3d2ec7da6() {
  let stringFormatter = (0, $4vY0V$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($7c8adf3925a26206$exports)));
  let modality = (0, $4620ae0dc40f0031$export$49bac5d6d4b352ea)();
  let dragSession = $28e10663603f5ea1$export$418e185dd3f1b968();
  let descriptionProps = (0, $4vY0V$reactariautils.useDescription)(dragSession ? stringFormatter.format($419982e205c8e8dc$var$MESSAGES[modality]) : "");
  return {
    dropProps: {
      ...descriptionProps,
      // Mobile Safari does not properly bubble click events on elements except links or inputs
      // unless there is an onclick handler bound directly to the element itself. By adding this
      // handler, React will take care of adding that for us, and we are able to handle document
      // level click events in the DragManager.
      // See https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
      onClick: () => {}
    }
  };
}
const $1ca228bc9257ca16$var$DROP_ACTIVATE_TIMEOUT = 800;
function $1ca228bc9257ca16$export$ccdee5eaf73cf661(options) {
  let {
    hasDropButton: hasDropButton
  } = options;
  let [isDropTarget, setDropTarget] = (0, $4vY0V$react.useState)(false);
  let state = (0, $4vY0V$react.useRef)({
    x: 0,
    y: 0,
    dragOverElements: new Set(),
    dropEffect: "none",
    allowedOperations: (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).all,
    dropActivateTimer: null
  }).current;
  let fireDropEnter = e => {
    setDropTarget(true);
    if (typeof options.onDropEnter === "function") {
      let rect = e.currentTarget.getBoundingClientRect();
      options.onDropEnter({
        type: "dropenter",
        x: e.clientX - rect.x,
        y: e.clientY - rect.y
      });
    }
  };
  let fireDropExit = e => {
    setDropTarget(false);
    if (typeof options.onDropExit === "function") {
      let rect = e.currentTarget.getBoundingClientRect();
      options.onDropExit({
        type: "dropexit",
        x: e.clientX - rect.x,
        y: e.clientY - rect.y
      });
    }
  };
  let onDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
    let allowedOperations = $1ca228bc9257ca16$var$getAllowedOperations(e);
    if (e.clientX === state.x && e.clientY === state.y && allowedOperations === state.allowedOperations) {
      e.dataTransfer.dropEffect = state.dropEffect;
      return;
    }
    state.x = e.clientX;
    state.y = e.clientY;
    let prevDropEffect = state.dropEffect;
    // Update drop effect if allowed drop operations changed (e.g. user pressed modifier key).
    if (allowedOperations !== state.allowedOperations) {
      let allowedOps = $1ca228bc9257ca16$var$allowedOperationsToArray(allowedOperations);
      let dropOperation = allowedOps[0];
      if (typeof options.getDropOperation === "function") {
        let types = new (0, $4620ae0dc40f0031$export$7f04ce188c91447c)(e.dataTransfer);
        dropOperation = $1ca228bc9257ca16$var$getDropOperation(allowedOperations, options.getDropOperation(types, allowedOps));
      }
      state.dropEffect = (0, $76b1e110a27b1ccd$export$5eacb0769d26d3b2)[dropOperation] || "none";
    }
    if (typeof options.getDropOperationForPoint === "function") {
      let types = new (0, $4620ae0dc40f0031$export$7f04ce188c91447c)(e.dataTransfer);
      let rect = e.currentTarget.getBoundingClientRect();
      let dropOperation = $1ca228bc9257ca16$var$getDropOperation(allowedOperations, options.getDropOperationForPoint(types, $1ca228bc9257ca16$var$allowedOperationsToArray(allowedOperations), state.x - rect.x, state.y - rect.y));
      state.dropEffect = (0, $76b1e110a27b1ccd$export$5eacb0769d26d3b2)[dropOperation] || "none";
    }
    state.allowedOperations = allowedOperations;
    e.dataTransfer.dropEffect = state.dropEffect;
    // If the drop operation changes, update state and fire events appropriately.
    if (state.dropEffect === "none" && prevDropEffect !== "none") fireDropExit(e);else if (state.dropEffect !== "none" && prevDropEffect === "none") fireDropEnter(e);
    if (typeof options.onDropMove === "function" && state.dropEffect !== "none") {
      let rect = e.currentTarget.getBoundingClientRect();
      options.onDropMove({
        type: "dropmove",
        x: state.x - rect.x,
        y: state.y - rect.y
      });
    }
    clearTimeout(state.dropActivateTimer);
    if (typeof options.onDropActivate === "function" && state.dropEffect !== "none") {
      let rect = e.currentTarget.getBoundingClientRect();
      state.dropActivateTimer = setTimeout(() => {
        options.onDropActivate({
          type: "dropactivate",
          x: state.x - rect.x,
          y: state.y - rect.y
        });
      }, $1ca228bc9257ca16$var$DROP_ACTIVATE_TIMEOUT);
    }
  };
  let onDragEnter = e => {
    e.preventDefault();
    e.stopPropagation();
    state.dragOverElements.add(e.target);
    if (state.dragOverElements.size > 1) return;
    let allowedOperationsBits = $1ca228bc9257ca16$var$getAllowedOperations(e);
    let allowedOperations = $1ca228bc9257ca16$var$allowedOperationsToArray(allowedOperationsBits);
    let dropOperation = allowedOperations[0];
    if (typeof options.getDropOperation === "function") {
      let types = new (0, $4620ae0dc40f0031$export$7f04ce188c91447c)(e.dataTransfer);
      dropOperation = $1ca228bc9257ca16$var$getDropOperation(allowedOperationsBits, options.getDropOperation(types, allowedOperations));
    }
    if (typeof options.getDropOperationForPoint === "function") {
      let types = new (0, $4620ae0dc40f0031$export$7f04ce188c91447c)(e.dataTransfer);
      let rect = e.currentTarget.getBoundingClientRect();
      dropOperation = $1ca228bc9257ca16$var$getDropOperation(allowedOperationsBits, options.getDropOperationForPoint(types, allowedOperations, e.clientX - rect.x, e.clientY - rect.y));
    }
    state.x = e.clientX;
    state.y = e.clientY;
    state.allowedOperations = allowedOperationsBits;
    state.dropEffect = (0, $76b1e110a27b1ccd$export$5eacb0769d26d3b2)[dropOperation] || "none";
    e.dataTransfer.dropEffect = state.dropEffect;
    if (dropOperation !== "cancel") fireDropEnter(e);
  };
  let onDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    // We would use e.relatedTarget to detect if the drag is still inside the drop target,
    // but it is always null in WebKit. https://bugs.webkit.org/show_bug.cgi?id=66547
    // Instead, we track all of the targets of dragenter events in a set, and remove them
    // in dragleave. When the set becomes empty, we've left the drop target completely.
    // We must also remove any elements that are no longer in the DOM, because dragleave
    // events will never be fired for these. This can happen, for example, with drop
    // indicators between items, which disappear when the drop target changes.
    state.dragOverElements.delete(e.target);
    for (let element of state.dragOverElements) if (!e.currentTarget.contains(element)) state.dragOverElements.delete(element);
    if (state.dragOverElements.size > 0) return;
    if (state.dropEffect !== "none") fireDropExit(e);
    clearTimeout(state.dropActivateTimer);
  };
  let onDrop = e => {
    e.preventDefault();
    e.stopPropagation();
    // Track drop effect in global state for Chrome Android. https://bugs.chromium.org/p/chromium/issues/detail?id=1353951
    // Android onDragEnd always returns "none" as its drop effect.
    (0, $4620ae0dc40f0031$export$64f52ed7349ddb84)(state.dropEffect);
    if (typeof options.onDrop === "function") {
      let dropOperation = (0, $76b1e110a27b1ccd$export$608ecc6f1b23c35d)[state.dropEffect];
      let items = (0, $4620ae0dc40f0031$export$d9e760437831f8b3)(e.dataTransfer);
      let rect = e.currentTarget.getBoundingClientRect();
      let event = {
        type: "drop",
        x: e.clientX - rect.x,
        y: e.clientY - rect.y,
        items: items,
        dropOperation: dropOperation
      };
      options.onDrop(event);
    }
    let dndStateSnapshot = {
      ...(0, $4620ae0dc40f0031$export$6ca6700462636d0b)
    };
    state.dragOverElements.clear();
    fireDropExit(e);
    clearTimeout(state.dropActivateTimer);
    // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
    // RSP collection and thus we don't need to preserve the global drop effect
    if (dndStateSnapshot.draggingCollectionRef == null) (0, $4620ae0dc40f0031$export$64f52ed7349ddb84)(undefined);else
      // Otherwise we need to preserve the global dnd state for onDragEnd's isInternal check.
      // At the moment fireDropExit may clear dropCollectionRef (i.e. useDroppableCollection's provided onDropExit, required to clear dropCollectionRef when exiting a valid drop target)
      (0, $4620ae0dc40f0031$export$6c10d32b362bfa5f)(dndStateSnapshot);
  };
  let onDropEnter = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    if (typeof options.onDropEnter === "function") options.onDropEnter(e);
  });
  let onDropExit = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    if (typeof options.onDropExit === "function") options.onDropExit(e);
  });
  let onDropActivate = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    if (typeof options.onDropActivate === "function") options.onDropActivate(e);
  });
  let onKeyboardDrop = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    if (typeof options.onDrop === "function") options.onDrop(e);
  });
  let getDropOperationKeyboard = (0, $4vY0V$reactariautils.useEffectEvent)((types, allowedOperations) => {
    if (options.getDropOperation) return options.getDropOperation(types, allowedOperations);
    return allowedOperations[0];
  });
  let {
    ref: ref
  } = options;
  (0, $4vY0V$reactariautils.useLayoutEffect)(() => $28e10663603f5ea1$export$c28d9fb4a54e471a({
    element: ref.current,
    getDropOperation: getDropOperationKeyboard,
    onDropEnter(e) {
      setDropTarget(true);
      onDropEnter(e);
    },
    onDropExit(e) {
      setDropTarget(false);
      onDropExit(e);
    },
    onDrop: onKeyboardDrop,
    onDropActivate: onDropActivate
  }), [ref, getDropOperationKeyboard, onDropEnter, onDropExit, onKeyboardDrop, onDropActivate]);
  let {
    dropProps: dropProps
  } = (0, $419982e205c8e8dc$export$62447ad3d2ec7da6)();
  return {
    dropProps: {
      ...(!hasDropButton && dropProps),
      onDragEnter: onDragEnter,
      onDragOver: onDragOver,
      onDragLeave: onDragLeave,
      onDrop: onDrop
    },
    dropButtonProps: {
      ...(hasDropButton && dropProps)
    },
    isDropTarget: isDropTarget
  };
}
function $1ca228bc9257ca16$var$getAllowedOperations(e) {
  let allowedOperations = (0, $76b1e110a27b1ccd$export$9bbdfc78cf083e16)[e.dataTransfer.effectAllowed];
  // WebKit always sets effectAllowed to "copyMove" on macOS, and "all" on iOS, regardless of what was
  // set during the dragstart event: https://bugs.webkit.org/show_bug.cgi?id=178058
  //
  // Android Chrome also sets effectAllowed to "copyMove" in all cases: https://bugs.chromium.org/p/chromium/issues/detail?id=1359182
  //
  // If the drag started within the page, we can use a global variable to get the real allowed operations.
  // This needs to be intersected with the actual effectAllowed, which may have been filtered based on modifier keys.
  // Unfortunately, this means that link operations do not work at all in Safari.
  if (0, $4620ae0dc40f0031$export$f0130eb70b6347b8) allowedOperations &= (0, $4620ae0dc40f0031$export$f0130eb70b6347b8);
  // Chrome and Safari on macOS will automatically filter effectAllowed when pressing modifier keys,
  // allowing the user to switch between move, link, and copy operations. Firefox on macOS and all
  // Windows browsers do not do this, so do it ourselves instead. The exact keys are platform dependent.
  // https://ux.stackexchange.com/questions/83748/what-are-the-most-common-modifier-keys-for-dragging-objects-with-a-mouse
  //
  // Note that none of these modifiers are ever set in WebKit due to a bug: https://bugs.webkit.org/show_bug.cgi?id=77465
  // However, Safari does update effectAllowed correctly, so we can just rely on that.
  let allowedModifiers = (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).none;
  if ((0, $4vY0V$reactariautils.isMac)()) {
    if (e.altKey) allowedModifiers |= (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).copy;
    // Chrome and Safari both use the Control key for link, even though Finder uses Command + Option.
    // iPadOS doesn't support link operations and will not fire the drop event at all if dropEffect is set to link.
    // https://bugs.webkit.org/show_bug.cgi?id=244701
    if (e.ctrlKey && !(0, $4vY0V$reactariautils.isIPad)()) allowedModifiers |= (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).link;
    if (e.metaKey) allowedModifiers |= (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).move;
  } else {
    if (e.altKey) allowedModifiers |= (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).link;
    if (e.shiftKey) allowedModifiers |= (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).move;
    if (e.ctrlKey) allowedModifiers |= (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).copy;
  }
  if (allowedModifiers) return allowedOperations & allowedModifiers;
  return allowedOperations;
}
function $1ca228bc9257ca16$var$allowedOperationsToArray(allowedOperationsBits) {
  let allowedOperations = [];
  if (allowedOperationsBits & (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).move) allowedOperations.push("move");
  if (allowedOperationsBits & (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).copy) allowedOperations.push("copy");
  if (allowedOperationsBits & (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e).link) allowedOperations.push("link");
  return allowedOperations;
}
function $1ca228bc9257ca16$var$getDropOperation(allowedOperations, operation) {
  let op = (0, $76b1e110a27b1ccd$export$60b7b4bcf3903d8e)[operation];
  return allowedOperations & op ? operation : "cancel";
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $12cc069a1c69155b$var$AUTOSCROLL_AREA_SIZE = 20;
function $12cc069a1c69155b$export$6323452ca4533ed8(ref) {
  let scrollableRef = (0, $4vY0V$react.useRef)(null);
  (0, $4vY0V$react.useEffect)(() => {
    if (ref.current) scrollableRef.current = (0, $4vY0V$reactariautils.isScrollable)(ref.current) ? ref.current : (0, $4vY0V$reactariautils.getScrollParent)(ref.current);
  }, [ref]);
  let state = (0, $4vY0V$react.useRef)({
    timer: null,
    dx: 0,
    dy: 0
  }).current;
  (0, $4vY0V$react.useEffect)(() => {
    return () => {
      if (state.timer) {
        cancelAnimationFrame(state.timer);
        state.timer = null;
      }
    };
    // state will become a new object, so it's ok to use in the dependency array for unmount
  }, [state]);
  let scroll = (0, $4vY0V$react.useCallback)(() => {
    scrollableRef.current.scrollLeft += state.dx;
    scrollableRef.current.scrollTop += state.dy;
    if (state.timer) state.timer = requestAnimationFrame(scroll);
  }, [scrollableRef, state]);
  return {
    move(x, y) {
      // Most browsers auto scroll natively, but WebKit on macOS does not (iOS does 🤷‍♂️).
      // https://bugs.webkit.org/show_bug.cgi?id=222636
      if (!(0, $4vY0V$reactariautils.isWebKit)() || (0, $4vY0V$reactariautils.isIOS)() || !scrollableRef.current) return;
      let box = scrollableRef.current.getBoundingClientRect();
      let left = $12cc069a1c69155b$var$AUTOSCROLL_AREA_SIZE;
      let top = $12cc069a1c69155b$var$AUTOSCROLL_AREA_SIZE;
      let bottom = box.height - $12cc069a1c69155b$var$AUTOSCROLL_AREA_SIZE;
      let right = box.width - $12cc069a1c69155b$var$AUTOSCROLL_AREA_SIZE;
      if (x < left || x > right || y < top || y > bottom) {
        if (x < left) state.dx = x - left;else if (x > right) state.dx = x - right;
        if (y < top) state.dy = y - top;else if (y > bottom) state.dy = y - bottom;
        if (!state.timer) state.timer = requestAnimationFrame(scroll);
      } else this.stop();
    },
    stop() {
      if (state.timer) {
        cancelAnimationFrame(state.timer);
        state.timer = null;
      }
    }
  };
}
const $7f93a158ac20b90a$var$DROP_POSITIONS = ["before", "on", "after"];
const $7f93a158ac20b90a$var$DROP_POSITIONS_RTL = ["after", "on", "before"];
function $7f93a158ac20b90a$export$f4e2f423c21f7b04(props, state, ref) {
  let localState = (0, $4vY0V$react.useRef)({
    props: props,
    state: state,
    nextTarget: null,
    dropOperation: null
  }).current;
  localState.props = props;
  localState.state = state;
  let defaultOnDrop = (0, $4vY0V$react.useCallback)(async e => {
    let {
      onInsert: onInsert,
      onRootDrop: onRootDrop,
      onItemDrop: onItemDrop,
      onReorder: onReorder,
      acceptedDragTypes = "all",
      shouldAcceptItemDrop: shouldAcceptItemDrop
    } = localState.props;
    let {
      draggingKeys: draggingKeys
    } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
    let isInternal = (0, $4620ae0dc40f0031$export$78bf638634500fa5)(ref);
    let {
      target: target,
      dropOperation: dropOperation,
      items: items
    } = e;
    let filteredItems = items;
    if (acceptedDragTypes !== "all" || shouldAcceptItemDrop) filteredItems = items.filter(item => {
      let itemTypes;
      if (item.kind === "directory") itemTypes = new Set([(0, $4620ae0dc40f0031$export$990fced5dfac2637)]);else itemTypes = item.kind === "file" ? new Set([item.type]) : item.types;
      if (acceptedDragTypes === "all" || acceptedDragTypes.some(type => itemTypes.has(type))) {
        // If we are performing a on item drop, check if the item in question accepts the dropped item since the item may have heavier restrictions
        // than the droppable collection itself
        if (target.type === "item" && target.dropPosition === "on" && shouldAcceptItemDrop) return shouldAcceptItemDrop(target, itemTypes);
        return true;
      }
      return false;
    });
    if (filteredItems.length > 0) {
      if (target.type === "root" && onRootDrop) await onRootDrop({
        items: filteredItems,
        dropOperation: dropOperation
      });
      if (target.type === "item") {
        if (target.dropPosition === "on" && onItemDrop) await onItemDrop({
          items: filteredItems,
          dropOperation: dropOperation,
          isInternal: isInternal,
          target: target
        });
        if (target.dropPosition !== "on") {
          if (!isInternal && onInsert) await onInsert({
            items: filteredItems,
            dropOperation: dropOperation,
            target: target
          });
          if (isInternal && onReorder) await onReorder({
            keys: draggingKeys,
            dropOperation: dropOperation,
            target: target
          });
        }
      }
    }
  }, [localState, ref]);
  let autoScroll = (0, $12cc069a1c69155b$export$6323452ca4533ed8)(ref);
  let {
    dropProps: dropProps
  } = (0, $1ca228bc9257ca16$export$ccdee5eaf73cf661)({
    ref: ref,
    onDropEnter() {
      state.setTarget(localState.nextTarget);
    },
    onDropMove(e) {
      state.setTarget(localState.nextTarget);
      autoScroll.move(e.x, e.y);
    },
    getDropOperationForPoint(types, allowedOperations, x, y) {
      let {
        draggingKeys: draggingKeys,
        dropCollectionRef: dropCollectionRef
      } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
      let isInternal = (0, $4620ae0dc40f0031$export$78bf638634500fa5)(ref);
      let isValidDropTarget = target => state.getDropOperation({
        target: target,
        types: types,
        allowedOperations: allowedOperations,
        isInternal: isInternal,
        draggingKeys: draggingKeys
      }) !== "cancel";
      let target = props.dropTargetDelegate.getDropTargetFromPoint(x, y, isValidDropTarget);
      if (!target) {
        localState.dropOperation = "cancel";
        localState.nextTarget = null;
        return "cancel";
      }
      localState.dropOperation = state.getDropOperation({
        target: target,
        types: types,
        allowedOperations: allowedOperations,
        isInternal: isInternal,
        draggingKeys: draggingKeys
      });
      // If the target doesn't accept the drop, see if the root accepts it instead.
      if (localState.dropOperation === "cancel") {
        let rootTarget = {
          type: "root"
        };
        let dropOperation = state.getDropOperation({
          target: rootTarget,
          types: types,
          allowedOperations: allowedOperations,
          isInternal: isInternal,
          draggingKeys: draggingKeys
        });
        if (dropOperation !== "cancel") {
          target = rootTarget;
          localState.dropOperation = dropOperation;
        }
      }
      // Only set dropCollectionRef if there is a valid drop target since we cleanup dropCollectionRef in onDropExit
      // which only runs when leaving a valid drop target or if the dropEffect become none (mouse dnd only).
      if (target && localState.dropOperation !== "cancel" && (ref === null || ref === void 0 ? void 0 : ref.current) !== (dropCollectionRef === null || dropCollectionRef === void 0 ? void 0 : dropCollectionRef.current)) (0, $4620ae0dc40f0031$export$dac8db29d42db9a1)(ref);
      localState.nextTarget = localState.dropOperation === "cancel" ? null : target;
      return localState.dropOperation;
    },
    onDropExit() {
      (0, $4620ae0dc40f0031$export$dac8db29d42db9a1)(undefined);
      state.setTarget(null);
      autoScroll.stop();
    },
    onDropActivate(e) {
      var _state_target, _state_target1;
      if (((_state_target = state.target) === null || _state_target === void 0 ? void 0 : _state_target.type) === "item" && ((_state_target1 = state.target) === null || _state_target1 === void 0 ? void 0 : _state_target1.dropPosition) === "on" && typeof props.onDropActivate === "function") props.onDropActivate({
        type: "dropactivate",
        x: e.x,
        y: e.y,
        target: state.target
      });
    },
    onDrop(e) {
      (0, $4620ae0dc40f0031$export$dac8db29d42db9a1)(ref);
      if (state.target) onDrop(e, state.target);
      // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
      // RSP collection and thus we don't need to preserve the global DnD state for onDragEnd
      let {
        draggingCollectionRef: draggingCollectionRef
      } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
      if (draggingCollectionRef == null) (0, $4620ae0dc40f0031$export$70936501603e6c57)();
    }
  });
  let droppingState = (0, $4vY0V$react.useRef)(null);
  let onDrop = (0, $4vY0V$react.useCallback)((e, target) => {
    var _state_collection_getItem;
    let {
      state: state
    } = localState;
    // Focus the collection.
    state.selectionManager.setFocused(true);
    // Save some state of the collection/selection before the drop occurs so we can compare later.
    let focusedKey = state.selectionManager.focusedKey;
    // If parent key was dragged, we want to use it instead (i.e. focus row instead of cell after dropping)
    if ((0, $4620ae0dc40f0031$export$6ca6700462636d0b).draggingKeys.has((_state_collection_getItem = state.collection.getItem(focusedKey)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.parentKey)) {
      focusedKey = state.collection.getItem(focusedKey).parentKey;
      state.selectionManager.setFocusedKey(focusedKey);
    }
    droppingState.current = {
      timeout: null,
      focusedKey: focusedKey,
      collection: state.collection,
      selectedKeys: state.selectionManager.selectedKeys
    };
    let onDropFn = localState.props.onDrop || defaultOnDrop;
    onDropFn({
      type: "drop",
      x: e.x,
      y: e.y,
      target: target,
      items: e.items,
      dropOperation: e.dropOperation
    });
    // Wait for a short time period after the onDrop is called to allow the data to be read asynchronously
    // and for React to re-render. If an insert occurs during this time, it will be selected/focused below.
    // If items are not "immediately" inserted by the onDrop handler, the application will need to handle
    // selecting and focusing those items themselves.
    droppingState.current.timeout = setTimeout(() => {
      // If focus didn't move already (e.g. due to an insert), and the user dropped on an item,
      // focus that item and show the focus ring to give the user feedback that the drop occurred.
      // Also show the focus ring if the focused key is not selected, e.g. in case of a reorder.
      let {
        state: state
      } = localState;
      if (target.type === "item" && target.dropPosition === "on" && state.collection.getItem(target.key) != null) {
        state.selectionManager.setFocusedKey(target.key);
        state.selectionManager.setFocused(true);
        (0, $4vY0V$reactariainteractions.setInteractionModality)("keyboard");
      } else if (!state.selectionManager.isSelected(focusedKey)) (0, $4vY0V$reactariainteractions.setInteractionModality)("keyboard");
      droppingState.current = null;
    }, 50);
  }, [localState, defaultOnDrop]);
  // eslint-disable-next-line arrow-body-style
  (0, $4vY0V$react.useEffect)(() => {
    return () => {
      if (droppingState.current) clearTimeout(droppingState.current.timeout);
    };
  }, []);
  (0, $4vY0V$reactariautils.useLayoutEffect)(() => {
    // If an insert occurs during a drop, we want to immediately select these items to give
    // feedback to the user that a drop occurred. Only do this if the selection didn't change
    // since the drop started so we don't override if the user or application did something.
    if (droppingState.current && state.selectionManager.isFocused && state.collection.size > droppingState.current.collection.size && state.selectionManager.isSelectionEqual(droppingState.current.selectedKeys)) {
      let newKeys = new Set();
      for (let key of state.collection.getKeys()) if (!droppingState.current.collection.getItem(key)) newKeys.add(key);
      state.selectionManager.setSelectedKeys(newKeys);
      // If the focused item didn't change since the drop occurred, also focus the first
      // inserted item. If selection is disabled, then also show the focus ring so there
      // is some indication that items were added.
      if (state.selectionManager.focusedKey === droppingState.current.focusedKey) {
        let first = newKeys.keys().next().value;
        let item = state.collection.getItem(first);
        // If this is a cell, focus the parent row.
        if ((item === null || item === void 0 ? void 0 : item.type) === "cell") first = item.parentKey;
        state.selectionManager.setFocusedKey(first);
        if (state.selectionManager.selectionMode === "none") (0, $4vY0V$reactariainteractions.setInteractionModality)("keyboard");
      }
      droppingState.current = null;
    }
  });
  let {
    direction: direction
  } = (0, $4vY0V$reactariai18n.useLocale)();
  (0, $4vY0V$react.useEffect)(() => {
    let getNextTarget = function (target) {
      let wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      let horizontal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!target) return {
        type: "root"
      };
      let {
        keyboardDelegate: keyboardDelegate
      } = localState.props;
      let nextKey;
      if ((target === null || target === void 0 ? void 0 : target.type) === "item") nextKey = horizontal ? keyboardDelegate.getKeyRightOf(target.key) : keyboardDelegate.getKeyBelow(target.key);else nextKey = horizontal && direction === "rtl" ? keyboardDelegate.getLastKey() : keyboardDelegate.getFirstKey();
      let dropPositions = horizontal && direction === "rtl" ? $7f93a158ac20b90a$var$DROP_POSITIONS_RTL : $7f93a158ac20b90a$var$DROP_POSITIONS;
      let dropPosition = dropPositions[0];
      if (target.type === "item") {
        // If the the keyboard delegate returned the next key in the collection,
        // first try the other positions in the current key. Otherwise (e.g. in a grid layout),
        // jump to the same drop position in the new key.
        let nextCollectionKey = horizontal && direction === "rtl" ? localState.state.collection.getKeyBefore(target.key) : localState.state.collection.getKeyAfter(target.key);
        if (nextKey == null || nextKey === nextCollectionKey) {
          let positionIndex = dropPositions.indexOf(target.dropPosition);
          let nextDropPosition = dropPositions[positionIndex + 1];
          if (positionIndex < dropPositions.length - 1 && !(nextDropPosition === dropPositions[2] && nextKey != null)) return {
            type: "item",
            key: target.key,
            dropPosition: nextDropPosition
          };
          // If the last drop position was 'after', then 'before' on the next key is equivalent.
          // Switch to 'on' instead.
          if (target.dropPosition === dropPositions[2]) dropPosition = "on";
        } else dropPosition = target.dropPosition;
      }
      if (nextKey == null) {
        if (wrap) return {
          type: "root"
        };
        return null;
      }
      return {
        type: "item",
        key: nextKey,
        dropPosition: dropPosition
      };
    };
    let getPreviousTarget = function (target) {
      let wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      let horizontal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      let {
        keyboardDelegate: keyboardDelegate
      } = localState.props;
      let nextKey;
      if ((target === null || target === void 0 ? void 0 : target.type) === "item") nextKey = horizontal ? keyboardDelegate.getKeyLeftOf(target.key) : keyboardDelegate.getKeyAbove(target.key);else nextKey = horizontal && direction === "rtl" ? keyboardDelegate.getFirstKey() : keyboardDelegate.getLastKey();
      let dropPositions = horizontal && direction === "rtl" ? $7f93a158ac20b90a$var$DROP_POSITIONS_RTL : $7f93a158ac20b90a$var$DROP_POSITIONS;
      let dropPosition = !target || target.type === "root" ? dropPositions[2] : "on";
      if ((target === null || target === void 0 ? void 0 : target.type) === "item") {
        // If the the keyboard delegate returned the previous key in the collection,
        // first try the other positions in the current key. Otherwise (e.g. in a grid layout),
        // jump to the same drop position in the new key.
        let prevCollectionKey = horizontal && direction === "rtl" ? localState.state.collection.getKeyAfter(target.key) : localState.state.collection.getKeyBefore(target.key);
        if (nextKey == null || nextKey === prevCollectionKey) {
          let positionIndex = dropPositions.indexOf(target.dropPosition);
          let nextDropPosition = dropPositions[positionIndex - 1];
          if (positionIndex > 0 && nextDropPosition !== dropPositions[2]) return {
            type: "item",
            key: target.key,
            dropPosition: nextDropPosition
          };
          // If the last drop position was 'before', then 'after' on the previous key is equivalent.
          // Switch to 'on' instead.
          if (target.dropPosition === dropPositions[0]) dropPosition = "on";
        } else dropPosition = target.dropPosition;
      }
      if (nextKey == null) {
        if (wrap) return {
          type: "root"
        };
        return null;
      }
      return {
        type: "item",
        key: nextKey,
        dropPosition: dropPosition
      };
    };
    let nextValidTarget = function (target, types, allowedDropOperations, getNextTarget) {
      let wrap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      let seenRoot = 0;
      let operation;
      let {
        draggingKeys: draggingKeys
      } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
      let isInternal = (0, $4620ae0dc40f0031$export$78bf638634500fa5)(ref);
      do {
        let nextTarget = getNextTarget(target, wrap);
        if (!nextTarget) return null;
        target = nextTarget;
        operation = localState.state.getDropOperation({
          target: nextTarget,
          types: types,
          allowedOperations: allowedDropOperations,
          isInternal: isInternal,
          draggingKeys: draggingKeys
        });
        if (target.type === "root") seenRoot++;
      } while (operation === "cancel" && !localState.state.isDropTarget(target) && seenRoot < 2);
      if (operation === "cancel") return null;
      return target;
    };
    return $28e10663603f5ea1$export$c28d9fb4a54e471a({
      element: ref.current,
      getDropOperation(types, allowedOperations) {
        if (localState.state.target) {
          let {
            draggingKeys: draggingKeys
          } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
          let isInternal = (0, $4620ae0dc40f0031$export$78bf638634500fa5)(ref);
          return localState.state.getDropOperation({
            target: localState.state.target,
            types: types,
            allowedOperations: allowedOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          });
        }
        // Check if any of the targets accept the drop.
        // TODO: should we have a faster way of doing this or e.g. for pagination?
        let target = nextValidTarget(null, types, allowedOperations, getNextTarget);
        return target ? "move" : "cancel";
      },
      onDropEnter(e, drag) {
        let types = (0, $4620ae0dc40f0031$export$e1d41611756c6326)(drag.items);
        let selectionManager = localState.state.selectionManager;
        let target;
        // Update the drop collection ref tracker for useDroppableItem's getDropOperation isInternal check
        (0, $4620ae0dc40f0031$export$dac8db29d42db9a1)(ref);
        // When entering the droppable collection for the first time, the default drop target
        // is after the focused key.
        let key = selectionManager.focusedKey;
        let dropPosition = "after";
        // If the focused key is a cell, get the parent item instead.
        // For now, we assume that individual cells cannot be dropped on.
        let item = localState.state.collection.getItem(key);
        if ((item === null || item === void 0 ? void 0 : item.type) === "cell") key = item.parentKey;
        // If the focused item is also selected, the default drop target is after the last selected item.
        // But if the focused key is the first selected item, then default to before the first selected item.
        // This is to make reordering lists slightly easier. If you select top down, we assume you want to
        // move the items down. If you select bottom up, we assume you want to move the items up.
        if (selectionManager.isSelected(key)) {
          if (selectionManager.selectedKeys.size > 1 && selectionManager.firstSelectedKey === key) dropPosition = "before";else key = selectionManager.lastSelectedKey;
        }
        if (key != null) {
          target = {
            type: "item",
            key: key,
            dropPosition: dropPosition
          };
          let {
            draggingKeys: draggingKeys
          } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
          let isInternal = (0, $4620ae0dc40f0031$export$78bf638634500fa5)(ref);
          var _nextValidTarget;
          // If the default target is not valid, find the next one that is.
          if (localState.state.getDropOperation({
            target: target,
            types: types,
            allowedOperations: drag.allowedDropOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          }) === "cancel") target = (_nextValidTarget = nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false)) !== null && _nextValidTarget !== void 0 ? _nextValidTarget : nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false);
        }
        // If no focused key, then start from the root.
        if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
        localState.state.setTarget(target);
      },
      onDropExit() {
        (0, $4620ae0dc40f0031$export$dac8db29d42db9a1)(undefined);
        localState.state.setTarget(null);
      },
      onDropTargetEnter(target) {
        localState.state.setTarget(target);
      },
      onDropActivate(e) {
        var _localState_state_target, _localState_state_target1;
        if (((_localState_state_target = localState.state.target) === null || _localState_state_target === void 0 ? void 0 : _localState_state_target.type) === "item" && ((_localState_state_target1 = localState.state.target) === null || _localState_state_target1 === void 0 ? void 0 : _localState_state_target1.dropPosition) === "on" && typeof localState.props.onDropActivate === "function") localState.props.onDropActivate({
          type: "dropactivate",
          x: e.x,
          y: e.y,
          target: localState.state.target
        });
      },
      onDrop(e, target) {
        (0, $4620ae0dc40f0031$export$dac8db29d42db9a1)(ref);
        if (localState.state.target) onDrop(e, target || localState.state.target);
      },
      onKeyDown(e, drag) {
        let {
          keyboardDelegate: keyboardDelegate
        } = localState.props;
        let types = (0, $4620ae0dc40f0031$export$e1d41611756c6326)(drag.items);
        switch (e.key) {
          case "ArrowDown":
            if (keyboardDelegate.getKeyBelow) {
              let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, getNextTarget);
              localState.state.setTarget(target);
            }
            break;
          case "ArrowUp":
            if (keyboardDelegate.getKeyAbove) {
              let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, getPreviousTarget);
              localState.state.setTarget(target);
            }
            break;
          case "ArrowLeft":
            if (keyboardDelegate.getKeyLeftOf) {
              let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, (target, wrap) => getPreviousTarget(target, wrap, true));
              localState.state.setTarget(target);
            }
            break;
          case "ArrowRight":
            if (keyboardDelegate.getKeyRightOf) {
              let target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, (target, wrap) => getNextTarget(target, wrap, true));
              localState.state.setTarget(target);
            }
            break;
          case "Home":
            if (keyboardDelegate.getFirstKey) {
              let target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
              localState.state.setTarget(target);
            }
            break;
          case "End":
            if (keyboardDelegate.getLastKey) {
              let target = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);
              localState.state.setTarget(target);
            }
            break;
          case "PageDown":
            if (keyboardDelegate.getKeyPageBelow) {
              let target = localState.state.target;
              if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);else {
                // If on the root, go to the item a page below the top. Otherwise a page below the current item.
                let nextKey = keyboardDelegate.getKeyPageBelow(target.type === "item" ? target.key : keyboardDelegate.getFirstKey());
                let dropPosition = target.type === "item" ? target.dropPosition : "after";
                // If there is no next key, or we are starting on the last key, jump to the last possible position.
                if (nextKey == null || target.type === "item" && target.key === keyboardDelegate.getLastKey()) {
                  nextKey = keyboardDelegate.getLastKey();
                  dropPosition = "after";
                }
                target = {
                  type: "item",
                  key: nextKey,
                  dropPosition: dropPosition
                };
                // If the target does not accept the drop, find the next valid target.
                // If no next valid target, find the previous valid target.
                let {
                  draggingCollectionRef: draggingCollectionRef,
                  draggingKeys: draggingKeys
                } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
                let isInternal = (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) === (ref === null || ref === void 0 ? void 0 : ref.current);
                let operation = localState.state.getDropOperation({
                  target: target,
                  types: types,
                  allowedOperations: drag.allowedDropOperations,
                  isInternal: isInternal,
                  draggingKeys: draggingKeys
                });
                var _nextValidTarget;
                if (operation === "cancel") target = (_nextValidTarget = nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false)) !== null && _nextValidTarget !== void 0 ? _nextValidTarget : nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false);
              }
              localState.state.setTarget(target !== null && target !== void 0 ? target : localState.state.target);
            }
            break;
          case "PageUp":
            {
              if (!keyboardDelegate.getKeyPageAbove) break;
              let target = localState.state.target;
              if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);else if (target.type === "item") {
                // If at the top already, switch to the root. Otherwise navigate a page up.
                if (target.key === keyboardDelegate.getFirstKey()) target = {
                  type: "root"
                };else {
                  let nextKey = keyboardDelegate.getKeyPageAbove(target.key);
                  let dropPosition = target.dropPosition;
                  if (nextKey == null) {
                    nextKey = keyboardDelegate.getFirstKey();
                    dropPosition = "before";
                  }
                  target = {
                    type: "item",
                    key: nextKey,
                    dropPosition: dropPosition
                  };
                }
                // If the target does not accept the drop, find the previous valid target.
                // If no next valid target, find the next valid target.
                let {
                  draggingKeys: draggingKeys
                } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
                let isInternal = (0, $4620ae0dc40f0031$export$78bf638634500fa5)(ref);
                let operation = localState.state.getDropOperation({
                  target: target,
                  types: types,
                  allowedOperations: drag.allowedDropOperations,
                  isInternal: isInternal,
                  draggingKeys: draggingKeys
                });
                var _nextValidTarget1;
                if (operation === "cancel") target = (_nextValidTarget1 = nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false)) !== null && _nextValidTarget1 !== void 0 ? _nextValidTarget1 : nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false);
              }
              localState.state.setTarget(target !== null && target !== void 0 ? target : localState.state.target);
              break;
            }
        }
      }
    });
  }, [localState, ref, onDrop, direction]);
  let id = (0, $4vY0V$reactariautils.useId)();
  (0, $4620ae0dc40f0031$export$dfdf5deeaf27473f).set(state, {
    id: id,
    ref: ref
  });
  return {
    collectionProps: (0, $4vY0V$reactariautils.mergeProps)(dropProps, {
      id: id,
      // Remove description from collection element. If dropping on the entire collection,
      // there should be a drop indicator that has this description, so no need to double announce.
      "aria-describedby": null
    })
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $fc1876157e07bcec$export$f7b0c5d28b66b6a5(options, state, ref) {
  let {
    dropProps: dropProps
  } = (0, $419982e205c8e8dc$export$62447ad3d2ec7da6)();
  let droppableCollectionRef = (0, $4620ae0dc40f0031$export$7e397efd01d3db27)(state);
  (0, $4vY0V$react.useEffect)(() => {
    if (ref.current) return $28e10663603f5ea1$export$aef80212ac99c003({
      element: ref.current,
      target: options.target,
      getDropOperation(types, allowedOperations) {
        let {
          draggingKeys: draggingKeys
        } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
        let isInternal = (0, $4620ae0dc40f0031$export$78bf638634500fa5)(droppableCollectionRef);
        return state.getDropOperation({
          target: options.target,
          types: types,
          allowedOperations: allowedOperations,
          isInternal: isInternal,
          draggingKeys: draggingKeys
        });
      }
    });
  }, [ref, options.target, state, droppableCollectionRef]);
  let dragSession = $28e10663603f5ea1$export$418e185dd3f1b968();
  let {
    draggingKeys: draggingKeys
  } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
  let isInternal = (0, $4620ae0dc40f0031$export$78bf638634500fa5)(droppableCollectionRef);
  let isValidDropTarget = dragSession && state.getDropOperation({
    target: options.target,
    types: (0, $4620ae0dc40f0031$export$e1d41611756c6326)(dragSession.dragTarget.items),
    allowedOperations: dragSession.dragTarget.allowedDropOperations,
    isInternal: isInternal,
    draggingKeys: draggingKeys
  }) !== "cancel";
  let isDropTarget = state.isDropTarget(options.target);
  (0, $4vY0V$react.useEffect)(() => {
    if (dragSession && isDropTarget && ref.current) ref.current.focus();
  }, [isDropTarget, dragSession, ref]);
  return {
    dropProps: {
      ...dropProps,
      "aria-hidden": !dragSession || isValidDropTarget ? undefined : "true"
    },
    isDropTarget: isDropTarget
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $c5557edbed563ebf$export$8d0e41d2815afac5(props, state, ref) {
  let {
    target: target
  } = props;
  let {
    collection: collection
  } = state;
  let stringFormatter = (0, $4vY0V$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($7c8adf3925a26206$exports)));
  let dragSession = $28e10663603f5ea1$export$418e185dd3f1b968();
  let {
    dropProps: dropProps
  } = (0, $fc1876157e07bcec$export$f7b0c5d28b66b6a5)(props, state, ref);
  let id = (0, $4vY0V$reactariautils.useId)();
  var _collection_getTextValue;
  let getText = key => {
    var _collection_getTextValue1, _collection_getItem;
    return (_collection_getTextValue = (_collection_getTextValue1 = collection.getTextValue) === null || _collection_getTextValue1 === void 0 ? void 0 : _collection_getTextValue1.call(collection, key)) !== null && _collection_getTextValue !== void 0 ? _collection_getTextValue : (_collection_getItem = collection.getItem(key)) === null || _collection_getItem === void 0 ? void 0 : _collection_getItem.textValue;
  };
  let label = "";
  let labelledBy;
  if (target.type === "root") {
    label = stringFormatter.format("dropOnRoot");
    labelledBy = "".concat(id, " ").concat((0, $4620ae0dc40f0031$export$3093291712f09a77)(state));
  } else if (target.dropPosition === "on") label = stringFormatter.format("dropOnItem", {
    itemText: getText(target.key)
  });else {
    let before;
    let after;
    if (collection.getFirstKey() === target.key && target.dropPosition === "before") before = null;else before = target.dropPosition === "before" ? collection.getKeyBefore(target.key) : target.key;
    if (collection.getLastKey() === target.key && target.dropPosition === "after") after = null;else after = target.dropPosition === "after" ? collection.getKeyAfter(target.key) : target.key;
    if (before && after) label = stringFormatter.format("insertBetween", {
      beforeItemText: getText(before),
      afterItemText: getText(after)
    });else if (before) label = stringFormatter.format("insertAfter", {
      itemText: getText(before)
    });else if (after) label = stringFormatter.format("insertBefore", {
      itemText: getText(after)
    });
  }
  let isDropTarget = state.isDropTarget(target);
  let ariaHidden = !dragSession ? "true" : dropProps["aria-hidden"];
  return {
    dropIndicatorProps: {
      ...dropProps,
      id: id,
      "aria-roledescription": stringFormatter.format("dropIndicator"),
      "aria-label": label,
      "aria-labelledby": labelledBy,
      "aria-hidden": ariaHidden,
      tabIndex: -1
    },
    isDropTarget: isDropTarget,
    // If aria-hidden, we are either not in a drag session or the drop target is invalid.
    // In that case, there's no need to render anything at all unless we need to show the indicator visually.
    // This can happen when dragging using the native DnD API as opposed to keyboard dragging.
    isHidden: !isDropTarget && !!ariaHidden
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $0cbbd00cda972c67$var$MESSAGES = {
  keyboard: {
    selected: "dragSelectedKeyboard",
    notSelected: "dragDescriptionKeyboard"
  },
  touch: {
    selected: "dragSelectedLongPress",
    notSelected: "dragDescriptionLongPress"
  },
  virtual: {
    selected: "dragDescriptionVirtual",
    notSelected: "dragDescriptionVirtual"
  }
};
function $0cbbd00cda972c67$export$b35afafff42da2d9(props, state) {
  let stringFormatter = (0, $4vY0V$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($7c8adf3925a26206$exports)));
  let isDisabled = state.selectionManager.isDisabled(props.key);
  let {
    dragProps: dragProps,
    dragButtonProps: dragButtonProps
  } = (0, $dc204e8ec58447a6$export$7941f8aafa4b6021)({
    getItems() {
      return state.getItems(props.key);
    },
    preview: state.preview,
    getAllowedDropOperations: state.getAllowedDropOperations,
    hasDragButton: props.hasDragButton,
    onDragStart(e) {
      state.startDrag(props.key, e);
      // Track draggingKeys for useDroppableCollection's default onDrop handler and useDroppableCollectionState's default getDropOperation
      (0, $4620ae0dc40f0031$export$72cb63bdda528276)(state.draggingKeys);
    },
    onDragMove(e) {
      state.moveDrag(e);
    },
    onDragEnd(e) {
      let {
        dropOperation: dropOperation
      } = e;
      let isInternal = dropOperation === "cancel" ? false : (0, $4620ae0dc40f0031$export$78bf638634500fa5)();
      state.endDrag({
        ...e,
        keys: state.draggingKeys,
        isInternal: isInternal
      });
      (0, $4620ae0dc40f0031$export$70936501603e6c57)();
    }
  });
  let item = state.collection.getItem(props.key);
  let numKeysForDrag = state.getKeysForDrag(props.key).size;
  let isSelected = numKeysForDrag > 1 && state.selectionManager.isSelected(props.key);
  let dragButtonLabel;
  let description;
  // Override description to include selected item count.
  let modality = (0, $4620ae0dc40f0031$export$49bac5d6d4b352ea)();
  if (!props.hasDragButton && state.selectionManager.selectionMode !== "none") {
    let msg = $0cbbd00cda972c67$var$MESSAGES[modality][isSelected ? "selected" : "notSelected"];
    if (props.hasAction && modality === "keyboard") msg += "Alt";
    if (isSelected) description = stringFormatter.format(msg, {
      count: numKeysForDrag
    });else description = stringFormatter.format(msg);
    // Remove the onClick handler from useDrag. Long pressing will be required on touch devices,
    // and NVDA/JAWS are always in forms mode within collection components.
    delete dragProps.onClick;
  } else if (isSelected) dragButtonLabel = stringFormatter.format("dragSelectedItems", {
    count: numKeysForDrag
  });else {
    var _state_collection, _state_collection_getTextValue;
    var _state_collection_getTextValue1, _ref;
    let itemText = (_ref = (_state_collection_getTextValue1 = (_state_collection_getTextValue = (_state_collection = state.collection).getTextValue) === null || _state_collection_getTextValue === void 0 ? void 0 : _state_collection_getTextValue.call(_state_collection, props.key)) !== null && _state_collection_getTextValue1 !== void 0 ? _state_collection_getTextValue1 : item === null || item === void 0 ? void 0 : item.textValue) !== null && _ref !== void 0 ? _ref : "";
    dragButtonLabel = stringFormatter.format("dragItem", {
      itemText: itemText
    });
  }
  let descriptionProps = (0, $4vY0V$reactariautils.useDescription)(description);
  if (description) Object.assign(dragProps, descriptionProps);
  if (!props.hasDragButton && props.hasAction) {
    let {
      onKeyDownCapture: onKeyDownCapture,
      onKeyUpCapture: onKeyUpCapture
    } = dragProps;
    if (modality === "touch")
      // Remove long press description if an action is present, because in that case long pressing selects the item.
      delete dragProps["aria-describedby"];
    // Require Alt key if there is a conflicting action.
    dragProps.onKeyDownCapture = e => {
      if (e.altKey) onKeyDownCapture(e);
    };
    dragProps.onKeyUpCapture = e => {
      if (e.altKey) onKeyUpCapture(e);
    };
  }
  return {
    dragProps: isDisabled ? {} : dragProps,
    dragButtonProps: {
      ...dragButtonProps,
      isDisabled: isDisabled,
      "aria-label": dragButtonLabel
    }
  };
}

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
function $c3e901bab7fcc6ff$export$2962a7984b2f0a80(props, state, ref) {
  // Update global DnD state if this keys within this collection are dragged
  let {
    draggingCollectionRef: draggingCollectionRef
  } = (0, $4620ae0dc40f0031$export$6ca6700462636d0b);
  if (state.draggingKeys.size > 0 && (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) !== ref.current) (0, $4620ae0dc40f0031$export$f2be18a910c0caa6)(ref);
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $74f3dedaa4d234b4$var$globalEvents = new Map();
function $74f3dedaa4d234b4$var$addGlobalEventListener(event, fn) {
  let eventData = $74f3dedaa4d234b4$var$globalEvents.get(event);
  if (!eventData) {
    let handlers = new Set();
    let listener = e => {
      for (let handler of handlers) handler(e);
    };
    eventData = {
      listener: listener,
      handlers: handlers
    };
    $74f3dedaa4d234b4$var$globalEvents.set(event, eventData);
    document.addEventListener(event, listener);
  }
  eventData.handlers.add(fn);
  return () => {
    eventData.handlers.delete(fn);
    if (eventData.handlers.size === 0) {
      document.removeEventListener(event, eventData.listener);
      $74f3dedaa4d234b4$var$globalEvents.delete(event);
    }
  };
}
function $74f3dedaa4d234b4$export$2314ca2a3e892862(options) {
  let isFocusedRef = (0, $4vY0V$react.useRef)(false);
  let {
    focusProps: focusProps
  } = (0, $4vY0V$reactariainteractions.useFocus)({
    onFocusChange: isFocused => {
      isFocusedRef.current = isFocused;
    }
  });
  let onBeforeCopy = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    // Enable the "Copy" menu item in Safari if this element is focused and copying is supported.
    if (isFocusedRef.current && options.getItems) e.preventDefault();
  });
  let onCopy = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    var _options_onCopy;
    if (!isFocusedRef.current || !options.getItems) return;
    e.preventDefault();
    (0, $4620ae0dc40f0031$export$f9c1490890ddd063)(e.clipboardData, options.getItems());
    (_options_onCopy = options.onCopy) === null || _options_onCopy === void 0 ? void 0 : _options_onCopy.call(options);
  });
  let onBeforeCut = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    if (isFocusedRef.current && options.onCut && options.getItems) e.preventDefault();
  });
  let onCut = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    if (!isFocusedRef.current || !options.onCut || !options.getItems) return;
    e.preventDefault();
    (0, $4620ae0dc40f0031$export$f9c1490890ddd063)(e.clipboardData, options.getItems());
    options.onCut();
  });
  let onBeforePaste = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    // Unfortunately, e.clipboardData.types is not available in this event so we always
    // have to enable the Paste menu item even if the type of data is unsupported.
    if (isFocusedRef.current && options.onPaste) e.preventDefault();
  });
  let onPaste = (0, $4vY0V$reactariautils.useEffectEvent)(e => {
    if (!isFocusedRef.current || !options.onPaste) return;
    e.preventDefault();
    let items = (0, $4620ae0dc40f0031$export$d9e760437831f8b3)(e.clipboardData);
    options.onPaste(items);
  });
  (0, $4vY0V$react.useEffect)(() => {
    return (0, $4vY0V$reactariautils.chain)($74f3dedaa4d234b4$var$addGlobalEventListener("beforecopy", onBeforeCopy), $74f3dedaa4d234b4$var$addGlobalEventListener("copy", onCopy), $74f3dedaa4d234b4$var$addGlobalEventListener("beforecut", onBeforeCut), $74f3dedaa4d234b4$var$addGlobalEventListener("cut", onCut), $74f3dedaa4d234b4$var$addGlobalEventListener("beforepaste", onBeforePaste), $74f3dedaa4d234b4$var$addGlobalEventListener("paste", onPaste));
  }, [onBeforeCopy, onCopy, onBeforeCut, onCut, onBeforePaste, onPaste]);
  return {
    clipboardProps: focusProps
  };
}

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $2dccaca1f4baa446$var$DragPreview(props, ref) {
  let render = props.children;
  let [children, setChildren] = (0, $4vY0V$react.useState)(null);
  let domRef = (0, $4vY0V$react.useRef)(null);
  (0, $4vY0V$react.useImperativeHandle)(ref, () => (items, callback) => {
    // This will be called during the onDragStart event by useDrag. We need to render the
    // preview synchronously before this event returns so we can call event.dataTransfer.setDragImage.
    (0, $4vY0V$reactdom.flushSync)(() => {
      setChildren(render(items));
    });
    // Yield back to useDrag to set the drag image.
    callback(domRef.current);
    // Remove the preview from the DOM after a frame so the browser has time to paint.
    requestAnimationFrame(() => {
      setChildren(null);
    });
  }, [render]);
  if (!children) return null;
  return /*#__PURE__*/(0, $parcel$interopDefault($4vY0V$react)).createElement("div", {
    style: {
      zIndex: -100,
      position: "absolute",
      top: 0,
      left: -100000
    },
    ref: domRef
  }, children);
}
let $2dccaca1f4baa446$export$905ab40ac2179daa = /*#__PURE__*/(0, $parcel$interopDefault($4vY0V$react)).forwardRef($2dccaca1f4baa446$var$DragPreview);
class $2268795bbb597ecb$export$fbd65d14c79e28cc {
  getPrimaryStart(rect) {
    return this.orientation === "horizontal" ? rect.left : rect.top;
  }
  getPrimaryEnd(rect) {
    return this.orientation === "horizontal" ? rect.right : rect.bottom;
  }
  getSecondaryStart(rect) {
    return this.orientation === "horizontal" ? rect.top : rect.left;
  }
  getSecondaryEnd(rect) {
    return this.orientation === "horizontal" ? rect.bottom : rect.right;
  }
  getFlowStart(rect) {
    return this.layout === "stack" ? this.getPrimaryStart(rect) : this.getSecondaryStart(rect);
  }
  getFlowEnd(rect) {
    return this.layout === "stack" ? this.getPrimaryEnd(rect) : this.getSecondaryEnd(rect);
  }
  getFlowSize(rect) {
    return this.getFlowEnd(rect) - this.getFlowStart(rect);
  }
  getDropTargetFromPoint(x, y, isValidDropTarget) {
    if (this.collection.size === 0) return {
      type: "root"
    };
    let rect = this.ref.current.getBoundingClientRect();
    let primary = this.orientation === "horizontal" ? x : y;
    let secondary = this.orientation === "horizontal" ? y : x;
    primary += this.getPrimaryStart(rect);
    secondary += this.getSecondaryStart(rect);
    let flow = this.layout === "stack" ? primary : secondary;
    let isPrimaryRTL = this.orientation === "horizontal" && this.direction === "rtl";
    let isSecondaryRTL = this.layout === "grid" && this.orientation === "vertical" && this.direction === "rtl";
    let isFlowRTL = this.layout === "stack" ? isPrimaryRTL : isSecondaryRTL;
    let elements = this.ref.current.querySelectorAll("[data-key]");
    let elementMap = new Map();
    for (let item of elements) if (item instanceof HTMLElement) elementMap.set(item.dataset.key, item);
    let items = [...this.collection];
    let low = 0;
    let high = items.length;
    while (low < high) {
      let mid = Math.floor((low + high) / 2);
      let item = items[mid];
      let element = elementMap.get(String(item.key));
      let rect = element.getBoundingClientRect();
      let update = isGreater => {
        if (isGreater) low = mid + 1;else high = mid;
      };
      if (primary < this.getPrimaryStart(rect)) update(isPrimaryRTL);else if (primary > this.getPrimaryEnd(rect)) update(!isPrimaryRTL);else if (secondary < this.getSecondaryStart(rect)) update(isSecondaryRTL);else if (secondary > this.getSecondaryEnd(rect)) update(!isSecondaryRTL);else {
        let target = {
          type: "item",
          key: item.key,
          dropPosition: "on"
        };
        if (isValidDropTarget(target)) {
          // Otherwise, if dropping on the item is accepted, try the before/after positions if within 5px
          // of the start or end of the item.
          if (flow <= this.getFlowStart(rect) + 5 && isValidDropTarget({
            ...target,
            dropPosition: "before"
          })) target.dropPosition = isFlowRTL ? "after" : "before";else if (flow >= this.getFlowEnd(rect) - 5 && isValidDropTarget({
            ...target,
            dropPosition: "after"
          })) target.dropPosition = isFlowRTL ? "before" : "after";
        } else {
          // If dropping on the item isn't accepted, try the target before or after depending on the position.
          let mid = this.getFlowStart(rect) + this.getFlowSize(rect) / 2;
          if (flow <= mid && isValidDropTarget({
            ...target,
            dropPosition: "before"
          })) target.dropPosition = isFlowRTL ? "after" : "before";else if (flow >= mid && isValidDropTarget({
            ...target,
            dropPosition: "after"
          })) target.dropPosition = isFlowRTL ? "before" : "after";
        }
        return target;
      }
    }
    let item = items[Math.min(low, items.length - 1)];
    let element = elementMap.get(String(item.key));
    rect = element.getBoundingClientRect();
    if (primary < this.getPrimaryStart(rect) || Math.abs(flow - this.getFlowStart(rect)) < Math.abs(flow - this.getFlowEnd(rect))) return {
      type: "item",
      key: item.key,
      dropPosition: isFlowRTL ? "after" : "before"
    };
    return {
      type: "item",
      key: item.key,
      dropPosition: isFlowRTL ? "before" : "after"
    };
  }
  constructor(collection, ref, options) {
    this.collection = collection;
    this.ref = ref;
    this.layout = (options === null || options === void 0 ? void 0 : options.layout) || "stack";
    this.orientation = (options === null || options === void 0 ? void 0 : options.orientation) || "vertical";
    this.direction = (options === null || options === void 0 ? void 0 : options.direction) || "ltr";
  }
}